"use strict";

Object.defineProperty(exports, "__esModule", {
  value: !0
});
var e,
  o = (e = require("deepmerge")) && "object" == typeof e && "default" in e ? e.default : e,
  r = require("@theme-ui/css/utils"),
  n = {
    primary70: "#A40917",
    primary60: "#C40D0E",
    primary50: "#E42313",
    primary40: "#EEAFAF",
    primary30: "#F4CACA",
    primary20: "#F9E4E4",
    primary10: "#FDF7F7",
    secondary70: "#474D66",
    secondary60: "#8F95B2",
    secondary50: "#D8DAE5",
    secondary40: "#EDEFF5",
    secondary30: "#F9FAFC",
    secondary20: "#FBFCFF",
    secondary10: "#FFFFFF",
    warning70: "#66460D",
    warning60: "#996A13",
    warning50: "#FFB020",
    warning40: "#FFD079",
    warning30: "#FFDFA6",
    warning20: "#FFEFD2",
    warning10: "#FFFAF1",
    success70: "#317159",
    success60: "#429777",
    success50: "#52BD94",
    success40: "#A3E6CD",
    success30: "#DCF2EA",
    success20: "#EEF8F4",
    success10: "#F5FBF8",
    error70: "#A74436",
    error60: "#BF2600",
    error50: "#FF5630",
    error40: "#FF7452",
    error30: "#FFBDAD",
    error20: "#FFEBE6",
    error10: "#FFF5F3",
    information70: "#1F3D99",
    information60: "#2952CC",
    information50: "#3366FF",
    information40: "#9DB5FF",
    information30: "#D6E0FF",
    information20: "#EBF0FF",
    information10: "#F3F6FF",
    grayscale100: "#151718",
    grayscale90: "#262829",
    grayscale80: "#2E3032",
    grayscale70: "#5C5E61",
    grayscale60: "#8C8F93",
    grayscale50: "#B1B5BA",
    grayscale40: "#C8CCD2",
    grayscale30: "#D9DDE3",
    grayscale20: "#F2F4F6",
    grayscale10: "#FFFFFF"
  },
  i = {
    spacing0: "1px",
    spacing1: "4px",
    spacing2: "0.5rem",
    spacing3: "0.75rem",
    spacing4: "1rem",
    spacing5: "1.25rem",
    spacing6: "1.5rem",
    spacing7: "1.75rem",
    spacing8: "2rem",
    spacing9: "2.25rem",
    spacing10: "2.5rem",
    spacing11: "3rem",
    spacing12: "3.5rem",
    spacing13: "4rem",
    spacing14: "5rem",
    spacing15: "6rem",
    spacing16: "7rem",
    spacing17: "8rem",
    spacing18: "9rem",
    spacing19: "10rem",
    spacing20: "11rem",
    spacing21: "12rem",
    spacing22: "13rem",
    spacing23: "14rem",
    spacing24: "15rem",
    spacing25: "16rem",
    spacing26: "18rem",
    spacing27: "20rem",
    spacing28: "24rem"
  },
  a = {
    primary25: "#eaf3f9",
    primary50: "#d6e7f4",
    primary100: "#c1dbee",
    primary200: "#accfe9",
    primary300: "#83b8de",
    primary400: "#59a0d3",
    primary500: "#3088c8",
    primary600: "#266da0",
    primary700: "#1d5278",
    primary800: "#133650",
    primary900: "#0a1b28",
    secondary25: "#fff8ec",
    secondary50: "#ffefd5",
    secondary100: "#fee7bf",
    secondary200: "#fdd692",
    secondary300: "#fdc464",
    secondary400: "#fcb337",
    secondary500: "#fba20a",
    secondary600: "#cf8508",
    secondary700: "#a36906",
    secondary800: "#774d05",
    secondary900: "#4b3003",
    tertiary25: "#f5f5f5",
    tertiary50: "#e6e6e6",
    tertiary100: "#d8d8d8",
    tertiary200: "#bcbcbc",
    tertiary300: "#9f9f9f",
    tertiary400: "#828282",
    tertiary500: "#666666",
    tertiary600: "#525252",
    tertiary700: "#3d3d3d",
    tertiary800: "#292929",
    tertiary900: "#141414",
    error25: "#fff6f4",
    error50: "#fce0dc",
    error100: "#f9cac3",
    error200: "#f39e92",
    error300: "#ec7262",
    error400: "#e64631",
    error500: "#e01a00",
    error600: "#b31500",
    error700: "#861000",
    error800: "#5a0a00",
    error900: "#2d0500",
    warning25: "#fffcf0",
    warning50: "#f3eed8",
    warning100: "#e7e0c1",
    warning200: "#cfc492",
    warning300: "#b6a862",
    warning400: "#9e8c33",
    warning500: "#867004",
    warning600: "#6b5a03",
    warning700: "#504302",
    warning800: "#362d02",
    warning900: "#1b1601",
    success25: "#f5fffa",
    success50: "#ddf4e9",
    success100: "#c5ead8",
    success200: "#95d4b6",
    success300: "#65bf93",
    success400: "#35a971",
    success500: "#05944f",
    success600: "#04763f",
    success700: "#03592f",
    success800: "#023b20",
    success900: "#011e10",
    information25: "#f2fafd",
    information50: "#ddeef4",
    information100: "#c8e2eb",
    information200: "#9dcbd9",
    information300: "#73b4c8",
    information400: "#489cb6",
    information500: "#1e84a4",
    information600: "#186a83",
    information700: "#125062",
    information800: "#0c3542",
    information900: "#061b21",
    buttonsLgPaddingLeftRight: "16px",
    buttonsLgPaddingTopBottom: "12px",
    buttonsSmPaddingLeftRight: "12px",
    buttonsSmPaddingTopBottom: "8px",
    buttonsPrimaryDefaultBackgroundColor: "#3088c8",
    buttonsPrimaryDefaultColor: "#ffffff",
    buttonsPrimaryHoverBackgroundColor: "#266da0",
    buttonsPrimaryHoverColor: "#ffffff",
    buttonsPrimaryActiveBackgroundColor: "#1d5278",
    buttonsPrimaryActiveColor: "#ffffff",
    buttonsPrimaryFocusBackgroundColors: "#3088c8",
    buttonsPrimaryFocusColor: "#ffffff",
    buttonsPrimaryFocusBorderColors: "#83b8de",
    buttonsPrimaryDisabledBackgroundColor: "#9f9f9f",
    buttonsPrimaryDisabledColor: "#666666",
    buttonsPrimaryBorderWidth: "0px",
    buttonsSecondaryDefaultBackgroundColor: "#d6e7f4",
    buttonsSecondaryDefaultColor: "#3088c8",
    buttonsSecondaryHoverBackgroundColor: "#c1dbee",
    buttonsSecondaryHoverColor: "#266da0",
    buttonsSecondaryActiveBackgroundColor: "#accfe9",
    buttonsSecondaryActiveColor: "#266da0",
    buttonsSecondaryFocusBackgroundColor: "#d6e7f4",
    buttonsSecondaryFocusColor: "#3088c8",
    buttonsSecondaryFocusBorderColors: "#3088c8",
    buttonsSecondaryDisabledBackgroundColor: "#e6e6e6",
    buttonsSecondaryDisabledColor: "#bcbcbc",
    buttonsSecondaryBorderWidth: "0px",
    buttonsBorderRadius: "16px",
    buttonsMdPaddingLeftRight: "12px",
    buttonsMdPaddingTopBottom: "8px",
    checkboxDefaultBackgroundColor: "#ffffff",
    checkboxDefaultBorder: "#bcbcbc",
    checkboxDisabledBackgroundColor: "#d8d8d8",
    checkboxDisabledBorder: "#9f9f9f",
    checkboxActiveDisableBackgroundColor: "#83b8de",
    checkboxActiveDisableColor: "#ffffff",
    checkboxActiveDisableBorder: "#3088c8",
    checkboxActiveBackgroundColor: "#3088c8",
    checkboxActiveColor: "#ffffff",
    checkboxActiveBorder: "#266da0",
    checkboxBorderRadius: "4px",
    checkboxBorderWidth: "1px",
    checkboxTextEnable: "#292929",
    checkboxTextDisable: "#828282",
    radioBorderWidth: "1px",
    radioDefaultBackgroundColor: "#ffffff",
    radioDefaultBorder: "#bcbcbc",
    radioDisableBackgroundColor: "#d8d8d8",
    radioDisableBorder: "#9f9f9f",
    radioActiveBackgroundColor: "#ffffff",
    radioActiveBorder: "#3088c8",
    radioActiveDisableBackgroundColor: "#ffffff",
    radioActiveDisableBorder: "#83b8de",
    radioTextEnable: "#292929",
    radioTextDisable: "#828282",
    anchorDefaultColor: "#3088c8",
    anchorHoverColor: "#266da0",
    anchorActiveColor: "#1d5278",
    anchorFocusColor: "#3088c8",
    anchorDisableColor: "#9f9f9f",
    switchActiveBackgroundColor: "#3088c8",
    switchActiveDisableBackgroundColor: "#accfe9",
    switchNonactiveBackgroundColor: "#9f9f9f",
    switchNonactiveDisableBackgroundColor: "#d8d8d8",
    textFieldDefaultBackgroundColor: "#ffffff",
    textFieldDefaultOutlineColor: "#bcbcbc",
    textFieldDefaultIconColor: "#292929",
    textFieldDefaultPlaceholderColor: "#828282",
    textFieldDefaultLabelColor: "#292929",
    textFieldActiveOutlineColor: "#59a0d3",
    textFieldActivePlaceholderColor: "#292929",
    textFieldActiveBorderColor: "#accfe9",
    textFieldErrorOutlineColor: "#e01a00",
    textFieldSuccessOutlineColor: "#05944f",
    textFieldDisableBackgroundColor: "#d8d8d8",
    textFieldDisableOutlineColor: "#9f9f9f",
    textFieldDisablePlaceholderColor: "#828282",
    textFieldPrefixsufixLineColor: "#9f9f9f",
    textFieldPrefixsufixTextColor: "#666666",
    textFieldBorderRadius: "4px",
    textFieldPaddingLeftRight: "12px",
    textFieldPaddingTopBottom: "12px",
    badgePrimaryBackgroundColor: "#3088c8",
    badgePrimaryColor: "#ffffff",
    badgeSecondaryBackgroundColor: "#c1dbee",
    badgeSecondaryColor: "#3088c8",
    badgeErrorBackgroundColor: "#f9cac3",
    badgeErrorColor: "#e01a00",
    badgeInfoBackgroundColor: "#c8e2eb",
    badgeInfoColor: "#1e84a4",
    badgeSuccessBackgroundColor: "#c5ead8",
    badgeSuccessColor: "#05944f",
    badgeWarningBackgroundColor: "#e7e0c1",
    badgeWarningColor: "#867004",
    badgeBorderRadius: "8px",
    baseWhite: "#ffffff",
    baseBlack: "#000000",
    sidebarNavlinkDefaultColor: "#666666",
    sidebarNavlinkDefaultBackgroundColor: "#ffffff",
    sidebarNavlinkHoverBackgroundColor: "#d6e7f4",
    sidebarNavlinkHoverColor: "#3088c8",
    sidebarNavlinkActiveBackgroundColor: "#d6e7f4",
    sidebarNavlinkActiveColor: "#3088c8",
    fontFamiliesPrimary: "Inter",
    fontFamiliesSecondary: "Inter",
    lineHeights0: "48px",
    lineHeights1: "42px",
    lineHeights2: "36px",
    lineHeights3: "32px",
    lineHeights4: "28px",
    lineHeights5: "26px",
    lineHeights6: "24px",
    lineHeights7: "21px",
    lineHeights8: "18px",
    lineHeights9: "16px",
    lineHeights10: "72px",
    lineHeights11: "56px",
    lineHeights12: "44px",
    lineHeights13: "40px",
    lineHeights14: "56px",
    lineHeights15: "72px",
    fontWeightsBold: "Bold",
    fontWeightsRegular: "Regular",
    fontWeightsSemiBold: "SemiBold",
    fontWeightsItalic: "Italic",
    fontSize0: "10px",
    fontSize1: "12px",
    fontSize2: "14px",
    fontSize3: "16px",
    fontSize4: "18px",
    fontSize5: "20px",
    fontSize6: "22px",
    fontSize7: "24px",
    fontSize8: "28px",
    fontSize9: "30px",
    fontSize10: "34px",
    fontSize11: "36px",
    fontSize12: "48px",
    fontSize13: "60px",
    letterSpacing0: "0px",
    letterSpacing1: "-0.08px",
    paragraphSpacing0: "0px",
    paragraphSpacing1: "18px",
    textCaseNone: "none",
    textCaseUppercase: "uppercase",
    textDecorationNone: "none",
    textDecorationUnderline: "underline",
    headingHeading1FontFamily: "Inter",
    headingHeading1FontWeight: "Bold",
    headingHeading1LineHeight: "72px",
    headingHeading1FontSize: "60px",
    headingHeading1LetterSpacing: "0px",
    headingHeading1ParagraphSpacing: "0px",
    headingHeading1TextCase: "none",
    headingHeading1TextDecoration: "none",
    headingHeading2FontFamily: "Inter",
    headingHeading2FontWeight: "Bold",
    headingHeading2LineHeight: "56px",
    headingHeading2FontSize: "48px",
    headingHeading2LetterSpacing: "0px",
    headingHeading2ParagraphSpacing: "0px",
    headingHeading2TextCase: "none",
    headingHeading2TextDecoration: "none",
    headingHeading3FontFamily: "Inter",
    headingHeading3FontWeight: "Bold",
    headingHeading3LineHeight: "44px",
    headingHeading3FontSize: "36px",
    headingHeading3LetterSpacing: "0px",
    headingHeading3ParagraphSpacing: "0px",
    headingHeading3TextCase: "none",
    headingHeading3TextDecoration: "none",
    headingHeading4FontFamily: "Inter",
    headingHeading4FontWeight: "Bold",
    headingHeading4LineHeight: "40px",
    headingHeading4FontSize: "30px",
    headingHeading4LetterSpacing: "0px",
    headingHeading4ParagraphSpacing: "0px",
    headingHeading4TextCase: "none",
    headingHeading4TextDecoration: "none",
    headingHeading5FontFamily: "Inter",
    headingHeading5FontWeight: "Bold",
    headingHeading5LineHeight: "36px",
    headingHeading5FontSize: "24px",
    headingHeading5LetterSpacing: "0px",
    headingHeading5ParagraphSpacing: "0px",
    headingHeading5TextCase: "none",
    headingHeading5TextDecoration: "none",
    headingHeading6FontFamily: "Inter",
    headingHeading6FontWeight: "Bold",
    headingHeading6LineHeight: "28px",
    headingHeading6FontSize: "20px",
    headingHeading6LetterSpacing: "0px",
    headingHeading6ParagraphSpacing: "0px",
    headingHeading6TextCase: "uppercase",
    headingHeading6TextDecoration: "none",
    bodyLargeRegularFontFamily: "Inter",
    bodyLargeRegularFontWeight: "Regular",
    bodyLargeRegularLineHeight: "28px",
    bodyLargeRegularFontSize: "18px",
    bodyLargeRegularLetterSpacing: "0px",
    bodyLargeRegularParagraphSpacing: "0px",
    bodyLargeRegularTextCase: "none",
    bodyLargeRegularTextDecoration: "none",
    bodyLargeSemiboldFontFamily: "Inter",
    bodyLargeSemiboldFontWeight: "SemiBold",
    bodyLargeSemiboldLineHeight: "28px",
    bodyLargeSemiboldFontSize: "18px",
    bodyLargeSemiboldLetterSpacing: "0px",
    bodyLargeSemiboldParagraphSpacing: "0px",
    bodyLargeSemiboldTextCase: "none",
    bodyLargeSemiboldTextDecoration: "none",
    bodyLargeBoldFontFamily: "Inter",
    bodyLargeBoldFontWeight: "Bold",
    bodyLargeBoldLineHeight: "28px",
    bodyLargeBoldFontSize: "18px",
    bodyLargeBoldLetterSpacing: "0px",
    bodyLargeBoldParagraphSpacing: "0px",
    bodyLargeBoldTextCase: "none",
    bodyLargeBoldTextDecoration: "none",
    bodyLargeItalicFontFamily: "Inter",
    bodyLargeItalicFontWeight: "Italic",
    bodyLargeItalicLineHeight: "28px",
    bodyLargeItalicFontSize: "18px",
    bodyLargeItalicLetterSpacing: "0px",
    bodyLargeItalicParagraphSpacing: "0px",
    bodyLargeItalicTextCase: "none",
    bodyLargeItalicTextDecoration: "none",
    bodyLargeUnderlineFontFamily: "Inter",
    bodyLargeUnderlineFontWeight: "Regular",
    bodyLargeUnderlineLineHeight: "28px",
    bodyLargeUnderlineFontSize: "18px",
    bodyLargeUnderlineLetterSpacing: "0px",
    bodyLargeUnderlineParagraphSpacing: "0px",
    bodyLargeUnderlineTextCase: "none",
    bodyLargeUnderlineTextDecoration: "underline",
    bodyLargeUnderlineSemiboldFontFamily: "Inter",
    bodyLargeUnderlineSemiboldFontWeight: "SemiBold",
    bodyLargeUnderlineSemiboldLineHeight: "28px",
    bodyLargeUnderlineSemiboldFontSize: "18px",
    bodyLargeUnderlineSemiboldLetterSpacing: "0px",
    bodyLargeUnderlineSemiboldParagraphSpacing: "0px",
    bodyLargeUnderlineSemiboldTextCase: "none",
    bodyLargeUnderlineSemiboldTextDecoration: "underline",
    bodyLargeUnderlineBoldFontFamily: "Inter",
    bodyLargeUnderlineBoldFontWeight: "Bold",
    bodyLargeUnderlineBoldLineHeight: "28px",
    bodyLargeUnderlineBoldFontSize: "18px",
    bodyLargeUnderlineBoldLetterSpacing: "0px",
    bodyLargeUnderlineBoldParagraphSpacing: "0px",
    bodyLargeUnderlineBoldTextCase: "none",
    bodyLargeUnderlineBoldTextDecoration: "underline",
    bodySmallRegularFontFamily: "Inter",
    bodySmallRegularFontWeight: "Regular",
    bodySmallRegularLineHeight: "24px",
    bodySmallRegularFontSize: "16px",
    bodySmallRegularLetterSpacing: "0px",
    bodySmallRegularParagraphSpacing: "0px",
    bodySmallRegularTextCase: "none",
    bodySmallRegularTextDecoration: "none",
    bodySmallSemiboldFontFamily: "Inter",
    bodySmallSemiboldFontWeight: "SemiBold",
    bodySmallSemiboldLineHeight: "24px",
    bodySmallSemiboldFontSize: "16px",
    bodySmallSemiboldLetterSpacing: "0px",
    bodySmallSemiboldParagraphSpacing: "0px",
    bodySmallSemiboldTextCase: "none",
    bodySmallSemiboldTextDecoration: "none",
    bodySmallBoldFontFamily: "Inter",
    bodySmallBoldFontWeight: "Bold",
    bodySmallBoldLineHeight: "24px",
    bodySmallBoldFontSize: "16px",
    bodySmallBoldLetterSpacing: "0px",
    bodySmallBoldParagraphSpacing: "0px",
    bodySmallBoldTextCase: "none",
    bodySmallBoldTextDecoration: "none",
    bodySmallItalicFontFamily: "Inter",
    bodySmallItalicFontWeight: "Italic",
    bodySmallItalicLineHeight: "24px",
    bodySmallItalicFontSize: "16px",
    bodySmallItalicLetterSpacing: "0px",
    bodySmallItalicParagraphSpacing: "0px",
    bodySmallItalicTextCase: "none",
    bodySmallItalicTextDecoration: "none",
    bodySmallUnderlineFontFamily: "Inter",
    bodySmallUnderlineFontWeight: "Regular",
    bodySmallUnderlineLineHeight: "24px",
    bodySmallUnderlineFontSize: "16px",
    bodySmallUnderlineLetterSpacing: "0px",
    bodySmallUnderlineParagraphSpacing: "18px",
    bodySmallUnderlineTextCase: "none",
    bodySmallUnderlineTextDecoration: "underline",
    bodySmallUnderlineSemiboldFontFamily: "Inter",
    bodySmallUnderlineSemiboldFontWeight: "SemiBold",
    bodySmallUnderlineSemiboldLineHeight: "24px",
    bodySmallUnderlineSemiboldFontSize: "16px",
    bodySmallUnderlineSemiboldLetterSpacing: "0px",
    bodySmallUnderlineSemiboldParagraphSpacing: "0px",
    bodySmallUnderlineSemiboldTextCase: "none",
    bodySmallUnderlineSemiboldTextDecoration: "underline",
    bodySmallUnderlineBoldFontFamily: "Inter",
    bodySmallUnderlineBoldFontWeight: "Bold",
    bodySmallUnderlineBoldLineHeight: "24px",
    bodySmallUnderlineBoldFontSize: "16px",
    bodySmallUnderlineBoldLetterSpacing: "-0.08px",
    bodySmallUnderlineBoldParagraphSpacing: "0px",
    bodySmallUnderlineBoldTextCase: "none",
    bodySmallUnderlineBoldTextDecoration: "underline",
    captionLargeRegularFontFamily: "Inter",
    captionLargeRegularFontWeight: "Regular",
    captionLargeRegularLineHeight: "21px",
    captionLargeRegularFontSize: "14px",
    captionLargeRegularLetterSpacing: "0px",
    captionLargeRegularParagraphSpacing: "0px",
    captionLargeRegularTextCase: "none",
    captionLargeRegularTextDecoration: "none",
    captionLargeSemiboldFontFamily: "Inter",
    captionLargeSemiboldFontWeight: "SemiBold",
    captionLargeSemiboldLineHeight: "21px",
    captionLargeSemiboldFontSize: "14px",
    captionLargeSemiboldLetterSpacing: "0px",
    captionLargeSemiboldParagraphSpacing: "0px",
    captionLargeSemiboldTextCase: "none",
    captionLargeSemiboldTextDecoration: "none",
    captionLargeBoldFontFamily: "Inter",
    captionLargeBoldFontWeight: "Bold",
    captionLargeBoldLineHeight: "21px",
    captionLargeBoldFontSize: "14px",
    captionLargeBoldLetterSpacing: "0px",
    captionLargeBoldParagraphSpacing: "0px",
    captionLargeBoldTextCase: "none",
    captionLargeBoldTextDecoration: "none",
    captionLargeItalicFontFamily: "Inter",
    captionLargeItalicFontWeight: "Italic",
    captionLargeItalicLineHeight: "21px",
    captionLargeItalicFontSize: "14px",
    captionLargeItalicLetterSpacing: "0px",
    captionLargeItalicParagraphSpacing: "0px",
    captionLargeItalicTextCase: "none",
    captionLargeItalicTextDecoration: "none",
    captionLargeUnderlineFontFamily: "Inter",
    captionLargeUnderlineFontWeight: "Regular",
    captionLargeUnderlineLineHeight: "21px",
    captionLargeUnderlineFontSize: "14px",
    captionLargeUnderlineLetterSpacing: "0px",
    captionLargeUnderlineParagraphSpacing: "0px",
    captionLargeUnderlineTextCase: "none",
    captionLargeUnderlineTextDecoration: "underline",
    captionLargeUnderlineSemiboldFontFamily: "Inter",
    captionLargeUnderlineSemiboldFontWeight: "SemiBold",
    captionLargeUnderlineSemiboldLineHeight: "21px",
    captionLargeUnderlineSemiboldFontSize: "14px",
    captionLargeUnderlineSemiboldLetterSpacing: "0px",
    captionLargeUnderlineSemiboldParagraphSpacing: "0px",
    captionLargeUnderlineSemiboldTextCase: "none",
    captionLargeUnderlineSemiboldTextDecoration: "underline",
    captionLargeUnderlineBoldFontFamily: "Inter",
    captionLargeUnderlineBoldFontWeight: "Bold",
    captionLargeUnderlineBoldLineHeight: "21px",
    captionLargeUnderlineBoldFontSize: "14px",
    captionLargeUnderlineBoldLetterSpacing: "0px",
    captionLargeUnderlineBoldParagraphSpacing: "0px",
    captionLargeUnderlineBoldTextCase: "none",
    captionLargeUnderlineBoldTextDecoration: "underline",
    captionSmallRegularFontFamily: "Inter",
    captionSmallRegularFontWeight: "Regular",
    captionSmallRegularLineHeight: "18px",
    captionSmallRegularFontSize: "12px",
    captionSmallRegularLetterSpacing: "0px",
    captionSmallRegularParagraphSpacing: "0px",
    captionSmallRegularTextCase: "none",
    captionSmallRegularTextDecoration: "none",
    captionSmallSemiboldFontFamily: "Inter",
    captionSmallSemiboldFontWeight: "SemiBold",
    captionSmallSemiboldLineHeight: "18px",
    captionSmallSemiboldFontSize: "12px",
    captionSmallSemiboldLetterSpacing: "0px",
    captionSmallSemiboldParagraphSpacing: "0px",
    captionSmallSemiboldTextCase: "none",
    captionSmallSemiboldTextDecoration: "none",
    captionSmallBoldFontFamily: "Inter",
    captionSmallBoldFontWeight: "Bold",
    captionSmallBoldLineHeight: "18px",
    captionSmallBoldFontSize: "12px",
    captionSmallBoldLetterSpacing: "0px",
    captionSmallBoldParagraphSpacing: "0px",
    captionSmallBoldTextCase: "none",
    captionSmallBoldTextDecoration: "none",
    captionSmallItalicFontFamily: "Inter",
    captionSmallItalicFontWeight: "Italic",
    captionSmallItalicLineHeight: "18px",
    captionSmallItalicFontSize: "12px",
    captionSmallItalicLetterSpacing: "0px",
    captionSmallItalicParagraphSpacing: "0px",
    captionSmallItalicTextCase: "none",
    captionSmallItalicTextDecoration: "none",
    captionSmallUnderlineFontFamily: "Inter",
    captionSmallUnderlineFontWeight: "Regular",
    captionSmallUnderlineLineHeight: "18px",
    captionSmallUnderlineFontSize: "12px",
    captionSmallUnderlineLetterSpacing: "0px",
    captionSmallUnderlineParagraphSpacing: "18px",
    captionSmallUnderlineTextCase: "none",
    captionSmallUnderlineTextDecoration: "underline",
    captionSmallUnderlineSemiboldFontFamily: "Inter",
    captionSmallUnderlineSemiboldFontWeight: "SemiBold",
    captionSmallUnderlineSemiboldLineHeight: "18px",
    captionSmallUnderlineSemiboldFontSize: "12px",
    captionSmallUnderlineSemiboldLetterSpacing: "0px",
    captionSmallUnderlineSemiboldParagraphSpacing: "0px",
    captionSmallUnderlineSemiboldTextCase: "none",
    captionSmallUnderlineSemiboldTextDecoration: "underline",
    captionSmallUnderlineBoldFontFamily: "Inter",
    captionSmallUnderlineBoldFontWeight: "Bold",
    captionSmallUnderlineBoldLineHeight: "18px",
    captionSmallUnderlineBoldFontSize: "12px",
    captionSmallUnderlineBoldLetterSpacing: "-0.08px",
    captionSmallUnderlineBoldParagraphSpacing: "0px",
    captionSmallUnderlineBoldTextCase: "none",
    captionSmallUnderlineBoldTextDecoration: "underline"
  },
  t = {
    body: {
      lg: {
        regular: {
          fontSize: "" + a.bodyLargeRegularFontSize,
          lineHeight: "" + a.bodyLargeRegularLineHeight,
          fontWeight: 400,
          fontFamily: "" + a.bodyLargeRegularFontFamily
        },
        semibold: {
          fontSize: "" + a.bodyLargeSemiboldFontSize,
          lineHeight: "" + a.bodyLargeSemiboldLineHeight,
          fontWeight: 600,
          fontFamily: "" + a.bodyLargeSemiboldFontFamily
        },
        bold: {
          fontSize: "" + a.bodyLargeBoldFontSize,
          lineHeight: "" + a.bodyLargeBoldLineHeight,
          fontWeight: 700,
          fontFamily: "" + a.bodyLargeBoldFontFamily
        },
        italic: {
          fontSize: "" + a.bodyLargeItalicFontSize,
          lineHeight: "" + a.bodyLargeItalicLineHeight,
          fontWeight: 400,
          fontStyle: "italic",
          fontFamily: "" + a.bodyLargeItalicFontFamily
        },
        underline: {
          fontSize: "" + a.bodyLargeUnderlineFontSize,
          lineHeight: "" + a.bodyLargeUnderlineLineHeight,
          fontWeight: 400,
          textDecoration: "underline",
          fontFamily: "" + a.bodyLargeUnderlineFontFamily
        },
        underline_semibold: {
          fontSize: "" + a.bodyLargeUnderlineSemiboldFontSize,
          lineHeight: "" + a.bodyLargeUnderlineSemiboldLineHeight,
          fontWeight: 600,
          textDecoration: "underline",
          fontFamily: "" + a.bodyLargeUnderlineSemiboldFontFamily
        },
        underline_bold: {
          fontSize: "" + a.bodyLargeUnderlineBoldFontSize,
          lineHeight: "" + a.bodyLargeUnderlineBoldLineHeight,
          fontWeight: 700,
          textDecoration: "underline",
          fontFamily: "" + a.bodyLargeUnderlineBoldFontFamily
        }
      },
      sm: {
        regular: {
          fontSize: "" + a.bodySmallRegularFontSize,
          lineHeight: "" + a.bodySmallRegularLineHeight,
          fontWeight: 400,
          fontFamily: "" + a.bodySmallRegularFontFamily
        },
        semibold: {
          fontSize: "" + a.bodySmallSemiboldFontSize,
          lineHeight: "" + a.bodySmallSemiboldLineHeight,
          fontWeight: 600,
          fontFamily: "" + a.bodySmallSemiboldFontFamily
        },
        bold: {
          fontSize: "" + a.bodySmallBoldFontSize,
          lineHeight: "" + a.bodySmallBoldLineHeight,
          fontWeight: 700,
          fontFamily: "" + a.bodySmallBoldFontFamily
        },
        italic: {
          fontSize: "" + a.bodySmallItalicFontSize,
          lineHeight: "" + a.bodySmallItalicLineHeight,
          fontWeight: 400,
          fontStyle: "italic",
          fontFamily: "" + a.bodySmallItalicFontFamily
        },
        underline: {
          fontSize: "" + a.bodySmallUnderlineFontSize,
          lineHeight: "" + a.bodySmallUnderlineLineHeight,
          fontWeight: 400,
          textDecoration: "underline",
          fontFamily: "" + a.bodySmallUnderlineFontFamily
        },
        underline_semibold: {
          fontSize: "" + a.bodySmallUnderlineSemiboldFontSize,
          lineHeight: "" + a.bodySmallUnderlineSemiboldLineHeight,
          fontWeight: 600,
          textDecoration: "underline",
          fontFamily: "" + a.bodySmallUnderlineSemiboldFontFamily
        },
        underline_bold: {
          fontSize: "" + a.bodySmallUnderlineBoldFontSize,
          lineHeight: "" + a.bodySmallUnderlineBoldLineHeight,
          fontWeight: 700,
          textDecoration: "underline",
          fontFamily: "" + a.bodySmallUnderlineBoldFontFamily
        }
      }
    },
    caption: {
      lg: {
        regular: {
          fontSize: "" + a.captionLargeRegularFontSize,
          lineHeight: "" + a.captionLargeRegularLineHeight,
          fontWeight: 400,
          fontFamily: "" + a.captionLargeRegularFontFamily
        },
        semibold: {
          fontSize: "" + a.captionLargeSemiboldFontSize,
          lineHeight: "" + a.captionLargeSemiboldLineHeight,
          fontWeight: 600,
          fontFamily: "" + a.captionLargeSemiboldFontFamily
        },
        bold: {
          fontSize: "" + a.captionLargeBoldFontSize,
          lineHeight: "" + a.captionLargeBoldLineHeight,
          fontWeight: 700,
          fontFamily: "" + a.captionLargeBoldFontFamily
        },
        italic: {
          fontSize: "" + a.captionLargeItalicFontSize,
          lineHeight: "" + a.captionLargeItalicLineHeight,
          fontWeight: 400,
          fontStyle: "italic",
          fontFamily: "" + a.captionLargeItalicFontFamily
        },
        underline: {
          fontSize: "" + a.captionLargeUnderlineFontSize,
          lineHeight: "" + a.captionLargeUnderlineLineHeight,
          fontWeight: 400,
          textDecoration: "underline",
          fontFamily: "" + a.captionLargeUnderlineFontFamily
        },
        underline_semibold: {
          fontSize: "" + a.captionLargeUnderlineSemiboldFontSize,
          lineHeight: "" + a.captionLargeUnderlineSemiboldLineHeight,
          fontWeight: 600,
          textDecoration: "underline",
          fontFamily: "" + a.captionLargeUnderlineSemiboldFontFamily
        },
        underline_bold: {
          fontSize: "" + a.captionLargeUnderlineBoldFontSize,
          lineHeight: "" + a.captionLargeUnderlineBoldLineHeight,
          fontWeight: 700,
          textDecoration: "underline",
          fontFamily: "" + a.captionLargeUnderlineBoldFontFamily
        }
      },
      sm: {
        regular: {
          fontSize: "" + a.captionSmallRegularFontSize,
          lineHeight: "" + a.captionSmallRegularLineHeight,
          fontWeight: 400,
          fontFamily: "" + a.captionSmallRegularFontFamily
        },
        semibold: {
          fontSize: "" + a.captionSmallSemiboldFontSize,
          lineHeight: "" + a.captionSmallSemiboldLineHeight,
          fontWeight: 600,
          fontFamily: "" + a.captionSmallSemiboldFontFamily
        },
        bold: {
          fontSize: "" + a.captionSmallBoldFontSize,
          lineHeight: "" + a.captionSmallBoldLineHeight,
          fontWeight: 700,
          fontFamily: "" + a.captionSmallBoldFontFamily
        },
        italic: {
          fontSize: "" + a.captionSmallItalicFontSize,
          lineHeight: "" + a.captionSmallItalicLineHeight,
          fontWeight: 400,
          fontStyle: "italic",
          fontFamily: "" + a.captionSmallItalicFontFamily
        },
        underline: {
          fontSize: "" + a.captionSmallUnderlineFontSize,
          lineHeight: "" + a.captionSmallUnderlineLineHeight,
          fontWeight: 400,
          textDecoration: "underline",
          fontFamily: "" + a.captionSmallUnderlineFontFamily
        },
        underline_semibold: {
          fontSize: "" + a.captionSmallUnderlineSemiboldFontSize,
          lineHeight: "" + a.captionSmallUnderlineSemiboldLineHeight,
          fontWeight: 600,
          textDecoration: "underline",
          fontFamily: "" + a.captionSmallUnderlineSemiboldFontFamily
        },
        underline_bold: {
          fontSize: "" + a.captionSmallUnderlineBoldFontSize,
          lineHeight: "" + a.captionSmallUnderlineBoldLineHeight,
          fontWeight: 700,
          textDecoration: "underline",
          fontFamily: "" + a.captionSmallUnderlineBoldFontFamily
        }
      }
    },
    heading: {
      h1: {
        fontSize: "" + a.headingHeading1FontSize,
        lineHeight: "" + a.headingHeading1LineHeight,
        fontWeight: 700,
        fontFamily: "" + a.headingHeading1FontFamily
      },
      h2: {
        fontSize: "" + a.headingHeading2FontSize,
        lineHeight: "" + a.headingHeading2LineHeight,
        fontWeight: 700,
        fontFamily: "" + a.headingHeading2FontFamily
      },
      h3: {
        fontSize: "" + a.headingHeading3FontSize,
        lineHeight: "" + a.headingHeading3LineHeight,
        fontWeight: 700,
        fontFamily: "" + a.headingHeading3FontFamily
      },
      h4: {
        fontSize: "" + a.headingHeading4FontSize,
        lineHeight: "" + a.headingHeading4LineHeight,
        fontWeight: 700,
        fontFamily: "" + a.headingHeading4FontFamily
      },
      h5: {
        fontSize: "" + a.headingHeading5FontSize,
        lineHeight: "" + a.headingHeading5LineHeight,
        fontWeight: 700,
        fontFamily: "" + a.headingHeading5FontFamily
      },
      h6: {
        fontSize: "" + a.headingHeading6FontSize,
        lineHeight: "" + a.headingHeading6LineHeight,
        fontWeight: 700,
        fontFamily: "" + a.headingHeading6FontFamily
      }
    }
  },
  l = {
    elevation0Color: "#ebf0ff",
    elevation0Type: "dropShadow",
    elevation0X: "0px",
    elevation0Y: "0px",
    elevation0Blur: "0px",
    elevation0Spread: "2px",
    elevation1Color: "#0000000d",
    elevation1Type: "dropShadow",
    elevation1X: "0px",
    elevation1Y: "1px",
    elevation1Blur: "0px",
    elevation1Spread: "0px",
    elevation20Color: "#00000040",
    elevation20Type: "dropShadow",
    elevation20X: "0px",
    elevation20Y: "0px",
    elevation20Blur: "1px",
    elevation20Spread: "0px",
    elevation21Color: "#0000000d",
    elevation21Type: "dropShadow",
    elevation21X: "0px",
    elevation21Y: "1px",
    elevation21Blur: "1px",
    elevation21Spread: "0px",
    elevation30Color: "#00000033",
    elevation30Type: "dropShadow",
    elevation30X: "0px",
    elevation30Y: "0px",
    elevation30Blur: "2px",
    elevation30Spread: "0px",
    elevation31Color: "#0000001a",
    elevation31Type: "dropShadow",
    elevation31X: "0px",
    elevation31Y: "2px",
    elevation31Blur: "10px",
    elevation31Spread: "0px",
    elevation40Color: "#0000001a",
    elevation40Type: "dropShadow",
    elevation40X: "0px",
    elevation40Y: "0px",
    elevation40Blur: "3px",
    elevation40Spread: "0px",
    elevation41Color: "#00000026",
    elevation41Type: "dropShadow",
    elevation41X: "0px",
    elevation41Y: "4px",
    elevation41Blur: "20px",
    elevation41Spread: "0px",
    elevation50Color: "#0000001a",
    elevation50Type: "dropShadow",
    elevation50X: "0px",
    elevation50Y: "0px",
    elevation50Blur: "4px",
    elevation50Spread: "0px",
    elevation51Color: "#00000033",
    elevation51Type: "dropShadow",
    elevation51X: "0px",
    elevation51Y: "8px",
    elevation51Blur: "40px",
    elevation51Spread: "0px",
    radius0: "0px",
    radius1: "2px",
    radius2: "4px",
    radius3: "6px",
    radius4: "8px",
    radius5: "16px",
    radius6: "32px",
    radius7: "500px",
    spacing1: "4px",
    spacing2: "8px",
    spacing3: "12px",
    spacing4: "16px",
    spacing5: "20px",
    spacing6: "24px",
    spacing7: "28px",
    spacing8: "32px",
    spacing9: "36px",
    spacing10: "40px",
    spacing11: "48px",
    spacing12: "56px",
    border1: "1px",
    border2: "2px",
    border0: "0px",
    size1: "8px",
    size2: "12px",
    size3: "16px",
    size4: "20px",
    size5: "24px",
    size6: "32px",
    size7: "40px",
    size8: "58px",
    size9: "64px",
    baseWhite: "#ffffff",
    baseBlack: "#000000",
    blue25: "#eaf3f9",
    blue50: "#d6e7f4",
    blue100: "#c1dbee",
    blue200: "#accfe9",
    blue300: "#83b8de",
    blue400: "#59a0d3",
    blue500: "#3088c8",
    blue600: "#266da0",
    blue700: "#1d5278",
    blue800: "#133650",
    blue900: "#0a1b28",
    yellow25: "#fff8ec",
    yellow50: "#ffefd5",
    yellow100: "#fee7bf",
    yellow200: "#fdd692",
    yellow300: "#fdc464",
    yellow400: "#fcb337",
    yellow500: "#fba20a",
    yellow600: "#cf8508",
    yellow700: "#a36906",
    yellow800: "#774d05",
    yellow900: "#4b3003",
    gray25: "#f5f5f5",
    gray50: "#e6e6e6",
    gray100: "#d8d8d8",
    gray200: "#bcbcbc",
    gray300: "#9f9f9f",
    gray400: "#828282",
    gray500: "#666666",
    gray600: "#525252",
    gray700: "#3d3d3d",
    gray800: "#292929",
    gray900: "#141414",
    masterError25: "#fff6f4",
    masterError50: "#fce0dc",
    masterError100: "#f9cac3",
    masterError200: "#f39e92",
    masterError300: "#ec7262",
    masterError400: "#e64631",
    masterError500: "#e01a00",
    masterError600: "#b31500",
    masterError700: "#861000",
    masterError800: "#5a0a00",
    masterError900: "#2d0500",
    masterWarning25: "#fffcf0",
    masterWarning50: "#f3eed8",
    masterWarning100: "#e7e0c1",
    masterWarning200: "#cfc492",
    masterWarning300: "#b6a862",
    masterWarning400: "#9e8c33",
    masterWarning500: "#867004",
    masterWarning600: "#6b5a03",
    masterWarning700: "#504302",
    masterWarning800: "#362d02",
    masterWarning900: "#1b1601",
    masterSuccess25: "#f5fffa",
    masterSuccess50: "#ddf4e9",
    masterSuccess100: "#c5ead8",
    masterSuccess200: "#95d4b6",
    masterSuccess300: "#65bf93",
    masterSuccess400: "#35a971",
    masterSuccess500: "#05944f",
    masterSuccess600: "#04763f",
    masterSuccess700: "#03592f",
    masterSuccess800: "#023b20",
    masterSuccess900: "#011e10",
    masterInformation25: "#f2fafd",
    masterInformation50: "#ddeef4",
    masterInformation100: "#c8e2eb",
    masterInformation200: "#9dcbd9",
    masterInformation300: "#73b4c8",
    masterInformation400: "#489cb6",
    masterInformation500: "#1e84a4",
    masterInformation600: "#186a83",
    masterInformation700: "#125062",
    masterInformation800: "#0c3542",
    masterInformation900: "#061b21"
  },
  d = function (e) {
    return {
      width: "100%",
      '&> input[type="checkbox"]': {
        position: "absolute",
        left: "-100vw",
        "&:checked ~ .content": {
          height: "auto",
          overflow: "visible",
          borderBottom: "1px solid " + e.tertiary300,
          padding: e.spacing3,
          borderTop: 0
        },
        "&:checked ~ label": {
          borderBottom: "none",
          ".toggle-up": {
            display: "inline-block !important"
          },
          ".toggle-down": {
            display: "none !important"
          }
        },
        "&:checked ~ label + .content": {
          opacity: 1,
          transition: ".3s",
          height: "auto",
          "&.menu-content > div": {
            display: "block"
          }
        }
      },
      label: {
        display: "block",
        color: e.tertiary800,
        cursor: "pointer",
        padding: e.spacing3,
        background: "#FFF",
        fontSize: "16px",
        borderBottom: "1px solid " + e.tertiary300,
        position: "relative",
        "&.menu-label": {
          fontWeight: "bold",
          fontSize: "14px !important",
          borderBottom: "0 !important",
          "&.is-menu:hover, &.is-menu-active": {
            background: "" + e.primary50,
            cursor: "pointer",
            borderLeft: "3px solid " + e.primary500
          }
        },
        "> svg": {
          marginRight: e.spacing3,
          fontSize: "16px",
          fontWeight: "bold",
          lineHeight: "28px",
          verticalAlign: "middle",
          position: "absolute",
          right: "-8px",
          top: "14px",
          "&.toggle-down": {
            display: "inline-block"
          },
          "&.toggle-up": {
            display: "none"
          }
        },
        ".left-icon": {
          marginRight: e.spacing2,
          position: "relative",
          top: "2px"
        },
        ".right-icon": {
          marginRight: e.spacing2,
          position: "absolute",
          right: "12px"
        }
      },
      ".content": {
        opacity: 0,
        transition: ".3s",
        height: 0,
        background: "#FFF",
        "&.menu-content": {
          padding: "0 " + e.spacing3 + " !important",
          borderBottom: "0 !important",
          "&> div": {
            display: "none"
          }
        }
      }
    };
  },
  c = function (e) {
    return {
      outerWrapper: {
        width: "100%",
        paddingTop: e.spacing2,
        paddingBottom: e.spacing2
      },
      iconWrapper: {
        borderRadius: e.radius7,
        width: 24,
        height: 24
      },
      titleMargin: {
        marginRight: e.spacing3
      },
      descMargin: {
        marginLeft: "35px"
      },
      info: {
        bg: e.information25,
        border: "1px solid " + e.information500
      },
      success: {
        bg: e.success25,
        border: "1px solid " + e.success500
      },
      error: {
        bg: e.error25,
        border: "1px solid " + e.error500
      },
      warning: {
        bg: e.warning25,
        border: "1px solid " + e.warning500
      },
      infoIcon: {
        bg: e.information500
      },
      successIcon: {
        bg: e.success500
      },
      errorIcon: {
        bg: e.error500
      },
      warningIcon: {
        bg: e.warning500
      },
      title: {
        fontSize: 16,
        fontWeight: 700,
        color: e.tertiary800
      },
      desc: {
        fontSize: 12,
        fontWeight: 400,
        color: e.tertiary500
      },
      close: {
        width: 28,
        height: 28,
        color: e.tertiary800,
        cursor: "pointer"
      }
    };
  };
function p() {
  return (p = Object.assign ? Object.assign.bind() : function (e) {
    for (var o = 1; o < arguments.length; o++) {
      var r = arguments[o];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }).apply(this, arguments);
}
var g = function (e) {
    return {
      primary: {
        bg: "" + e.badgePrimaryBackgroundColor,
        color: e.badgePrimaryColor
      },
      secondary: {
        bg: "" + e.badgeSecondaryBackgroundColor,
        color: e.badgeSecondaryColor
      },
      error: {
        bg: "" + e.badgeErrorBackgroundColor,
        color: e.badgeErrorColor
      },
      info: {
        bg: "" + e.badgeInfoBackgroundColor,
        color: e.badgeInfoColor
      },
      success: {
        bg: "" + e.badgeSuccessBackgroundColor,
        color: e.badgeSuccessColor
      },
      warning: {
        bg: "" + e.badgeWarningBackgroundColor,
        color: e.badgeWarningColor
      },
      small: p({
        width: 8,
        height: 8,
        borderRadius: 4
      }, t.body.sm.regular),
      smallWithBorder: p({
        border: "1px solid white",
        height: 10,
        borderRadius: 5
      }, t.body.sm.regular),
      largeWithBorder: p({
        border: "2px solid white"
      }, t.body.lg.regular),
      smallWithContent: p({
        display: "inline-flex",
        alignItems: "center",
        height: 21,
        borderRadius: 24,
        paddingX: "7px"
      }, t.body.sm.regular),
      largeWithContent: p({
        display: "inline-flex",
        alignItems: "center",
        height: 28,
        borderRadius: e.badgeBorderRadius,
        paddingX: "14px"
      }, t.body.lg.regular),
      large: p({
        width: 12,
        height: 12,
        borderRadius: 6
      }, t.body.lg.regular)
    };
  },
  s = function (e) {
    return {
      sm: p({
        minWidth: "32px",
        minHeight: "32px",
        padding: "5px 7px !important"
      }, t.caption.lg.semibold, {
        lineHeight: "20px"
      }),
      md: p({
        minWidth: "40px",
        minHeight: "40px",
        padding: "7px 11px !important"
      }, t.body.sm.semibold, {
        lineHeight: "24px"
      }),
      lg: p({
        minWidth: "56px",
        minHeight: "56px",
        padding: "13px 15px !important"
      }, t.body.sm.semibold, {
        lineHeight: "28px"
      }),
      solid: {
        alignItems: "center",
        borderRadius: "" + e.buttonsBorderRadius,
        cursor: "pointer",
        display: "flex",
        lineHeight: "21px",
        fontWeight: "700",
        justifyContent: "center",
        "& .wrapper-icon-left-large": {
          display: "flex",
          width: "20px",
          height: "20px",
          alignItems: "center"
        },
        "& .wrapper-icon-left-medium": {
          display: "flex",
          width: "16px",
          height: "16px",
          alignItems: "center"
        },
        "& .wrapper-icon-left-small": {
          display: "flex",
          width: "12px",
          height: "12px",
          alignItems: "center"
        },
        "& .wrapper-icon-both-children": {
          marginLeft: "10px",
          marginRight: "10px"
        },
        "& .wrapper-icon-left-children": {
          marginLeft: "10px"
        },
        "& .wrapper-icon-right-children": {
          marginRight: "10px"
        },
        "& .wrapper-two-icon": {
          marginRight: "10px"
        },
        "& .wrapperIconLeft": {
          marginRight: 10
        },
        "& .wrapperIconRight": {
          marginLeft: 10
        },
        "& .wrapper-icon-right-large": {
          display: "flex",
          width: "20px",
          height: "20px",
          alignItems: "center"
        },
        "& .wrapper-icon-right-medium": {
          display: "flex",
          width: "16px",
          height: "16px",
          alignItems: "center"
        },
        "& .wrapper-icon-right-small": {
          display: "flex",
          width: "12px",
          height: "12px",
          alignItems: "center"
        },
        primary: {
          backgroundColor: e.primary500,
          color: "#ffffff",
          "&:hover": {
            backgroundColor: e.primary600,
            boxShadow: "none !important"
          },
          "&:focus": {
            boxShadow: "inset 0px 0px 0px 2px " + e.primary400 + " !important"
          },
          "&:active": {
            backgroundColor: e.primary700 + " !important",
            border: "none",
            boxShadow: "none !important"
          },
          "&:disabled": {
            cursor: "unset !important",
            backgroundColor: e.tertiary300 + " !important",
            color: e.tertiary500 + " !important"
          }
        },
        secondary: {
          backgroundColor: e.secondary500,
          color: "#ffffff",
          "&:hover": {
            backgroundColor: e.secondary600,
            boxShadow: "none !important"
          },
          "&:focus": {
            boxShadow: "inset 0px 0px 0px 2px " + e.secondary400 + " !important"
          },
          "&:active": {
            backgroundColor: e.secondary700 + " !important",
            border: "none",
            boxShadow: "none !important"
          },
          "&:disabled": {
            cursor: "unset !important",
            backgroundColor: e.tertiary300 + " !important",
            color: e.tertiary500 + " !important"
          }
        },
        tertiary: {
          backgroundColor: e.tertiary500,
          color: "#ffffff",
          "&:hover": {
            backgroundColor: e.tertiary600,
            boxShadow: "none !important"
          },
          "&:focus": {
            boxShadow: "inset 0px 0px 0px 2px " + e.tertiary400 + " !important"
          },
          "&:active": {
            backgroundColor: e.tertiary700 + " !important",
            border: "none",
            boxShadow: "none !important"
          },
          "&:disabled": {
            cursor: "unset !important",
            backgroundColor: e.tertiary300 + " !important",
            color: e.tertiary500 + " !important"
          }
        },
        success: {
          backgroundColor: e.success500,
          color: "#ffffff",
          "&:hover": {
            backgroundColor: e.success600,
            boxShadow: "none !important"
          },
          "&:focus": {
            boxShadow: "inset 0px 0px 0px 2px " + e.success400 + " !important"
          },
          "&:active": {
            backgroundColor: e.success700 + " !important",
            border: "none",
            boxShadow: "none !important"
          },
          "&:disabled": {
            cursor: "unset !important",
            backgroundColor: e.tertiary300 + " !important",
            color: e.tertiary500 + " !important"
          }
        },
        warning: {
          backgroundColor: e.warning500,
          color: "#ffffff",
          "&:hover": {
            backgroundColor: e.warning600,
            boxShadow: "none !important"
          },
          "&:focus": {
            boxShadow: "inset 0px 0px 0px 2px " + e.warning400 + " !important"
          },
          "&:active": {
            backgroundColor: e.warning700 + " !important",
            border: "none",
            boxShadow: "none !important"
          },
          "&:disabled": {
            cursor: "unset !important",
            backgroundColor: e.tertiary300 + " !important",
            color: e.tertiary500 + " !important"
          }
        },
        info: {
          backgroundColor: e.information500,
          color: "#ffffff",
          "&:hover": {
            backgroundColor: e.information600,
            boxShadow: "none !important"
          },
          "&:focus": {
            boxShadow: "inset 0px 0px 0px 2px " + e.information400 + " !important"
          },
          "&:active": {
            backgroundColor: e.information700 + " !important",
            border: "none",
            boxShadow: "none !important"
          },
          "&:disabled": {
            cursor: "unset !important",
            backgroundColor: e.tertiary300 + " !important",
            color: e.tertiary500 + " !important"
          }
        },
        error: {
          backgroundColor: e.error500,
          color: "#ffffff",
          "&:hover": {
            backgroundColor: e.error600,
            boxShadow: "none !important"
          },
          "&:focus": {
            boxShadow: "inset 0px 0px 0px 2px " + e.error400 + " !important"
          },
          "&:active": {
            backgroundColor: e.error700 + " !important",
            border: "none",
            boxShadow: "none !important"
          },
          "&:disabled": {
            cursor: "unset !important",
            backgroundColor: e.tertiary300 + " !important",
            color: e.tertiary500 + " !important"
          }
        }
      },
      soft: {
        alignItems: "center",
        borderRadius: "" + e.buttonsBorderRadius,
        cursor: "pointer",
        display: "flex",
        lineHeight: "21px",
        fontWeight: "700",
        justifyContent: "center",
        "& .wrapper-icon-left-large": {
          display: "flex",
          width: "20px",
          height: "20px",
          alignItems: "center"
        },
        "& .wrapper-icon-left-medium": {
          display: "flex",
          width: "16px",
          height: "16px",
          alignItems: "center"
        },
        "& .wrapper-icon-left-small": {
          display: "flex",
          width: "12px",
          height: "12px",
          alignItems: "center"
        },
        "& .wrapper-icon-both-children": {
          marginLeft: "10px",
          marginRight: "10px"
        },
        "& .wrapper-icon-left-children": {
          marginLeft: "10px"
        },
        "& .wrapper-icon-right-children": {
          marginRight: "10px"
        },
        "& .wrapper-two-icon": {
          marginRight: "10px"
        },
        "& .wrapperIconLeft": {
          marginRight: 10
        },
        "& .wrapperIconRight": {
          marginLeft: 10
        },
        "& .wrapper-icon-right-large": {
          display: "flex",
          width: "20px",
          height: "20px",
          alignItems: "center"
        },
        "& .wrapper-icon-right-medium": {
          display: "flex",
          width: "16px",
          height: "16px",
          alignItems: "center"
        },
        "& .wrapper-icon-right-small": {
          display: "flex",
          width: "12px",
          height: "12px",
          alignItems: "center"
        },
        primary: {
          backgroundColor: e.primary50,
          color: e.primary500,
          "&:hover": {
            backgroundColor: e.primary200,
            boxShadow: "none",
            color: e.primary600
          },
          "&:focus": {
            backgroundColor: e.primary50,
            boxShadow: "inset 0px 0px 0px 2px " + e.primary400 + " !important",
            color: e.primary500
          },
          "&:active": {
            backgroundColor: e.primary300,
            border: "none",
            boxShadow: "none !important",
            color: e.primary700
          },
          "&:disabled": {
            appearance: "none",
            backgroundColor: e.tertiary200,
            border: "none",
            color: e.tertiary500,
            cursor: "unset"
          }
        },
        secondary: {
          backgroundColor: e.secondary50,
          color: e.secondary500,
          "&:hover": {
            backgroundColor: e.secondary200,
            boxShadow: "none",
            color: e.secondary600
          },
          "&:focus": {
            backgroundColor: e.secondary50,
            boxShadow: "inset 0px 0px 0px 2px " + e.secondary400 + " !important",
            color: e.secondary500
          },
          "&:active": {
            backgroundColor: e.secondary300,
            border: "none",
            boxShadow: "none !important",
            color: e.secondary700
          },
          "&:disabled": {
            appearance: "none",
            backgroundColor: e.tertiary200,
            border: "none",
            color: e.tertiary500,
            cursor: "unset"
          }
        },
        tertiary: {
          backgroundColor: e.tertiary50,
          color: e.tertiary500,
          "&:hover": {
            backgroundColor: e.tertiary200,
            boxShadow: "none",
            color: e.tertiary600
          },
          "&:focus": {
            backgroundColor: e.tertiary50,
            boxShadow: "inset 0px 0px 0px 2px " + e.tertiary400 + " !important",
            color: e.tertiary500
          },
          "&:active": {
            backgroundColor: e.tertiary300,
            border: "none",
            boxShadow: "none !important",
            color: e.tertiary700
          },
          "&:disabled": {
            appearance: "none",
            backgroundColor: e.tertiary200,
            border: "none",
            color: e.tertiary500,
            cursor: "unset"
          }
        },
        success: {
          backgroundColor: e.success50,
          color: e.success500,
          "&:hover": {
            backgroundColor: e.success200,
            boxShadow: "none",
            color: e.success600
          },
          "&:focus": {
            backgroundColor: e.success50,
            boxShadow: "inset 0px 0px 0px 2px " + e.success400 + " !important",
            color: e.success500
          },
          "&:active": {
            backgroundColor: e.success300,
            border: "none",
            boxShadow: "none !important",
            color: e.success700
          },
          "&:disabled": {
            appearance: "none",
            backgroundColor: e.tertiary200,
            border: "none",
            color: e.tertiary500,
            cursor: "unset"
          }
        },
        warning: {
          backgroundColor: e.warning50,
          color: e.warning500,
          "&:hover": {
            backgroundColor: e.warning200,
            boxShadow: "none",
            color: e.warning600
          },
          "&:focus": {
            backgroundColor: e.warning50,
            boxShadow: "inset 0px 0px 0px 2px " + e.warning400 + " !important",
            color: e.warning500
          },
          "&:active": {
            backgroundColor: e.warning300,
            border: "none",
            boxShadow: "none !important",
            color: e.warning700
          },
          "&:disabled": {
            appearance: "none",
            backgroundColor: e.tertiary200,
            border: "none",
            color: e.tertiary500,
            cursor: "unset"
          }
        },
        info: {
          backgroundColor: e.information50,
          color: e.information500,
          "&:hover": {
            backgroundColor: e.information200,
            boxShadow: "none",
            color: e.information600
          },
          "&:focus": {
            backgroundColor: e.information50,
            boxShadow: "inset 0px 0px 0px 2px " + e.information400 + " !important",
            color: e.information500
          },
          "&:active": {
            backgroundColor: e.information300,
            border: "none",
            boxShadow: "none !important",
            color: e.information700
          },
          "&:disabled": {
            appearance: "none",
            backgroundColor: e.tertiary200,
            border: "none",
            color: e.tertiary500,
            cursor: "unset"
          }
        },
        error: {
          backgroundColor: e.error50,
          color: e.error500,
          "&:hover": {
            backgroundColor: e.error200,
            boxShadow: "none",
            color: e.error600
          },
          "&:focus": {
            backgroundColor: e.error50,
            boxShadow: "inset 0px 0px 0px 2px " + e.error400 + " !important",
            color: e.error500
          },
          "&:active": {
            backgroundColor: e.error300,
            border: "none",
            boxShadow: "none !important",
            color: e.error700
          },
          "&:disabled": {
            appearance: "none",
            backgroundColor: e.tertiary200,
            border: "none",
            color: e.tertiary500,
            cursor: "unset"
          }
        }
      },
      outline: {
        alignItems: "center",
        borderRadius: "" + e.buttonsBorderRadius,
        cursor: "pointer",
        display: "flex",
        lineHeight: "21px",
        fontWeight: "700",
        justifyContent: "center",
        "& .wrapper-icon-left-large": {
          display: "flex",
          width: "20px",
          height: "20px",
          alignItems: "center"
        },
        "& .wrapper-icon-left-medium": {
          display: "flex",
          width: "16px",
          height: "16px",
          alignItems: "center"
        },
        "& .wrapper-icon-left-small": {
          display: "flex",
          width: "12px",
          height: "12px",
          alignItems: "center"
        },
        "& .wrapper-icon-both-children": {
          marginLeft: "10px",
          marginRight: "10px"
        },
        "& .wrapper-icon-left-children": {
          marginLeft: "10px"
        },
        "& .wrapper-icon-right-children": {
          marginRight: "10px"
        },
        "& .wrapper-two-icon": {
          marginRight: "10px"
        },
        "& .wrapperIconLeft": {
          marginRight: 10
        },
        "& .wrapperIconRight": {
          marginLeft: 10
        },
        "& .wrapper-icon-right-large": {
          display: "flex",
          width: "20px",
          height: "20px",
          alignItems: "center"
        },
        "& .wrapper-icon-right-medium": {
          display: "flex",
          width: "16px",
          height: "16px",
          alignItems: "center"
        },
        "& .wrapper-icon-right-small": {
          display: "flex",
          width: "12px",
          height: "12px",
          alignItems: "center"
        },
        primary: {
          backgroundColor: e.primary50,
          border: "2px solid " + e.primary500,
          color: e.primary500,
          "&:hover": {
            backgroundColor: e.primary100,
            border: "2px solid " + e.primary600,
            color: e.primary600,
            boxShadow: "none !important"
          },
          "&:active": {
            backgroundColor: e.primary200,
            border: "2px solid " + e.primary700,
            color: e.primary700,
            boxShadow: "none !important"
          },
          "&:focus": {
            backgroundColor: e.primary100,
            boxShadow: "0px 0px 0px 2px " + e.primary400
          },
          "&:disabled": {
            cursor: "unset",
            appearance: "none",
            backgroundColor: e.tertiary200 + " !important",
            border: "none",
            color: e.tertiary500 + " !important"
          }
        },
        secondary: {
          backgroundColor: e.secondary50,
          border: "2px solid " + e.secondary500,
          color: e.secondary500,
          "&:hover": {
            backgroundColor: e.secondary100,
            border: "2px solid " + e.secondary600,
            color: e.secondary600,
            boxShadow: "none !important"
          },
          "&:active": {
            backgroundColor: e.secondary200,
            border: "2px solid " + e.secondary700,
            color: e.secondary700,
            boxShadow: "none !important"
          },
          "&:focus": {
            backgroundColor: e.secondary100,
            boxShadow: "0px 0px 0px 2px " + e.secondary400
          },
          "&:disabled": {
            cursor: "unset",
            appearance: "none",
            backgroundColor: e.tertiary200 + " !important",
            border: "none",
            color: e.tertiary500 + " !important"
          }
        },
        tertiary: {
          backgroundColor: e.tertiary50,
          border: "2px solid " + e.tertiary500,
          color: e.tertiary500,
          "&:hover": {
            backgroundColor: e.tertiary100,
            border: "2px solid " + e.tertiary600,
            color: e.tertiary600,
            boxShadow: "none !important"
          },
          "&:active": {
            backgroundColor: e.tertiary200,
            border: "2px solid " + e.tertiary700,
            color: e.tertiary700,
            boxShadow: "none !important"
          },
          "&:focus": {
            backgroundColor: e.tertiary100,
            boxShadow: "0px 0px 0px 2px " + e.tertiary400
          },
          "&:disabled": {
            cursor: "unset",
            appearance: "none",
            backgroundColor: e.tertiary200 + " !important",
            border: "none",
            color: e.tertiary500 + " !important"
          }
        },
        success: {
          backgroundColor: e.success50,
          border: "2px solid " + e.success500,
          color: e.success500,
          "&:hover": {
            backgroundColor: e.success100,
            border: "2px solid " + e.success600,
            color: e.success600,
            boxShadow: "none !important"
          },
          "&:active": {
            backgroundColor: e.success200,
            border: "2px solid " + e.success700,
            color: e.success700,
            boxShadow: "none !important"
          },
          "&:focus": {
            backgroundColor: e.success100,
            boxShadow: "0px 0px 0px 2px " + e.success400
          },
          "&:disabled": {
            cursor: "unset",
            appearance: "none",
            backgroundColor: e.tertiary200 + " !important",
            border: "none",
            color: e.tertiary500 + " !important"
          }
        },
        warning: {
          backgroundColor: e.warning50,
          border: "2px solid " + e.warning500,
          color: e.warning500,
          "&:hover": {
            backgroundColor: e.warning100,
            border: "2px solid " + e.warning600,
            color: e.warning600,
            boxShadow: "none !important"
          },
          "&:active": {
            backgroundColor: e.warning200,
            border: "2px solid " + e.warning700,
            color: e.warning700,
            boxShadow: "none !important"
          },
          "&:focus": {
            backgroundColor: e.warning100,
            boxShadow: "0px 0px 0px 2px " + e.warning400
          },
          "&:disabled": {
            cursor: "unset",
            appearance: "none",
            backgroundColor: e.tertiary200 + " !important",
            border: "none",
            color: e.tertiary500 + " !important"
          }
        },
        info: {
          backgroundColor: e.information50,
          border: "2px solid " + e.information500,
          color: e.information500,
          "&:hover": {
            backgroundColor: e.information100,
            border: "2px solid " + e.information600,
            color: e.information600,
            boxShadow: "none !important"
          },
          "&:active": {
            backgroundColor: e.information200,
            border: "2px solid " + e.information700,
            color: e.information700,
            boxShadow: "none !important"
          },
          "&:focus": {
            backgroundColor: e.information100,
            boxShadow: "0px 0px 0px 2px " + e.information400
          },
          "&:disabled": {
            cursor: "unset",
            appearance: "none",
            backgroundColor: e.tertiary200 + " !important",
            border: "none",
            color: e.tertiary500 + " !important"
          }
        },
        error: {
          backgroundColor: e.error50,
          border: "2px solid " + e.error500,
          color: e.error500,
          "&:hover": {
            backgroundColor: e.error100,
            border: "2px solid " + e.error600,
            color: e.error600,
            boxShadow: "none !important"
          },
          "&:active": {
            backgroundColor: e.error200,
            border: "2px solid " + e.error700,
            color: e.error700,
            boxShadow: "none !important"
          },
          "&:focus": {
            backgroundColor: e.error100,
            boxShadow: "0px 0px 0px 2px " + e.error400
          },
          "&:disabled": {
            cursor: "unset",
            appearance: "none",
            backgroundColor: e.tertiary200 + " !important",
            border: "none",
            color: e.tertiary500 + " !important"
          }
        }
      },
      transparent: {
        alignItems: "center",
        borderRadius: "" + e.buttonsBorderRadius,
        cursor: "pointer",
        display: "flex",
        lineHeight: "21px",
        fontWeight: "700",
        justifyContent: "center",
        "& .wrapper-icon-left-large": {
          display: "flex",
          width: "20px",
          height: "20px",
          alignItems: "center"
        },
        "& .wrapper-icon-left-medium": {
          display: "flex",
          width: "16px",
          height: "16px",
          alignItems: "center"
        },
        "& .wrapper-icon-left-small": {
          display: "flex",
          width: "12px",
          height: "12px",
          alignItems: "center"
        },
        "& .wrapper-icon-both-children": {
          marginLeft: "10px",
          marginRight: "10px"
        },
        "& .wrapper-icon-left-children": {
          marginLeft: "10px"
        },
        "& .wrapper-icon-right-children": {
          marginRight: "10px"
        },
        "& .wrapper-two-icon": {
          marginRight: "10px"
        },
        "& .wrapperIconLeft": {
          marginRight: 10
        },
        "& .wrapperIconRight": {
          marginLeft: 10
        },
        "& .wrapper-icon-right-large": {
          display: "flex",
          width: "20px",
          height: "20px",
          alignItems: "center"
        },
        "& .wrapper-icon-right-medium": {
          display: "flex",
          width: "16px",
          height: "16px",
          alignItems: "center"
        },
        "& .wrapper-icon-right-small": {
          display: "flex",
          width: "12px",
          height: "12px",
          alignItems: "center"
        },
        primary: {
          backgroundColor: "transparent",
          color: e.primary500,
          "&:hover": {
            backgroundColor: e.primary100,
            color: e.primary600,
            boxShadow: "none"
          },
          "&:focus": {
            backgroundColor: e.primary25,
            boxShadow: "inset 0px 0px 0px 2px " + e.primary400 + " !important",
            color: e.primary500
          },
          "&:active": {
            backgroundColor: e.primary100,
            border: "none",
            color: e.primary700,
            boxShadow: "none"
          },
          "&:disabled": {
            cursor: "unset",
            appearance: "none",
            backgroundColor: "transparent",
            border: "none",
            color: e.tertiary400
          }
        },
        secondary: {
          backgroundColor: "transparent",
          color: e.secondary500,
          "&:hover": {
            backgroundColor: e.secondary100,
            color: e.secondary600,
            boxShadow: "none"
          },
          "&:focus": {
            backgroundColor: e.secondary25,
            boxShadow: "inset 0px 0px 0px 2px " + e.secondary400 + " !important",
            color: e.secondary500
          },
          "&:active": {
            backgroundColor: e.secondary100,
            border: "none",
            color: e.secondary700,
            boxShadow: "none"
          },
          "&:disabled": {
            cursor: "unset",
            appearance: "none",
            backgroundColor: "transparent",
            border: "none",
            color: e.tertiary400
          }
        },
        tertiary: {
          backgroundColor: "transparent",
          color: e.tertiary500,
          "&:hover": {
            backgroundColor: e.tertiary100,
            color: e.tertiary600,
            boxShadow: "none"
          },
          "&:focus": {
            backgroundColor: e.tertiary25,
            boxShadow: "inset 0px 0px 0px 2px " + e.tertiary400 + " !important",
            color: e.tertiary500
          },
          "&:active": {
            backgroundColor: e.tertiary100,
            border: "none",
            color: e.tertiary700,
            boxShadow: "none"
          },
          "&:disabled": {
            cursor: "unset",
            appearance: "none",
            backgroundColor: "transparent",
            border: "none",
            color: e.tertiary400
          }
        },
        success: {
          backgroundColor: "transparent",
          color: e.success500,
          "&:hover": {
            backgroundColor: e.success100,
            color: e.success600,
            boxShadow: "none"
          },
          "&:focus": {
            backgroundColor: e.success25,
            boxShadow: "inset 0px 0px 0px 2px " + e.success400 + " !important",
            color: e.success500
          },
          "&:active": {
            backgroundColor: e.success100,
            border: "none",
            color: e.success700,
            boxShadow: "none"
          },
          "&:disabled": {
            cursor: "unset",
            appearance: "none",
            backgroundColor: "transparent",
            border: "none",
            color: e.tertiary400
          }
        },
        warning: {
          backgroundColor: "transparent",
          color: e.warning500,
          "&:hover": {
            backgroundColor: e.warning100,
            color: e.warning600,
            boxShadow: "none"
          },
          "&:focus": {
            backgroundColor: e.warning25,
            boxShadow: "inset 0px 0px 0px 2px " + e.warning400 + " !important",
            color: e.warning500
          },
          "&:active": {
            backgroundColor: e.warning100,
            border: "none",
            color: e.warning700,
            boxShadow: "none"
          },
          "&:disabled": {
            cursor: "unset",
            appearance: "none",
            backgroundColor: "transparent",
            border: "none",
            color: e.tertiary400
          }
        },
        info: {
          backgroundColor: "transparent",
          color: e.information500,
          "&:hover": {
            backgroundColor: e.information100,
            color: e.information600,
            boxShadow: "none"
          },
          "&:focus": {
            backgroundColor: e.information25,
            boxShadow: "inset 0px 0px 0px 2px " + e.information400 + " !important",
            color: e.information500
          },
          "&:active": {
            backgroundColor: e.information100,
            border: "none",
            color: e.information700,
            boxShadow: "none"
          },
          "&:disabled": {
            cursor: "unset",
            appearance: "none",
            backgroundColor: "transparent",
            border: "none",
            color: e.tertiary400
          }
        },
        error: {
          backgroundColor: "transparent",
          color: e.error500,
          "&:hover": {
            backgroundColor: e.error100,
            color: e.error600,
            boxShadow: "none"
          },
          "&:focus": {
            backgroundColor: e.error25,
            boxShadow: "inset 0px 0px 0px 2px " + e.error400 + " !important",
            color: e.error500
          },
          "&:active": {
            backgroundColor: e.error100,
            border: "none",
            color: e.error700,
            boxShadow: "none"
          },
          "&:disabled": {
            cursor: "unset",
            appearance: "none",
            backgroundColor: "transparent",
            border: "none",
            color: e.tertiary400
          }
        }
      }
    };
  },
  m = function (e) {
    return {
      a: {
        color: e.anchorDefaultColor,
        disabled: {
          color: e.tertiary300,
          pointerEvents: "none"
        },
        "&:hover": {
          color: e.anchorHoverColor + " !important",
          textDecoration: "underline",
          outline: "none",
          cursor: "pointer"
        },
        "&:active": {
          color: e.anchorActiveColor + " !important",
          outline: "none !important",
          textDecoration: "underline !important"
        },
        "&:focus": {
          outline: "2px solid " + n.primary30 + " !important",
          borderRadius: "4px !important",
          textDecoration: "none !important"
        },
        "& .wrapper-anchor": {
          display: "flex",
          alignItems: "center"
        },
        "& .wrapper-icon-left-large": {
          display: "flex",
          width: "20px",
          height: "20px",
          alignItems: "center",
          marginRight: "5px"
        },
        "& .wrapper-icon-left-medium": {
          display: "flex",
          width: "16px",
          height: "16px",
          alignItems: "center",
          marginRight: "5px"
        },
        "& .wrapper-icon-left-small": {
          display: "flex",
          width: "12px",
          height: "12px",
          alignItems: "center",
          marginRight: "5px"
        },
        "& .wrapper-icon-right-large": {
          display: "flex",
          width: "20px",
          height: "20px",
          alignItems: "center",
          marginLeft: "5px"
        },
        "& .wrapper-icon-right-medium": {
          display: "flex",
          width: "16px",
          height: "16px",
          alignItems: "center",
          marginLeft: "5px"
        },
        "& .wrapper-icon-right-small": {
          display: "flex",
          width: "12px",
          height: "12px",
          alignItems: "center",
          marginLeft: "5px"
        },
        sm: p({
          color: e.anchorDefaultColor + " !important"
        }, t.caption.lg.bold, {
          display: "inline-flex",
          alignItems: "center"
        }),
        md: p({
          color: e.anchorDefaultColor
        }, t.body.sm.bold, {
          display: "inline-flex",
          alignItems: "center"
        }),
        lg: p({
          color: e.anchorDefaultColor
        }, t.body.lg.bold, {
          display: "inline-flex",
          alignItems: "center"
        })
      },
      background: {
        primary25: {
          background: "" + e.primary25
        },
        primary50: {
          background: "" + e.primary50
        },
        primary100: {
          background: "" + e.primary100
        },
        primary200: {
          background: "" + e.primary200
        },
        primary300: {
          background: "" + e.primary300
        },
        primary400: {
          background: "" + e.primary400
        },
        primary500: {
          background: "" + e.primary500
        },
        primary600: {
          background: "" + e.primary600
        },
        primary700: {
          background: "" + e.primary700
        },
        primary800: {
          background: "" + e.primary800
        },
        primary900: {
          background: "" + e.primary900
        },
        secondary25: {
          background: "" + e.secondary25
        },
        secondary50: {
          background: "" + e.secondary50
        },
        secondary100: {
          background: "" + e.secondary100
        },
        secondary200: {
          background: "" + e.secondary200
        },
        secondary300: {
          background: "" + e.secondary300
        },
        secondary400: {
          background: "" + e.secondary400
        },
        secondary500: {
          background: "" + e.secondary500
        },
        secondary600: {
          background: "" + e.secondary600
        },
        secondary700: {
          background: "" + e.secondary700
        },
        secondary800: {
          background: "" + e.secondary800
        },
        secondary900: {
          background: "" + e.secondary900
        },
        tertiary25: {
          background: "" + e.tertiary25
        },
        tertiary50: {
          background: "" + e.tertiary50
        },
        tertiary100: {
          background: "" + e.tertiary100
        },
        tertiary200: {
          background: "" + e.tertiary200
        },
        tertiary300: {
          background: "" + e.tertiary300
        },
        tertiary400: {
          background: "" + e.tertiary400
        },
        tertiary500: {
          background: "" + e.tertiary500
        },
        tertiary600: {
          background: "" + e.tertiary600
        },
        tertiary700: {
          background: "" + e.tertiary700
        },
        tertiary800: {
          background: "" + e.tertiary800
        },
        tertiary900: {
          background: "" + e.tertiary900
        },
        success25: {
          background: "" + e.success25
        },
        success50: {
          background: "" + e.success50
        },
        success100: {
          background: "" + e.success100
        },
        success200: {
          background: "" + e.success200
        },
        success300: {
          background: "" + e.success300
        },
        success400: {
          background: "" + e.success400
        },
        success500: {
          background: "" + e.success500
        },
        success600: {
          background: "" + e.success600
        },
        success700: {
          background: "" + e.success700
        },
        success800: {
          background: "" + e.success800
        },
        success900: {
          background: "" + e.success900
        },
        warning25: {
          background: "" + e.warning25
        },
        warning50: {
          background: "" + e.warning50
        },
        warning100: {
          background: "" + e.warning100
        },
        warning200: {
          background: "" + e.warning200
        },
        warning300: {
          background: "" + e.warning300
        },
        warning400: {
          background: "" + e.warning400
        },
        warning500: {
          background: "" + e.warning500
        },
        warning600: {
          background: "" + e.warning600
        },
        warning700: {
          background: "" + e.warning700
        },
        warning800: {
          background: "" + e.warning800
        },
        warning900: {
          background: "" + e.warning900
        },
        error25: {
          background: "" + e.error25
        },
        error50: {
          background: "" + e.error50
        },
        error100: {
          background: "" + e.error100
        },
        error200: {
          background: "" + e.error200
        },
        error300: {
          background: "" + e.error300
        },
        error400: {
          background: "" + e.error400
        },
        error500: {
          background: "" + e.error500
        },
        error600: {
          background: "" + e.error600
        },
        error700: {
          background: "" + e.error700
        },
        error800: {
          background: "" + e.error800
        },
        error900: {
          background: "" + e.error900
        },
        info25: {
          background: "" + e.information25
        },
        info50: {
          background: "" + e.information50
        },
        info100: {
          background: "" + e.information100
        },
        info200: {
          background: "" + e.information200
        },
        info300: {
          background: "" + e.information300
        },
        info400: {
          background: "" + e.information400
        },
        info500: {
          background: "" + e.information500
        },
        info600: {
          background: "" + e.information600
        },
        info700: {
          background: "" + e.information700
        },
        info800: {
          background: "" + e.information800
        },
        info900: {
          background: "" + e.information900
        }
      },
      text: {
        primary25: {
          color: "" + e.primary25
        },
        primary50: {
          color: "" + e.primary50
        },
        primary100: {
          color: "" + e.primary100
        },
        primary200: {
          color: "" + e.primary200
        },
        primary300: {
          color: "" + e.primary300
        },
        primary400: {
          color: "" + e.primary400
        },
        primary500: {
          color: "" + e.primary500
        },
        primary600: {
          color: "" + e.primary600
        },
        primary700: {
          color: "" + e.primary700
        },
        primary800: {
          color: "" + e.primary800
        },
        primary900: {
          color: "" + e.primary900
        },
        secondary25: {
          color: "" + e.secondary25
        },
        secondary50: {
          color: "" + e.secondary50
        },
        secondary100: {
          color: "" + e.secondary100
        },
        secondary200: {
          color: "" + e.secondary200
        },
        secondary300: {
          color: "" + e.secondary300
        },
        secondary400: {
          color: "" + e.secondary400
        },
        secondary500: {
          color: "" + e.secondary500
        },
        secondary600: {
          color: "" + e.secondary600
        },
        secondary700: {
          color: "" + e.secondary700
        },
        secondary800: {
          color: "" + e.secondary800
        },
        secondary900: {
          color: "" + e.secondary900
        },
        tertiary25: {
          color: "" + e.tertiary25
        },
        tertiary50: {
          color: "" + e.tertiary50
        },
        tertiary100: {
          color: "" + e.tertiary100
        },
        tertiary200: {
          color: "" + e.tertiary200
        },
        tertiary300: {
          color: "" + e.tertiary300
        },
        tertiary400: {
          color: "" + e.tertiary400
        },
        tertiary500: {
          color: "" + e.tertiary500
        },
        tertiary600: {
          color: "" + e.tertiary600
        },
        tertiary700: {
          color: "" + e.tertiary700
        },
        tertiary800: {
          color: "" + e.tertiary800
        },
        tertiary900: {
          color: "" + e.tertiary900
        },
        success25: {
          color: "" + e.success25
        },
        success50: {
          color: "" + e.success50
        },
        success100: {
          color: "" + e.success100
        },
        success200: {
          color: "" + e.success200
        },
        success300: {
          color: "" + e.success300
        },
        success400: {
          color: "" + e.success400
        },
        success500: {
          color: "" + e.success500
        },
        success600: {
          color: "" + e.success600
        },
        success700: {
          color: "" + e.success700
        },
        success800: {
          color: "" + e.success800
        },
        success900: {
          color: "" + e.success900
        },
        warning25: {
          color: "" + e.warning25
        },
        warning50: {
          color: "" + e.warning50
        },
        warning100: {
          color: "" + e.warning100
        },
        warning200: {
          color: "" + e.warning200
        },
        warning300: {
          color: "" + e.warning300
        },
        warning400: {
          color: "" + e.warning400
        },
        warning500: {
          color: "" + e.warning500
        },
        warning600: {
          color: "" + e.warning600
        },
        warning700: {
          color: "" + e.warning700
        },
        warning800: {
          color: "" + e.warning800
        },
        warning900: {
          color: "" + e.warning900
        },
        error25: {
          color: "" + e.error25
        },
        error50: {
          color: "" + e.error50
        },
        error100: {
          color: "" + e.error100
        },
        error200: {
          color: "" + e.error200
        },
        error300: {
          color: "" + e.error300
        },
        error400: {
          color: "" + e.error400
        },
        error500: {
          color: "" + e.error500
        },
        error600: {
          color: "" + e.error600
        },
        error700: {
          color: "" + e.error700
        },
        error800: {
          color: "" + e.error800
        },
        error900: {
          color: "" + e.error900
        },
        info25: {
          color: "" + e.information25
        },
        info50: {
          color: "" + e.information50
        },
        info100: {
          color: "" + e.information100
        },
        info200: {
          color: "" + e.information200
        },
        info300: {
          color: "" + e.information300
        },
        info400: {
          color: "" + e.information400
        },
        info500: {
          color: "" + e.information500
        },
        info600: {
          color: "" + e.information600
        },
        info700: {
          color: "" + e.information700
        },
        info800: {
          color: "" + e.information800
        },
        info900: {
          color: "" + e.information900
        }
      },
      elevation: {
        elevation0: {
          boxShadow: e.elevation0X + " " + e.elevation0Y + " " + e.elevation0Blur + " " + e.elevation0Spread + " " + e.elevation0Color
        },
        elevation1: {
          boxShadow: e.elevation1X + " " + e.elevation1Y + " " + e.elevation1Blur + " " + e.elevation1Spread + " " + e.elevation1Color
        },
        elevation2: {
          boxShadow: e.elevation21X + " " + e.elevation21Y + " " + e.elevation21Blur + " " + e.elevation21Spread + " " + e.elevation21Color + ", " + e.elevation20X + " " + e.elevation20Y + " " + e.elevation20Blur + " " + e.elevation20Spread + " " + e.elevation20Color
        },
        elevation3: {
          boxShadow: e.elevation31X + " " + e.elevation31Y + " " + e.elevation31Blur + " " + e.elevation31Spread + " " + e.elevation31Color + ", " + e.elevation30X + " " + e.elevation30Y + " " + e.elevation30Blur + " " + e.elevation30Spread + " " + e.elevation30Color
        },
        elevation4: {
          boxShadow: e.elevation41X + " " + e.elevation41Y + " " + e.elevation41Blur + " " + e.elevation41Spread + " " + e.elevation41Color + ", " + e.elevation40X + " " + e.elevation40Y + " " + e.elevation40Blur + " " + e.elevation40Spread + " " + e.elevation40Color
        },
        elevation5: {
          boxShadow: e.elevation51X + " " + e.elevation51Y + " " + e.elevation51Blur + " " + e.elevation51Spread + " " + e.elevation51Color + ", " + e.elevation50X + " " + e.elevation50Y + " " + e.elevation50Blur + " " + e.elevation50Spread + " " + e.elevation50Color
        }
      }
    };
  },
  x = function (e) {
    var o = m(e);
    return {
      base: {
        borderRadius: e.radius4,
        overflow: "hidden",
        transition: "box-shadow 0.15s ease-in-out 0s, transform 0.15s ease-in-out 0s"
      },
      flat: {
        backgroundColor: e.tertiary50
      },
      bordered: {
        backgroundColor: "#FFF",
        border: "1px solid " + e.tertiary200
      },
      shadow: p({
        backgroundColor: "#FFF"
      }, o.elevation.elevation5),
      hoverable: {
        "&:hover": p({
          transform: "translateY(-2px)"
        }, o.elevation.elevation5)
      },
      pressable: {
        cursor: "pointer",
        "&:active": {
          transform: "scale(97%)"
        }
      },
      header: {
        padding: e.spacing4 + " " + e.spacing4 + " 0"
      },
      body: {
        padding: e.spacing4
      },
      footer: {
        padding: "0 " + e.spacing4 + " " + e.spacing4
      }
    };
  },
  b = function (e) {
    return {
      primary50: {
        backgroundColor: e.primary50
      },
      primary500: {
        backgroundColor: e.primary500
      },
      tertiary100: {
        backgroundColor: e.tertiary100
      },
      imageTitle: {
        fontWeight: 700,
        color: e.tertiary800
      },
      imageDesc: {
        fontWeight: 400,
        color: e.tertiary500
      }
    };
  },
  u = {
    borderRadius: "24px",
    fontSize: "12px",
    display: "flex",
    alignItems: "center"
  },
  h = function (e) {
    return {
      ".chip--prefix:not(.icon-only)": {
        marginRight: e.spacing1
      },
      ".chip--postfix:not(.icon-only)": {
        marginLeft: e.spacing1
      }
    };
  },
  f = function (e) {
    return {
      display: "inline-block",
      ".chip": {
        "&--sm": p({}, u, {
          padding: "0 " + e.spacing1,
          height: "18px",
          lineHeight: "18px",
          "&.outline": {
            lineHeight: "16px"
          }
        }, h, {
          "svg, img": {
            width: "12px",
            height: "12px",
            position: "relative",
            top: "1.5px"
          }
        }),
        "&--md": p({}, u, {
          padding: "3px " + e.spacing2,
          height: "24px",
          lineHeight: "18px",
          "&.outline": {
            lineHeight: "16px"
          }
        }, h, {
          "svg, img": {
            width: "18px",
            height: "18px",
            position: "relative",
            top: "2px"
          }
        }),
        "&--lg": p({}, u, {
          padding: "" + e.spacing2,
          height: "32px",
          lineHeight: "15px",
          ".chip--prefix:not(.icon-only)": {
            marginRight: e.spacing2
          },
          ".chip--postfix:not(.icon-only)": {
            marginLeft: e.spacing2
          },
          "svg, img": {
            width: "24px",
            height: "24px",
            position: "relative",
            top: "1.5px"
          }
        })
      },
      '& input[type="checkbox"]': {
        display: "none",
        "&:not(disabled) ~ .chip": {
          cursor: "pointer"
        },
        "&:disabled ~ .chip": {
          cursor: "text"
        },
        "&:checked ~ .chip": {
          "&.soft, &.outline": {
            "&--primary, &--tertiary, &--error, &--warning, &--success, &--info": {
              color: "#FFF"
            },
            "&--primary": {
              background: e.primary500
            },
            "&--tertiary": {
              background: e.tertiary500
            },
            "&--error": {
              background: e.error500
            },
            "&--warning": {
              background: e.warning500
            },
            "&--success": {
              background: e.success500
            },
            "&--info": {
              background: e.information500
            }
          }
        }
      },
      ".soft": {
        "&--primary": {
          backgroundColor: e.primary100,
          color: e.primary500,
          "&:hover": {
            background: e.primary200
          }
        },
        "&--tertiary": {
          backgroundColor: e.tertiary100,
          color: e.tertiary500,
          "&:hover": {
            background: e.tertiary200
          }
        },
        "&--error": {
          backgroundColor: e.error100,
          color: e.error500,
          "&:hover": {
            background: e.error200
          }
        },
        "&--warning": {
          backgroundColor: e.warning100,
          color: e.warning500,
          "&:hover": {
            background: e.warning200
          }
        },
        "&--success": {
          backgroundColor: e.success100,
          color: e.success500,
          "&:hover": {
            background: e.success200
          }
        },
        "&--info": {
          backgroundColor: e.information100,
          color: e.information500,
          "&:hover": {
            background: e.information200
          }
        }
      },
      ".outline": {
        backgroundColor: "transparent",
        border: "1px solid",
        "&--primary": {
          borderColor: e.primary500,
          color: e.primary500,
          "&:hover": {
            background: e.primary100
          }
        },
        "&--tertiary": {
          borderColor: e.tertiary500,
          color: e.tertiary500,
          "&:hover": {
            background: e.tertiary100
          }
        },
        "&--error": {
          borderColor: e.error500,
          color: e.error500,
          "&:hover": {
            background: e.error100
          }
        },
        "&--info": {
          borderColor: e.information500,
          color: e.information500,
          "&:hover": {
            background: e.information100
          }
        },
        "&--success": {
          borderColor: e.success500,
          color: e.success500,
          "&:hover": {
            background: e.success100
          }
        },
        "&--warning": {
          borderColor: e.warning500,
          color: e.warning500,
          "&:hover": {
            background: e.warning100
          }
        }
      }
    };
  },
  y = function (e) {
    return {
      containerColors: {
        marginBottom: "20px"
      },
      wrappValueColors: p({}, t.caption.sm.semibold, {
        padding: "10px"
      }),
      primary25: {
        backgroundColor: "" + e.primary25,
        color: "" + e.primary900,
        padding: "1rem",
        width: "100%"
      },
      primary50: {
        backgroundColor: "" + e.primary50,
        color: "" + e.primary900,
        padding: "1rem",
        width: "100%"
      },
      primary100: {
        backgroundColor: "" + e.primary100,
        color: "" + e.primary900,
        padding: "1rem",
        width: "100%"
      },
      primary200: {
        backgroundColor: "" + e.primary200,
        color: "" + e.primary900,
        padding: "1rem",
        width: "100%"
      },
      primary300: {
        backgroundColor: "" + e.primary300,
        color: "" + e.primary900,
        padding: "1rem",
        width: "100%"
      },
      primary400: {
        backgroundColor: "" + e.primary400,
        color: "" + e.primary25,
        padding: "1rem",
        width: "100%"
      },
      primary500: {
        backgroundColor: "" + e.primary500,
        color: "" + e.primary25,
        padding: "1rem",
        width: "100%"
      },
      primary600: {
        backgroundColor: "" + e.primary600,
        color: "" + e.primary25,
        padding: "1rem",
        width: "100%"
      },
      primary700: {
        backgroundColor: "" + e.primary700,
        color: "" + e.primary25,
        padding: "1rem",
        width: "100%"
      },
      primary800: {
        backgroundColor: "" + e.primary800,
        color: "" + e.primary25,
        padding: "1rem",
        width: "100%"
      },
      primary900: {
        backgroundColor: "" + e.primary900,
        color: "" + e.primary25,
        padding: "1rem",
        width: "100%"
      },
      secondary25: {
        backgroundColor: "" + e.secondary25,
        color: "" + e.secondary900,
        padding: "1rem",
        width: "100%"
      },
      secondary50: {
        backgroundColor: "" + e.secondary50,
        color: "" + e.secondary900,
        padding: "1rem",
        width: "100%"
      },
      secondary100: {
        backgroundColor: "" + e.secondary100,
        color: "" + e.secondary900,
        padding: "1rem",
        width: "100%"
      },
      secondary200: {
        backgroundColor: "" + e.secondary200,
        color: "" + e.secondary900,
        padding: "1rem",
        width: "100%"
      },
      secondary300: {
        backgroundColor: "" + e.secondary300,
        color: "" + e.secondary900,
        padding: "1rem",
        width: "100%"
      },
      secondary400: {
        backgroundColor: "" + e.secondary400,
        color: "" + e.secondary25,
        padding: "1rem",
        width: "100%"
      },
      secondary500: {
        backgroundColor: "" + e.secondary500,
        color: "" + e.secondary25,
        padding: "1rem",
        width: "100%"
      },
      secondary600: {
        backgroundColor: "" + e.secondary600,
        color: "" + e.secondary25,
        padding: "1rem",
        width: "100%"
      },
      secondary700: {
        backgroundColor: "" + e.secondary700,
        color: "" + e.secondary25,
        padding: "1rem",
        width: "100%"
      },
      secondary800: {
        backgroundColor: "" + e.secondary800,
        color: "" + e.secondary25,
        padding: "1rem",
        width: "100%"
      },
      secondary900: {
        backgroundColor: "" + e.secondary900,
        color: "" + e.secondary25,
        padding: "1rem",
        width: "100%"
      },
      tertiary25: {
        backgroundColor: "" + e.tertiary25,
        color: "" + e.tertiary900,
        padding: "1rem",
        width: "100%"
      },
      tertiary50: {
        backgroundColor: "" + e.tertiary50,
        color: "" + e.tertiary900,
        padding: "1rem",
        width: "100%"
      },
      tertiary100: {
        backgroundColor: "" + e.tertiary100,
        color: "" + e.tertiary900,
        padding: "1rem",
        width: "100%"
      },
      tertiary200: {
        backgroundColor: "" + e.tertiary200,
        color: "" + e.tertiary900,
        padding: "1rem",
        width: "100%"
      },
      tertiary300: {
        backgroundColor: "" + e.tertiary300,
        color: "" + e.tertiary900,
        padding: "1rem",
        width: "100%"
      },
      tertiary400: {
        backgroundColor: "" + e.tertiary400,
        color: "" + e.tertiary25,
        padding: "1rem",
        width: "100%"
      },
      tertiary500: {
        backgroundColor: "" + e.tertiary500,
        color: "" + e.tertiary25,
        padding: "1rem",
        width: "100%"
      },
      tertiary600: {
        backgroundColor: "" + e.tertiary600,
        color: "" + e.tertiary25,
        padding: "1rem",
        width: "100%"
      },
      tertiary700: {
        backgroundColor: "" + e.tertiary700,
        color: "" + e.tertiary25,
        padding: "1rem",
        width: "100%"
      },
      tertiary800: {
        backgroundColor: "" + e.tertiary800,
        color: "" + e.tertiary25,
        padding: "1rem",
        width: "100%"
      },
      tertiary900: {
        backgroundColor: "" + e.tertiary900,
        color: "" + e.tertiary25,
        padding: "1rem",
        width: "100%"
      },
      success25: {
        backgroundColor: "" + e.success25,
        color: "" + e.success900,
        padding: "1rem",
        width: "100%"
      },
      success50: {
        backgroundColor: "" + e.success50,
        color: "" + e.success900,
        padding: "1rem",
        width: "100%"
      },
      success100: {
        backgroundColor: "" + e.success100,
        color: "" + e.success900,
        padding: "1rem",
        width: "100%"
      },
      success200: {
        backgroundColor: "" + e.success200,
        color: "" + e.success900,
        padding: "1rem",
        width: "100%"
      },
      success300: {
        backgroundColor: "" + e.success300,
        color: "" + e.success900,
        padding: "1rem",
        width: "100%"
      },
      success400: {
        backgroundColor: "" + e.success400,
        color: "" + e.success25,
        padding: "1rem",
        width: "100%"
      },
      success500: {
        backgroundColor: "" + e.success500,
        color: "" + e.success25,
        padding: "1rem",
        width: "100%"
      },
      success600: {
        backgroundColor: "" + e.success600,
        color: "" + e.success25,
        padding: "1rem",
        width: "100%"
      },
      success700: {
        backgroundColor: "" + e.success700,
        color: "" + e.success25,
        padding: "1rem",
        width: "100%"
      },
      success800: {
        backgroundColor: "" + e.success800,
        color: "" + e.success25,
        padding: "1rem",
        width: "100%"
      },
      success900: {
        backgroundColor: "" + e.success900,
        color: "" + e.success25,
        padding: "1rem",
        width: "100%"
      },
      warning25: {
        backgroundColor: "" + e.warning25,
        color: "" + e.warning900,
        padding: "1rem",
        width: "100%"
      },
      warning50: {
        backgroundColor: "" + e.warning50,
        color: "" + e.warning900,
        padding: "1rem",
        width: "100%"
      },
      warning100: {
        backgroundColor: "" + e.warning100,
        color: "" + e.warning900,
        padding: "1rem",
        width: "100%"
      },
      warning200: {
        backgroundColor: "" + e.warning200,
        color: "" + e.warning900,
        padding: "1rem",
        width: "100%"
      },
      warning300: {
        backgroundColor: "" + e.warning300,
        color: "" + e.warning900,
        padding: "1rem",
        width: "100%"
      },
      warning400: {
        backgroundColor: "" + e.warning400,
        color: "" + e.warning25,
        padding: "1rem",
        width: "100%"
      },
      warning500: {
        backgroundColor: "" + e.warning500,
        color: "" + e.warning25,
        padding: "1rem",
        width: "100%"
      },
      warning600: {
        backgroundColor: "" + e.warning600,
        color: "" + e.warning25,
        padding: "1rem",
        width: "100%"
      },
      warning700: {
        backgroundColor: "" + e.warning700,
        color: "" + e.warning25,
        padding: "1rem",
        width: "100%"
      },
      warning800: {
        backgroundColor: "" + e.warning800,
        color: "" + e.warning25,
        padding: "1rem",
        width: "100%"
      },
      warning900: {
        backgroundColor: "" + e.warning900,
        color: "" + e.warning25,
        padding: "1rem",
        width: "100%"
      },
      error25: {
        backgroundColor: "" + e.error25,
        color: "" + e.error900,
        padding: "1rem",
        width: "100%"
      },
      error50: {
        backgroundColor: "" + e.error50,
        color: "" + e.error900,
        padding: "1rem",
        width: "100%"
      },
      error100: {
        backgroundColor: "" + e.error100,
        color: "" + e.error900,
        padding: "1rem",
        width: "100%"
      },
      error200: {
        backgroundColor: "" + e.error200,
        color: "" + e.error900,
        padding: "1rem",
        width: "100%"
      },
      error300: {
        backgroundColor: "" + e.error300,
        color: "" + e.error900,
        padding: "1rem",
        width: "100%"
      },
      error400: {
        backgroundColor: "" + e.error400,
        color: "" + e.error25,
        padding: "1rem",
        width: "100%"
      },
      error500: {
        backgroundColor: "" + e.error500,
        color: "" + e.error25,
        padding: "1rem",
        width: "100%"
      },
      error600: {
        backgroundColor: "" + e.error600,
        color: "" + e.error25,
        padding: "1rem",
        width: "100%"
      },
      error700: {
        backgroundColor: "" + e.error700,
        color: "" + e.error25,
        padding: "1rem",
        width: "100%"
      },
      error800: {
        backgroundColor: "" + e.error800,
        color: "" + e.error25,
        padding: "1rem",
        width: "100%"
      },
      error900: {
        backgroundColor: "" + e.error900,
        color: "" + e.error25,
        padding: "1rem",
        width: "100%"
      },
      info25: {
        backgroundColor: "" + e.information25,
        color: "" + e.information900,
        padding: "1rem",
        width: "100%"
      },
      info50: {
        backgroundColor: "" + e.information50,
        color: "" + e.information900,
        padding: "1rem",
        width: "100%"
      },
      info100: {
        backgroundColor: "" + e.information100,
        color: "" + e.information900,
        padding: "1rem",
        width: "100%"
      },
      info200: {
        backgroundColor: "" + e.information200,
        color: "" + e.information900,
        padding: "1rem",
        width: "100%"
      },
      info300: {
        backgroundColor: "" + e.information300,
        color: "" + e.information900,
        padding: "1rem",
        width: "100%"
      },
      info400: {
        backgroundColor: "" + e.information400,
        color: "" + e.information25,
        padding: "1rem",
        width: "100%"
      },
      info500: {
        backgroundColor: "" + e.information500,
        color: "" + e.information25,
        padding: "1rem",
        width: "100%"
      },
      info600: {
        backgroundColor: "" + e.information600,
        color: "" + e.information25,
        padding: "1rem",
        width: "100%"
      },
      info700: {
        backgroundColor: "" + e.information700,
        color: "" + e.information25,
        padding: "1rem",
        width: "100%"
      },
      info800: {
        backgroundColor: "" + e.information800,
        color: "" + e.information25,
        padding: "1rem",
        width: "100%"
      },
      info900: {
        backgroundColor: "" + e.information900,
        color: "" + e.information25,
        padding: "1rem",
        width: "100%"
      }
    };
  },
  S = function (e) {
    return {
      primary25: e.primary25,
      primary50: e.primary50,
      primary100: e.primary100,
      primary200: e.primary200,
      primary300: e.primary300,
      primary400: e.primary400,
      primary500: e.primary500,
      primary600: e.primary600,
      primary700: e.primary700,
      primary800: e.primary800,
      primary900: e.primary900,
      secondary25: e.secondary25,
      secondary50: e.secondary50,
      secondary100: e.secondary100,
      secondary200: e.secondary200,
      secondary300: e.secondary300,
      secondary400: e.secondary400,
      secondary500: e.secondary500,
      secondary600: e.secondary600,
      secondary700: e.secondary700,
      secondary800: e.secondary800,
      secondary900: e.secondary900,
      tertiary25: e.tertiary25,
      tertiary50: e.tertiary50,
      tertiary100: e.tertiary100,
      tertiary200: e.tertiary200,
      tertiary300: e.tertiary300,
      tertiary400: e.tertiary400,
      tertiary500: e.tertiary500,
      tertiary600: e.tertiary600,
      tertiary700: e.tertiary700,
      tertiary800: e.tertiary800,
      tertiary900: e.tertiary900,
      error25: e.error25,
      error50: e.error50,
      error100: e.error100,
      error200: e.error200,
      error300: e.error300,
      error400: e.error400,
      error500: e.error500,
      error600: e.error600,
      error700: e.error700,
      error800: e.error800,
      error900: e.error900,
      warning25: e.warning25,
      warning50: e.warning50,
      warning100: e.warning100,
      warning200: e.warning200,
      warning300: e.warning300,
      warning400: e.warning400,
      warning500: e.warning500,
      warning600: e.warning600,
      warning700: e.warning700,
      warning800: e.warning800,
      warning900: e.warning900,
      success25: e.success25,
      success50: e.success50,
      success100: e.success100,
      success200: e.success200,
      success300: e.success300,
      success400: e.success400,
      success500: e.success500,
      success600: e.success600,
      success700: e.success700,
      success800: e.success800,
      success900: e.success900,
      information25: e.information25,
      information50: e.information50,
      information100: e.information100,
      information200: e.information200,
      information300: e.information300,
      information400: e.information400,
      information500: e.information500,
      information600: e.information600,
      information700: e.information700,
      information800: e.information800,
      information900: e.information900
    };
  },
  F = function (e) {
    return {
      search: {
        width: "200px !important"
      },
      table: {
        width: "100%"
      },
      tableCell: {
        borderBottom: "1px solid " + e.tertiary300,
        padding: 10
      },
      tableHead: {
        borderBottom: "1px solid " + e.tertiary300,
        borderTop: "1px solid " + e.tertiary300,
        padding: 10
      },
      tableRow: {
        textAlign: "left"
      }
    };
  },
  C = function (e) {
    return {
      switch: {
        md: {
          height: "22px",
          width: "40px",
          marginTop: "-2px"
        },
        sm: {
          marginTop: "2px",
          height: "17px",
          width: "28px",
          div: {
            height: "12px !important",
            width: "12px !important"
          }
        },
        background: "#C8CCD2 !important",
        "input:checked ~ &": {
          backgroundColor: e.primary500 + " !important"
        },
        ":disabled": {
          background: "#D9DDE3 !important"
        }
      },
      checkbox: {
        sizeBoxLarge: {
          fontSize: "16px",
          display: "flex",
          alignItems: "center",
          cursor: "pointer",
          width: "fit-content"
        },
        sizeBoxSmall: {
          fontSize: "14px",
          display: "flex",
          alignItems: "center",
          cursor: "pointer",
          width: "fit-content"
        },
        wrappLabel: {
          marginLeft: "10px"
        },
        "& .container-checkbox": {
          display: "flex",
          alignItems: "center"
        },
        check: {
          sm: {
            height: "20px !important",
            width: "20px !important"
          },
          "&:disabled": {
            "&:hover": {
              "&:after": {
                content: '""'
              },
              cursor: "pointer"
            },
            "&:checked": {
              "&:after": {
                content: '"\\2714"',
                color: e.checkboxDisabledBorder + " !important"
              }
            },
            backgroundColor: e.checkboxDisabledBackgroundColor + " !important",
            borderRadius: e.checkboxBorderRadius + " !important",
            border: "none !important"
          },
          height: "24px",
          width: "24px",
          appearance: "none",
          border: "2px solid " + e.checkboxDefaultBorder,
          borderRadius: e.checkboxBorderRadius,
          cursor: "pointer",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          "&:hover": {
            border: "2px solid " + e.checkboxActiveBorder,
            "&:after": {
              color: e.checkboxActiveDisableBackgroundColor,
              content: '"\\2714"'
            }
          },
          "&:checked": {
            backgroundColor: e.checkboxActiveBackgroundColor,
            border: "2px solid " + e.checkboxActiveBorder,
            transition: "all 0.15s ease-in-out 0s",
            "&:after": {
              content: '"\\2714"',
              color: e.checkboxDefaultBackgroundColor
            },
            "&:hover": {
              backgroundColor: e.checkboxActiveBorder,
              transition: "all 0.15s ease-in-out 0s"
            }
          }
        },
        indeterminate: {
          sm: {
            height: "20px !important",
            width: "20px !important"
          },
          "&:disabled": {
            "&:hover": {
              "&:after": {
                content: '""'
              },
              cursor: "pointer"
            },
            "&:checked": {
              "&:after": {
                content: '"\\2012"',
                color: e.checkboxDisabledBorder + " !important"
              }
            },
            backgroundColor: n.grayscale30 + " !important",
            borderRadius: e.checkboxBorderRadius + " !important",
            border: "none !important"
          },
          height: "24px",
          width: "24px",
          appearance: "none",
          border: "2px solid " + e.checkboxDefaultBorder,
          borderRadius: e.checkboxBorderRadius,
          cursor: "pointer",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          "&:hover": {
            border: "2px solid " + e.checkboxActiveBorder,
            "&:after": {
              color: e.checkboxActiveDisableBackgroundColor,
              content: '"\\2012"'
            }
          },
          "&:checked": {
            backgroundColor: e.checkboxActiveBackgroundColor,
            border: "2px solid " + e.checkboxActiveBorder,
            transition: "all 0.15s ease-in-out 0s",
            "&:after": {
              content: '"\\2012"',
              color: e.checkboxDefaultBackgroundColor
            },
            "&:hover": {
              backgroundColor: e.checkboxActiveBorder,
              transition: "all 0.15s ease-in-out 0s"
            }
          }
        }
      },
      input: {
        container: {
          position: "relative",
          display: "flex !important",
          flexDirection: "row",
          alignItems: "center !important",
          backgroundColor: "" + e.textFieldDefaultBackgroundColor,
          marginBottom: "30px",
          sm: {
            fontSize: "14px",
            lineHeight: "20px",
            ".wrap-icon-left": {
              width: "12px",
              height: "12px",
              marginLeft: "8px"
            },
            ".wrap-icon-right": {
              width: "12px",
              height: "12px",
              marginRight: "8px"
            },
            ".contain-prefix-left": {
              paddingLeft: "8px"
            },
            ".contain-prefix-right": {
              paddingRight: "8px"
            },
            ".limit-prefix-left": {
              marginLeft: "7px"
            },
            ".limit-prefix-right": {
              marginRight: "7px"
            }
          },
          md: {
            fontSize: "16px",
            lineHeight: "24px",
            ".wrap-icon-left": {
              width: "16px",
              height: "16px",
              marginLeft: "8px"
            },
            ".wrap-icon-right": {
              width: "16px",
              height: "16px",
              marginRight: "8px"
            },
            ".contain-prefix-left": {
              paddingLeft: "8px"
            },
            ".contain-prefix-right": {
              paddingRight: "8px"
            },
            ".limit-prefix-left": {
              marginLeft: "7px"
            },
            ".limit-prefix-right": {
              marginRight: "7px"
            }
          },
          lg: {
            fontSize: "18px",
            lineHeight: "28px",
            ".wrap-icon-left": {
              width: "20px",
              height: "20px",
              marginLeft: "16px"
            },
            ".wrap-icon-right": {
              width: "20px",
              height: "20px",
              marginRight: "16px"
            },
            ".contain-prefix-left": {
              paddingLeft: "16px"
            },
            ".contain-prefix-right": {
              paddingRight: "16px"
            },
            ".limit-prefix-left": {
              marginLeft: "15px"
            },
            ".limit-prefix-right": {
              marginRight: "15px"
            }
          }
        },
        containPrefLeft: {
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          pointerEvents: "none",
          zIndex: 3
        },
        wrapperPrefLeft: {
          color: "" + e.textFieldPrefixsufixTextColor,
          fontWeight: t.body.sm.semibold.fontWeight
        },
        limitPrefLeft: {
          height: "24px",
          borderRight: "1px solid " + e.textFieldPrefixsufixLineColor
        },
        wrappPrefLeftIconLeft: {
          display: "flex",
          alignItems: "center",
          width: "16px",
          height: "16px",
          marginLeft: "12px",
          zIndex: 2
        },
        wrappIconLeft: {
          position: "relative",
          zIndex: 2,
          display: "flex",
          alignItems: "center",
          width: "16px",
          height: "16px",
          color: e.tertiary900
        },
        wrappField: {
          position: "absolute",
          zIndex: 1,
          top: "0px",
          left: "0px",
          width: "100%",
          height: "100%",
          borderRadius: "" + e.textFieldBorderRadius,
          border: "1px solid " + e.textFieldDefaultOutlineColor,
          backgroundColor: e.textFieldDisableBackgroundColor + " !important",
          transition: "all 0.15s ease-in-out 0s"
        },
        wrappNormal: {
          position: "absolute",
          zIndex: 1,
          top: "0px",
          left: "0px",
          width: "100%",
          height: "100%",
          border: "1px solid " + e.textFieldDefaultOutlineColor,
          borderRadius: "" + e.textFieldBorderRadius,
          transition: "all 0.15s ease-in-out 0s"
        },
        wrappSuccess: {
          zIndex: 1,
          top: "0px",
          left: "0px",
          width: "100%",
          height: "100%",
          borderRadius: "" + e.textFieldBorderRadius,
          border: "1px solid " + e.textFieldSuccessOutlineColor,
          transition: "all 0.15s ease-in-out 0s",
          position: "absolute"
        },
        wrappError: {
          zIndex: 1,
          top: "0px",
          left: "0px",
          width: "100%",
          height: "100%",
          borderRadius: "" + e.textFieldBorderRadius,
          border: "1px solid " + e.textFieldErrorOutlineColor,
          transition: "all 0.15s ease-in-out 0s",
          position: "absolute"
        },
        wrappPrefRightIconRight: {
          display: "flex",
          alignItems: "center",
          width: "16px",
          height: "16px",
          zIndex: 2,
          marginRight: "12px"
        },
        wrappIconRight: {
          position: "relative",
          zIndex: 2,
          display: "flex",
          alignItems: "center",
          width: "16px",
          height: "16px",
          cursor: "pointer",
          color: e.tertiary900
        },
        containPrefRight: {
          textAlign: "center",
          display: "flex",
          alignItems: "center",
          zIndex: 3
        },
        limitPrefRight: {
          height: "24px",
          borderRight: "1px solid " + e.textFieldPrefixsufixLineColor
        },
        wrapperPrefRight: {
          color: "" + e.textFieldPrefixsufixTextColor,
          fontWeight: t.body.sm.semibold.fontWeight
        },
        wrappLabelField: p({
          justifyContent: "space-between",
          marginBottom: "5px",
          color: "" + e.textFieldDefaultLabelColor
        }, t.body.sm.semibold, {
          ".label-field-text": {
            gap: "4px"
          },
          ".label-field-help": {
            color: e.tertiary600,
            svg: {
              verticalAlign: "middle"
            }
          },
          ".label-field-optional": {
            color: e.tertiary500,
            fontSize: "14px",
            fontWeight: 400
          }
        }),
        wrapperCaption: {
          alignItems: "center",
          gap: "8px",
          marginTop: "8px",
          color: e.tertiary500,
          fontSize: "14px",
          lineHeight: "21px",
          ".container-textfield + &": {
            marginTop: "-22px"
          },
          ".container-textfield + & + .wrapper-field-caption": {
            marginTop: "8px"
          },
          error: {
            color: e.error500
          },
          success: {
            color: e.success500
          }
        },
        wrapperCaptionIcon: {
          display: "flex",
          alignItems: "center",
          "& svg": {
            width: "20px",
            height: "20px"
          }
        },
        "&:disabled": {
          zIndex: 2,
          border: 0,
          backgroundColor: "transparent !important"
        },
        normal: {
          "&::placeholder": {
            color: e.textFieldDefaultPlaceholderColor
          },
          "&:focus": {
            outline: "none"
          },
          "&:hover ~ .input-border": {
            outline: "none",
            border: "1px solid " + e.textFieldActiveOutlineColor + " !important",
            transition: "all 0.10s ease-in-out 0s"
          },
          "&:focus  ~ .input-border": {
            outline: "none",
            border: "1px solid " + e.textFieldActiveOutlineColor,
            boxShadow: "0px 0px 0px 2px " + e.textFieldActiveBorderColor + " !important",
            transition: "all 0.15s ease-in-out 0s"
          },
          "& .input-border": {
            paddingLeft: "30px !important"
          },
          border: "0",
          backgroundColor: "transparent",
          zIndex: "2"
        },
        success: {
          "&::placeholder": {
            color: e.textFieldDefaultPlaceholderColor
          },
          "&:focus": {
            outline: "none"
          },
          "&:hover ~ .input-border": {
            outline: "none",
            border: "1px solid " + e.textFieldActiveOutlineColor + " !important",
            transition: "all 0.10s ease-in-out 0s"
          },
          "&:focus ~ .input-border": {
            outline: "none",
            border: "1px solid " + e.textFieldActiveOutlineColor,
            boxShadow: "0px 0px 0px 2px " + e.textFieldActiveBorderColor + " !important",
            transition: "all 0.15s ease-in-out 0s"
          },
          zIndex: 2,
          border: "0",
          backgroundColor: "transparent"
        },
        error: {
          "&::placeholder": {
            color: e.textFieldDefaultPlaceholderColor
          },
          "&:focus": {
            outline: "none"
          },
          "&:hover  ~ .input-border": {
            outline: "none",
            border: "1px solid " + e.textFieldActiveOutlineColor + " !important",
            transition: "all 0.10s ease-in-out 0s"
          },
          "&:focus ~ .input-border": {
            border: "1px solid " + e.textFieldActiveOutlineColor,
            boxShadow: "0px 0px 0px 2px " + e.textFieldActiveBorderColor + " !important",
            transition: "all 0.15s ease-in-out 0s"
          },
          zIndex: 2,
          border: "0",
          backgroundColor: "transparent"
        },
        sm: {
          padding: "6px 8px"
        },
        md: {
          padding: "8px"
        },
        lg: {
          padding: "14px 16px"
        },
        "&:autofill": {
          backgroundColor: "transparent",
          backgroundClip: "text",
          boxShadow: "0 0 0 30px transparent inset",
          WebkitBoxShadow: "0 0 0 30px transparent inset",
          WebkitTextFillColor: "#1f1f1f",
          transition: "background-color 5000s ease-in-out 0s",
          filter: "none",
          "&:hover": {
            backgroundColor: "transparent",
            backgroundClip: "text",
            boxShadow: "0 0 0 30px transparent inset",
            WebkitBoxShadow: "0 0 0 30px transparent inset",
            WebkitTextFillColor: "#1f1f1f",
            transition: "background-color 5000s ease-in-out 0s",
            filter: "none"
          },
          "&:focus": {
            backgroundColor: "transparent",
            backgroundClip: "text",
            boxShadow: "0 0 0 30px transparent inset",
            WebkitBoxShadow: "0 0 0 30px transparent inset",
            WebkitTextFillColor: "#1f1f1f",
            transition: "background-color 5000s ease-in-out 0s",
            filter: "none"
          },
          "&:active": {
            backgroundColor: "transparent",
            backgroundClip: "text",
            boxShadow: "0 0 0 30px transparent inset",
            WebkitBoxShadow: "0 0 0 30px transparent inset",
            WebkitTextFillColor: "#1f1f1f",
            transition: "background-color 5000s ease-in-out 0s",
            filter: "none"
          }
        },
        "&:-webkit-autofill": {
          backgroundColor: "transparent",
          backgroundClip: "text",
          boxShadow: "0 0 0 30px transparent inset",
          WebkitBoxShadow: "0 0 0 30px transparent inset",
          WebkitTextFillColor: "#1f1f1f",
          transition: "background-color 5000s ease-in-out 0s",
          "&:hover": {
            backgroundColor: "transparent",
            backgroundClip: "text",
            boxShadow: "0 0 0 30px transparent inset",
            WebkitBoxShadow: "0 0 0 30px transparent inset",
            WebkitTextFillColor: "#1f1f1f",
            transition: "background-color 5000s ease-in-out 0s"
          },
          "&:focus": {
            backgroundColor: "transparent",
            backgroundClip: "text",
            boxShadow: "0 0 0 30px transparent inset",
            WebkitBoxShadow: "0 0 0 30px transparent inset",
            WebkitTextFillColor: "#1f1f1f",
            transition: "background-color 5000s ease-in-out 0s"
          },
          "&:active": {
            backgroundColor: "transparent",
            backgroundClip: "text",
            boxShadow: "0 0 0 30px transparent inset",
            WebkitBoxShadow: "0 0 0 30px transparent inset",
            WebkitTextFillColor: "#1f1f1f",
            transition: "background-color 5000s ease-in-out 0s"
          }
        }
      },
      textarea: {
        backgroundColor: "" + e.textFieldDefaultBackgroundColor,
        borderRadius: "" + e.textFieldBorderRadius,
        "&::placeholder": {
          color: "" + e.textFieldDefaultPlaceholderColor
        },
        ":disabled": {
          border: "1px solid " + e.textFieldDefaultOutlineColor + " !important",
          backgroundColor: e.textFieldDisableBackgroundColor + " !important",
          ":hover": {
            border: "1px solid " + e.textFieldDefaultOutlineColor + " !important",
            outline: "none",
            transition: "all 0.15s ease-in-out 0s"
          }
        },
        ":hover": {
          outline: "none",
          border: "1px solid " + e.textFieldActiveOutlineColor + " !important",
          transition: "all 0.15s ease-in-out 0s"
        },
        ":focus": {
          outline: "none",
          border: "1px solid " + e.textFieldActiveOutlineColor,
          boxShadow: "0px 0px 0px 2px " + e.textFieldActiveBorderColor
        },
        normal: {
          border: "1px solid " + e.textFieldDefaultOutlineColor,
          transition: "all 0.15s ease-in-out 0s"
        },
        success: {
          border: "1px solid " + e.textFieldSuccessOutlineColor,
          transition: "all 0.15s ease-in-out 0s"
        },
        error: {
          border: "1px solid " + e.textFieldErrorOutlineColor,
          transition: "all 0.15s ease-in-out 0s"
        }
      }
    };
  },
  w = function (e) {
    return p({
      borderBottom: "1px solid " + e.tertiary400,
      color: "#000",
      backgroundColor: e.tertiary200,
      padding: e.spacing3 + " " + e.spacing4
    }, t.body.sm.bold);
  },
  L = function (e) {
    return {
      nav: p({}, t.caption.lg.bold, {
        color: e.tertiary900,
        padding: e.spacing3,
        margin: e.spacing1,
        "&:hover": {
          background: "" + e.primary400,
          cursor: "pointer"
        },
        "&:active": {
          background: "" + e.primary400,
          borderRight: e.spacing1 + " solid " + e.primary500,
          cursor: "pointer"
        },
        svg: {
          height: "14px",
          width: "14px",
          marginRight: e.spacing3
        }
      }),
      primary: {
        bg: "" + e.primary500,
        color: "" + e.tertiary25
      },
      secondary: {
        bg: "" + e.secondary50,
        color: "" + e.tertiary900
      }
    };
  },
  k = function (e) {
    return {
      primary50: {
        backgroundColor: "" + e.primary50
      },
      primary500: {
        color: "" + e.primary500
      },
      tertiary800: {
        color: "" + e.tertiary800
      },
      flexWrapper: {
        display: "flex",
        flexDirection: "row"
      },
      leftWrapper: {
        width: "25%",
        borderRight: "1px solid " + e.primary100,
        padding: "0.625rem",
        height: 350,
        overflow: "auto",
        item: {
          display: "flex",
          padding: e.spacing2 + " " + e.spacing3,
          marginBottom: "0.625rem",
          cursor: "pointer",
          title: {
            fontWeight: 600,
            fontSize: "" + e.spacing4
          }
        }
      },
      rightWrapper: {
        width: "75%",
        height: 350,
        overflow: "auto",
        padding: e.spacing3 + " " + e.spacing5 + " " + e.spacing3 + " " + e.spacing8,
        layoutWrapper: {
          display: "flex",
          justifyContent: "space-around",
          flexWrap: "wrap",
          gap: "1.875rem"
        },
        item: {
          display: "flex",
          justifyContent: "flex-start",
          alignItems: "center",
          marginBottom: "" + e.spacing5,
          marginLeft: "0.625rem",
          title: {
            fontWeight: 700,
            fontSize: "" + e.spacing8
          },
          children: {
            layout: {
              flex: 1,
              marginBottom: "" + e.spacing8,
              title: {
                fontWeight: 700,
                fontSize: "1.125rem",
                marginBottom: "0.9375rem",
                marginLeft: "0.625rem"
              },
              desc: {
                color: e.tertiary800 + " !important",
                fontWeight: 600,
                padding: e.spacing2 + " " + e.spacing3,
                fontSize: "" + e.spacing4,
                "&:hover": {
                  display: "flex",
                  textDecoration: "none",
                  background: "" + e.primary50,
                  color: e.primary500 + " !important",
                  padding: e.spacing2 + " " + e.spacing3
                }
              }
            }
          }
        }
      }
    };
  },
  B = function (e) {
    return {
      ".modal": {
        opacity: 0,
        visibility: "hidden",
        position: "fixed",
        top: 0,
        right: 0,
        bottom: 0,
        left: 0,
        textAlign: "left",
        background: "rgba(0,0,0, .5)",
        transition: "opacity .25s ease",
        zIndex: 99999,
        "&__bg": {
          position: "absolute",
          top: 0,
          right: 0,
          bottom: 0,
          left: 0,
          cursor: "pointer"
        },
        "&-state": {
          display: "none",
          "&:checked + .modal": {
            opacity: 1,
            visibility: "visible",
            ".modal__inner": {
              top: "50%"
            }
          }
        },
        "&__inner": {
          transition: "top .25s ease",
          position: "relative",
          top: 0,
          left: "50%",
          width: "50%",
          transform: "translate(-50%, -50%)",
          height: "auto",
          maxHeight: "90%",
          maxWidth: "90%",
          overflow: "auto",
          background: "#FFF",
          borderRadius: "6px",
          padding: 0,
          "&_wrapper": {
            height: "100%"
          }
        },
        "&__title": {
          padding: e.spacing6 + " " + e.spacing11 + " " + e.spacing3 + " " + e.spacing6,
          span: {
            fontSize: "18px",
            fontWeight: 700,
            lineHeight: e.spacing7
          },
          svg: {
            marginRight: e.spacing3
          }
        },
        "&__content": {
          padding: e.spacing3 + " " + e.spacing6
        },
        "&__footer": {
          padding: e.spacing3 + " " + e.spacing6 + " " + e.spacing6,
          position: "relative",
          bottom: 0,
          width: "100%",
          "&.fixed": {
            position: "fixed"
          }
        },
        "&__close": {
          position: "absolute",
          right: e.spacing6,
          top: "30px",
          cursor: "pointer"
        }
      }
    };
  },
  H = function (e) {
    return {
      hideIn: {
        sm: {
          "@media screen and (max-width: 640px)": {
            display: "none"
          }
        },
        md: {
          "@media screen and (max-width: 768px)": {
            display: "none"
          }
        },
        lg: {
          "@media screen and (max-width: 1024px)": {
            display: "none"
          }
        },
        xl: {
          "@media screen and (max-width: 1280px)": {
            display: "none"
          }
        }
      },
      showIn: {
        sm: {
          display: "none",
          "@media screen and (max-width: 640px)": {
            display: "flex"
          }
        },
        md: {
          display: "none",
          "@media screen and (max-width: 768px)": {
            display: "flex"
          }
        },
        lg: {
          display: "none",
          "@media screen and (max-width: 1024px)": {
            display: "flex"
          }
        },
        xl: {
          display: "none",
          "@media screen and (max-width: 1280px)": {
            display: "flex"
          }
        }
      },
      navbarBrand: {
        display: "flex",
        justifyContent: "space-between",
        width: "100%",
        "@media screen and (max-width: 768px)": {
          alignItems: "center",
          height: "100%"
        }
      },
      navbarCollapse: {
        div: {
          p: e.spacing4,
          li: {
            fontSize: "1rem",
            fontWeight: "600",
            lineHeight: "1.5rem",
            listStyleType: "none"
          }
        },
        "@media screen and (max-width: 768px)": {
          borderTop: "2px solid " + e.tertiary200,
          background: "rgba(255, 255, 255, 0.95)",
          height: "100vh",
          left: 0,
          position: "absolute",
          width: "100%",
          top: e.spacing12,
          borderRadius: e.radius4
        }
      },
      navbarContent: {
        default: {
          display: "flex",
          alignItems: "center",
          listStyleType: "none",
          gap: e.spacing10,
          margin: 0,
          padding: 0,
          li: {
            fontWeight: "600",
            a: {
              "&:hover": {
                opacity: "0.8"
              }
            }
          }
        }
      },
      navbarItem: {
        active: {
          background: e.primary500,
          borderRadius: e.radius2,
          color: "#ffffff",
          fontWeight: "600",
          padding: e.spacing2
        }
      },
      mode: {
        light: {
          background: "#ffffff",
          color: e.tertiary800
        },
        dark: {
          background: "#000000",
          color: e.tertiary500
        }
      },
      variant: {
        floating: {
          borderRadius: e.radius4,
          marginTop: e.spacing4,
          marginLeft: e.spacing4,
          marginRight: e.spacing4,
          position: "sticky",
          left: 0,
          right: 0,
          top: e.spacing4,
          "@media screen and (max-width: 768px)": {
            p: "0px " + e.spacing4
          }
        },
        static: {
          position: "static",
          borderBottom: "1px solid " + e.tertiary300,
          "@media screen and (max-width: 768px)": {
            display: "block",
            p: "0px " + e.spacing4
          }
        },
        sticky: {
          position: "sticky",
          top: 0,
          borderBottom: "1px solid " + e.tertiary300,
          "@media screen and (max-width: 768px)": {
            display: "block",
            p: "0px " + e.spacing4
          }
        }
      }
    };
  },
  v = {
    lineHeight: "150%",
    display: "block"
  },
  z = p({}, v, {
    fontWeight: "600",
    fontSize: "16px",
    marginBottom: "8px"
  }),
  U = {
    lineHeight: 1,
    display: "flex",
    alignItems: "center"
  },
  I = p({}, v, {
    fontWeight: "400",
    fontSize: "14px",
    marginTop: "8px",
    display: "flex",
    alignItems: "center",
    svg: {
      height: "16px"
    }
  }),
  T = function (e, o, r) {
    return {
      borderRadius: "4px",
      boxShadow: "none",
      border: "1px solid " + e,
      "&:hover,&:active,&:focus": {
        borderColor: o,
        boxShadow: "0px 0px 0px 2px " + r
      }
    };
  },
  D = function (e) {
    return {
      borderRadius: "4px",
      color: e.tertiary800,
      "&:hover": {
        background: e.primary50
      }
    };
  },
  R = function (e) {
    return p({}, T(e.tertiary300, e.primary500, e.primary300));
  },
  W = function (e) {
    return p({}, T(e.error500, e.error500, e.error100));
  },
  P = function (e) {
    return p({}, T(e.success500, e.success500, e.success100));
  },
  _ = function (e) {
    return {
      label: {
        normal: p({}, z),
        error: p({}, z),
        success: p({}, z)
      },
      iconLeft: {
        sm: p({}, U, {
          paddingLeft: "6px",
          marginRight: "-6px",
          svg: {
            height: "16px",
            color: e.tertiary800
          }
        }),
        md: p({}, U, {
          paddingLeft: "8px",
          marginRight: "-4px",
          svg: {
            height: "20px",
            color: e.tertiary800
          }
        }),
        lg: p({}, U, {
          paddingLeft: "10px",
          marginRight: "-2px",
          svg: {
            height: "24px",
            color: e.tertiary800
          }
        })
      },
      core: {
        control: {
          sm: {
            normal: p({}, R(e), {
              minHeight: "32px"
            }),
            error: p({}, W(e), {
              minHeight: "32px"
            }),
            success: p({}, P(e), {
              minHeight: "32px"
            })
          },
          md: {
            normal: p({}, R(e), {
              minHeight: "40px"
            }),
            error: p({}, W(e), {
              minHeight: "40px"
            }),
            success: p({}, P(e), {
              minHeight: "40px"
            })
          },
          lg: {
            normal: p({}, R(e), {
              minHeight: "56px"
            }),
            error: p({}, W(e), {
              minHeight: "56px"
            }),
            success: p({}, P(e), {
              minHeight: "56px"
            })
          }
        },
        menu: {
          boxShadow: "0px 2px 10px rgba(0, 0, 0, 0.1), 0px 0px 2px rgba(0, 0, 0, 0.2)",
          padding: "0 4px",
          zIndex: 99999
        },
        option: {
          sm: p({}, D(e), {
            padding: "6px 10px",
            fontSize: "14px"
          }),
          md: p({}, D(e), {
            padding: "8px 10px",
            fontSize: "16px"
          }),
          lg: p({}, D(e), {
            padding: "8px 10px",
            fontSize: "18px"
          })
        },
        multiValue: {
          borderRadius: "24px",
          background: e.primary50
        },
        multiValueLabel: {
          padding: "2px 2px 2px 7px",
          color: e.primary500
        },
        multiValueRemove: {
          padding: "2px 4px 2px 2px",
          color: e.primary500
        },
        indicatorsContainer: {
          padding: 0
        },
        dropdownIndicator: {
          padding: "4px 8px"
        },
        placeholder: {
          sm: {
            fontSize: "14px",
            lineHeight: 1
          },
          md: {
            fontSize: "16px",
            lineHeight: 1
          },
          lg: {
            fontSize: "18px",
            lineHeight: 1
          }
        }
      },
      hint: p({}, I, {
        color: "" + e.tertiary600
      }),
      caption: {
        normal: p({}, I, {
          color: "" + e.tertiary600
        }),
        error: p({}, I, {
          color: "" + e.error500
        }),
        success: p({}, I, {
          color: "" + e.success500
        }),
        icon: {
          display: "flex",
          alignItems: "center",
          paddingRight: "4px"
        },
        text: {
          display: "flex",
          alignItems: "center",
          lineHeight: 1
        }
      }
    };
  },
  A = function (e) {
    return {
      padding: e.spacing2 + " 0 " + e.spacing11,
      width: "16rem",
      overflowY: "auto",
      ".sidebar-top-content": {
        marginBottom: e.spacing6
      },
      ".sidebar-menu-wrapper": {
        padding: 0,
        "& a": {
          position: "relative",
          "&:hover, &:focus, &.active": {
            background: e.primary50,
            borderLeft: "3px solid " + e.primary500
          }
        },
        "& .badgeMenu": {
          position: "absolute",
          right: "12px"
        }
      }
    };
  },
  N = function (e) {
    return {
      position: "fixed",
      top: 0,
      width: "280px",
      height: "auto",
      overflow: "hidden",
      zIndex: 99,
      textAlign: "left",
      left: 0,
      ".sidebarHeader, .sidebarBody, .sidebarFooter": {
        padding: e.spacing4
      },
      ".sidebarHeader": {
        borderBottom: "1px solid " + e.tertiary100
      },
      ".sidebarBody": {
        overflowX: "hidden",
        overflowY: "auto",
        maxHeight: "85vh"
      },
      ".sidebarFooter": {
        bottom: 0,
        position: "absolute",
        width: "100%",
        background: "white",
        borderTop: "1px solid " + e.tertiary100
      },
      "#sidebarMenu": {
        height: "100%",
        position: "fixed",
        left: 0,
        zIndex: 99,
        width: "280px",
        marginTop: 0,
        transform: "translateX(-280px)",
        transition: "transform 250ms ease-in-out",
        background: "white",
        boxShadow: "6px 6px 6px -2px " + e.tertiary100,
        ".menu-label:not(:hover), .menu-content": {
          backgroundColor: "unset"
        }
      },
      'input[type="checkbox"]': {
        "&:checked ~ ": {
          "#sidebarMenu": {
            transform: "translateX(0)"
          }
        }
      },
      "input[type=checkbox]": {
        transition: "all 0.3s",
        boxSizing: "border-box",
        display: "none",
        "&:checked ~": {
          ".sidebarIconToggle": {
            transform: "translateX(280px)",
            transition: "transform 250ms ease-in-out",
            ">.horizontal": {
              transition: "all 0.3s",
              boxSizing: "border-box",
              opacity: 0
            },
            ">.hamburger": {
              display: "none"
            },
            ">.close": {
              display: "block"
            }
          }
        }
      },
      ".sidebarIconToggle": {
        boxSizing: "border-box",
        cursor: "pointer",
        position: "fixed",
        zIndex: 999,
        height: "40px",
        width: "48px",
        boxShadow: "6px 6px 6px -2px " + e.tertiary100,
        background: "white",
        borderRadius: "0 5px 5px 0",
        top: "12px",
        padding: "10px",
        textAlign: "center",
        display: "flex",
        justifyContent: "center",
        border: "1px solid " + e.tertiary100,
        borderLeft: "none"
      },
      ".spinner": {
        transition: "all 0.3s",
        boxSizing: "border-box",
        position: "absolute",
        width: "100%",
        "&.close": {
          display: "none"
        }
      }
    };
  },
  E = function (e) {
    return {
      primary: {
        color: e.primary500
      },
      secondary: {
        color: e.secondary500
      }
    };
  },
  O = function (e) {
    return {
      success: {
        backgroundColor: e.success500,
        borderColor: e.success500
      },
      warning: {
        backgroundColor: e.warning500,
        borderColor: e.warning500
      },
      error: {
        backgroundColor: e.error500,
        borderColor: e.error500
      },
      stepItem: {
        width: "40px",
        height: "40px",
        border: "2px solid #ddd",
        borderRadius: "50%",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        position: "relative",
        margin: "0",
        fontSize: "20px",
        fontWeight: "bold"
      },
      stepItemActive: {
        backgroundColor: "#ddd",
        borderColor: "#000",
        color: "#000",
        boxShadow: "0 0 10px #ddd"
      },
      stepTitle: {
        fontWeight: "bold",
        mt: 1
      },
      stepDescription: {
        fontSize: "14px",
        color: "#A0A0A0"
      }
    };
  },
  j = function (e) {
    return {
      position: "relative",
      wrapper: {
        width: "100%",
        margin: e.spacing6 + " 0",
        textAlign: "left",
        paddingLeft: 0,
        paddingBottom: e.spacing4
      },
      horizontal: {
        display: "flex",
        overflowX: "auto"
      },
      vertical: {
        display: "block",
        overflowY: "auto",
        maxWidth: "220px",
        "& .tab-item": {
          display: "block !important",
          label: {
            whiteSpace: "break-spaces !important",
            "&:hover": {
              borderBottom: "none !important",
              borderRight: "4px solid " + e.primary500
            }
          },
          "& .tab-content": {
            top: "4px !important",
            left: "225px !important",
            width: "calc( 100% - 240px ) !important"
          },
          '[id^="legionTab_"]:checked + label': {
            borderRight: "4px solid " + e.primary500,
            borderBottom: "none !important",
            color: e.primary500
          }
        }
      },
      tabItem: {
        display: "flex",
        justifyContent: "flex-start",
        '& input[type="radio"]': {
          display: "none"
        },
        label: {
          display: "block",
          padding: e.spacing5,
          fontSize: "16px",
          lineHeight: e.spacing6,
          fontWeight: "600",
          background: "white",
          cursor: "pointer",
          position: "relative",
          top: "4px",
          transition: "all 0.2s ease-in-out",
          whiteSpace: "nowrap",
          color: e.tertiary700,
          "& .prefix": {
            marginRight: "6px",
            position: "relative",
            top: "1px"
          },
          "& .tab-badges": {
            marginLeft: "6px",
            background: "#E4EAF3",
            borderRadius: "8px",
            color: "#0077BC",
            fontSize: "14px",
            padding: "3px 6px"
          },
          "&:hover": {
            borderBottom: "4px solid " + e.primary500,
            background: e.primary25
          }
        },
        ".tab-content": {
          zIndex: 2,
          display: "none",
          overflow: "hidden",
          width: "100%",
          fontSize: "17px",
          lineHeight: e.spacing6,
          padding: e.spacing5,
          position: "absolute",
          top: "74px",
          left: 0,
          background: "white"
        },
        '[id^="legionTab_"]:checked + label': {
          borderBottom: "4px solid " + e.primary500,
          color: e.primary500
        },
        '[id^="legionTab"]:checked ~ [id^="legionTabContent"]': {
          display: "block"
        },
        '[id^="legionTab"]:disabled + label': {
          color: e.tertiary400,
          "&:hover": {
            background: "white",
            borderBottom: "none !important",
            borderRight: "none !important",
            cursor: "not-allowed"
          }
        }
      }
    };
  },
  X = function (e) {
    return p({
      borderBottom: "1px solid " + e.tertiary300,
      padding: e.spacing3 + " " + e.spacing4
    }, t.caption.lg.regular);
  },
  Y = function (e) {
    return {
      "&:nth-child(even)": {
        backgroundColor: "" + e.tertiary50
      }
    };
  },
  M = function (e) {
    return {
      default: {
        fontFamily: "Nunito Sans, sans-serif",
        color: e.tertiary800,
        lg_regular: p({}, t.body.lg.regular),
        lg_regular_respon: p({}, t.body.lg.regular, {
          "@media screen and (max-width: 400px)": {
            fontSize: "16px",
            lineHeight: "24px"
          }
        }),
        lg_semibold: p({}, t.body.lg.semibold),
        lg_semibold_respon: p({}, t.body.lg.semibold, {
          "@media screen and (max-width: 400px)": {
            fontSize: "16px",
            lineHeight: "24px"
          }
        }),
        lg_bold: p({}, t.body.lg.bold),
        lg_bold_respon: p({}, t.body.lg.bold, {
          "@media screen and (max-width: 400px)": {
            fontSize: "16px",
            lineHeight: "24px"
          }
        }),
        lg_italic: p({}, t.body.lg.italic),
        lg_italic_respon: p({}, t.body.lg.italic, {
          "@media screen and (max-width: 400px)": {
            fontSize: "16px",
            lineHeight: "24px"
          }
        }),
        lg_underline: p({}, t.body.lg.underline),
        lg_underline_respon: p({}, t.body.lg.underline, {
          "@media screen and (max-width: 400px)": {
            fontSize: "16px",
            lineHeight: "24px"
          }
        }),
        lg_underline_semibold: p({}, t.body.lg.underline_semibold),
        lg_underline_semibold_respon: p({}, t.body.lg.underline_semibold, {
          "@media screen and (max-width: 400px)": {
            fontSize: "16px",
            lineHeight: "24px"
          }
        }),
        lg_underline_bold: p({}, t.body.lg.underline_bold),
        lg_underline_bold_respon: p({}, t.body.lg.underline_bold, {
          "@media screen and (max-width: 400px)": {
            fontSize: "16px",
            lineHeight: "24px"
          }
        }),
        sm_regular: p({}, t.body.sm.regular),
        sm_regular_respon: p({}, t.body.sm.regular, {
          "@media screen and (max-width: 400px)": {
            fontSize: "14px",
            lineHeight: "21px"
          }
        }),
        sm_semibold: p({}, t.body.sm.semibold),
        sm_semibold_respon: p({}, t.body.sm.semibold, {
          "@media screen and (max-width: 400px)": {
            fontSize: "14px",
            lineHeight: "21px"
          }
        }),
        sm_bold: p({}, t.body.sm.bold),
        sm_bold_respon: p({}, t.body.sm.semibold, {
          "@media screen and (max-width: 400px)": {
            fontSize: "14px",
            lineHeight: "21px"
          }
        }),
        sm_italic: p({}, t.body.sm.italic),
        sm_italic_respon: p({}, t.body.sm.italic, {
          "@media screen and (max-width: 400px)": {
            fontSize: "14px",
            lineHeight: "21px"
          }
        }),
        sm_underline: p({}, t.body.sm.underline),
        sm_underline_respon: p({}, t.body.sm.underline, {
          "@media screen and (max-width: 400px)": {
            fontSize: "14px",
            lineHeight: "21px"
          }
        }),
        sm_underline_semibold: p({}, t.body.sm.underline_semibold),
        sm_underline_semibold_respon: p({}, t.body.sm.underline_semibold, {
          "@media screen and (max-width: 400px)": {
            fontSize: "14px",
            lineHeight: "21px"
          }
        }),
        sm_underline_bold: p({}, t.body.sm.underline_bold),
        sm_underline_bold_respon: p({}, t.body.sm.underline_bold, {
          "@media screen and (max-width: 400px)": {
            fontSize: "14px",
            lineHeight: "21px"
          }
        }),
        sizes: {
          lg_regular: p({}, t.caption.lg.regular),
          lg_regular_respon: p({}, t.caption.lg.regular, {
            "@media screen and (max-width: 400px)": {
              fontSize: "12px",
              lineHeight: "18px"
            }
          }),
          lg_semibold: p({}, t.caption.lg.semibold),
          lg_semibold_respon: p({}, t.caption.lg.semibold, {
            "@media screen and (max-width: 400px)": {
              fontSize: "12px",
              lineHeight: "18px"
            }
          }),
          lg_bold: p({}, t.caption.lg.bold),
          lg_bold_respon: p({}, t.caption.lg.bold, {
            "@media screen and (max-width: 400px)": {
              fontSize: "12px",
              lineHeight: "18px"
            }
          }),
          lg_italic: p({}, t.caption.lg.italic),
          lg_italic_respon: p({}, t.caption.lg.italic, {
            "@media screen and (max-width: 400px)": {
              fontSize: "12px",
              lineHeight: "18px"
            }
          }),
          lg_underline: p({}, t.caption.lg.underline),
          lg_underline_respon: p({}, t.caption.lg.underline, {
            "@media screen and (max-width: 400px)": {
              fontSize: "12px",
              lineHeight: "18px"
            }
          }),
          lg_underline_semibold: p({}, t.caption.lg.underline_semibold),
          lg_underline_semibold_respon: p({}, t.caption.lg.underline_semibold, {
            "@media screen and (max-width: 400px)": {
              fontSize: "12px",
              lineHeight: "18px"
            }
          }),
          lg_underline_bold: p({}, t.caption.lg.underline_bold),
          lg_underline_bold_respon: p({}, t.caption.lg.underline_bold, {
            "@media screen and (max-width: 400px)": {
              fontSize: "12px",
              lineHeight: "18px"
            }
          }),
          sm_regular: p({}, t.caption.sm.regular),
          sm_regular_respon: p({}, t.caption.sm.regular, {
            "@media screen and (max-width: 400px)": {
              fontSize: "10px",
              lineHeight: "18px"
            }
          }),
          sm_semibold: p({}, t.caption.sm.semibold),
          sm_semibold_respon: p({}, t.caption.sm.semibold, {
            "@media screen and (max-width: 400px)": {
              fontSize: "10px",
              lineHeight: "18px"
            }
          }),
          sm_bold: p({}, t.caption.sm.bold),
          sm_bold_respon: p({}, t.caption.sm.bold, {
            "@media screen and (max-width: 400px)": {
              fontSize: "10px",
              lineHeight: "18px"
            }
          }),
          sm_italic: p({}, t.caption.sm.italic),
          sm_italic_respon: p({}, t.caption.sm.italic, {
            "@media screen and (max-width: 400px)": {
              fontSize: "10px",
              lineHeight: "18px"
            }
          }),
          sm_underline: p({}, t.caption.sm.underline),
          sm_underline_respon: p({}, t.caption.sm.underline, {
            "@media screen and (max-width: 400px)": {
              fontSize: "10px",
              lineHeight: "18px"
            }
          }),
          sm_underline_semibold: p({}, t.caption.sm.underline_semibold),
          sm_underline_semibold_respon: p({}, t.caption.sm.underline_semibold, {
            "@media screen and (max-width: 400px)": {
              fontSize: "10px",
              lineHeight: "18px"
            }
          }),
          sm_underline_bold: p({}, t.caption.sm.underline_bold),
          sm_underline_bold_respon: p({}, t.caption.sm.underline_bold, {
            "@media screen and (max-width: 400px)": {
              fontSize: "10px",
              lineHeight: "18px"
            }
          })
        }
      },
      heading: {
        h1: p({}, t.heading.h1),
        h1Respon: p({}, t.heading.h1, {
          "@media screen and (max-width: 400px)": {
            fontSize: "34px",
            lineHeight: "48px",
            fontWeight: "700"
          }
        }),
        h2: p({}, t.heading.h2),
        h2Respon: p({}, t.heading.h2, {
          "@media screen and (max-width: 400px)": {
            fontSize: "28px",
            lineHeight: "42px",
            fontWeight: "700"
          }
        }),
        h3: p({}, t.heading.h3),
        h3Respon: p({}, t.heading.h3, {
          "@media screen and (max-width: 400px)": {
            fontSize: "24px",
            lineHeight: "36px",
            fontWeight: "700"
          }
        }),
        h4: p({}, t.heading.h4),
        h4Respon: p({}, t.heading.h4, {
          "@media screen and (max-width: 400px)": {
            fontSize: "22px",
            lineHeight: "32px",
            fontWeight: "700"
          }
        }),
        h5: p({}, t.heading.h5),
        h5Respon: p({}, t.heading.h5, {
          "@media screen and (max-width: 400px)": {
            fontSize: "20px",
            lineHeight: "28px",
            fontWeight: "700"
          }
        }),
        h6: p({}, t.heading.h6),
        h6Respon: p({}, t.heading.h6, {
          "@media screen and (max-width: 400px)": {
            fontSize: "18px",
            lineHeight: "26px",
            fontWeight: "700"
          }
        })
      }
    };
  },
  V = function (e) {
    return {
      position: "relative",
      display: "inline-block",
      "&:hover .wrapper-tooltip": {
        opacity: 1
      },
      wrapper: {
        width: "max-content",
        maxWidth: "50vw",
        fontWeight: 600,
        fontSize: "12px",
        lineHeight: "18xpx",
        color: "#fff",
        backgroundColor: e.tertiary800,
        padding: "12px",
        borderRadius: "8px",
        position: "absolute",
        zIndex: 1,
        opacity: 0,
        transition: "opacity 0.15s ease-in-out 0s",
        pointerEvents: "none",
        arrow: {
          width: "12px",
          height: "12px",
          backgroundColor: e.tertiary800,
          borderRadius: "1px",
          transform: "rotate(45deg)",
          position: "absolute",
          "top-start": {
            bottom: "-3px",
            left: "12px"
          },
          "top-end": {
            bottom: "-3px",
            right: "12px"
          },
          top: {
            bottom: "-3px",
            left: "50%",
            transform: "translateX(-50%) rotate(45deg)"
          },
          "bottom-start": {
            top: "-3px",
            left: "12px"
          },
          "bottom-end": {
            top: "-3px",
            right: "12px"
          },
          bottom: {
            top: "-3px",
            left: "50%",
            transform: "translateX(-50%) rotate(45deg)"
          },
          left: {
            right: "-3px",
            top: "50%",
            transform: "translateY(-50%) rotate(45deg)"
          },
          right: {
            left: "-3px",
            top: "50%",
            transform: "translateY(-50%) rotate(45deg)"
          }
        },
        "top-start": {
          bottom: "100%",
          marginBottom: "10px",
          left: "-12px"
        },
        "top-end": {
          bottom: "100%",
          marginBottom: "10px",
          right: "-12px"
        },
        top: {
          bottom: "100%",
          marginBottom: "10px",
          left: "50%",
          transform: "translateX(-50%)"
        },
        "bottom-start": {
          top: "100%",
          marginTop: "10px",
          left: "-12px"
        },
        "bottom-end": {
          top: "100%",
          marginTop: "10px",
          right: "-12px"
        },
        bottom: {
          top: "100%",
          marginTop: "10px",
          left: "50%",
          transform: "translateX(-50%)"
        },
        left: {
          right: "100%",
          marginRight: "10px",
          top: "50%",
          transform: "translateY(-50%)"
        },
        right: {
          left: "100%",
          marginLeft: "10px",
          top: "50%",
          transform: "translateY(-50%)"
        }
      }
    };
  },
  q = function (e) {
    return {
      accordion: d(e),
      alerts: c(e),
      badges: g(e),
      buttons: s(e),
      cards: x(e),
      carousel: b(e),
      Chip: f(e),
      colorscard: y(e),
      colors: S(e),
      dataTable: F(e),
      forms: C(e),
      headCell: w(e),
      layout: {
        container: {
          fontFamily: "Nunito Sans, sans-serif",
          ".container-login-center": (r = {}, r["@media (max-width:480px)"] = {
            ".container-side-right": {
              display: "none"
            }
          }, r.position = "relative", r.overflow = "hidden", r.height = "100vh", r[".form-side-center"] = (o = {}, o["@media (max-width:480px)"] = {
            height: "90vh",
            width: "90%"
          }, o.position = "absolute", o.backgroundColor = n.grayscale10, o.top = "50%", o.left = "50%", o.transform = "translate(-50%, -50%)", o.width = "50%", o.padding = "50px 50px 20px 50px", o.overflowY = "scroll", o.height = "70vh", o[".container-logo"] = {
            textAlign: "center",
            ".wrapper-logo": {
              width: "150px"
            }
          }, o[".wrapper-title"] = {
            color: n.secondary70,
            fontWeight: 700,
            fontSize: "36px",
            marginTop: i.spacing8,
            marginBottom: i.spacing3,
            textAlign: "center"
          }, o[".wrapper-desc"] = {
            color: n.grayscale50,
            lineHeight: "24px",
            fontSize: "16px",
            marginBottom: i.spacing6,
            textAlign: "center"
          }, o[".wrapper-remember"] = {
            display: "flex",
            justifyContent: "space-between",
            marginTop: i.spacing6,
            marginBottom: i.spacing6
          }, o[".wrapper-button"] = {
            width: "100%"
          }, o[".wrapper-or"] = {
            display: "flex",
            alignItems: "center",
            marginTop: i.spacing4,
            marginBottom: i.spacing4,
            ".wrapper-line": {
              width: "50%",
              borderBottom: "1px solid " + n.grayscale40
            },
            ".or": {
              marginLeft: "20px",
              marginRight: "20px"
            }
          }, o[".wrapper-register"] = {
            color: n.grayscale70,
            fontWeight: 600,
            fontSize: "16px",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            marginTop: i.spacing4,
            marginBottom: i.spacing10
          }, o[".wrapper-footer"] = {
            color: n.grayscale80,
            fontWeight: 600,
            fontSize: "14px",
            display: "flex",
            justifyContent: "center",
            fontFamily: "Nunito Sans, sans-serif"
          }, o), r[".container-side-right"] = {
            width: "100%",
            ".wrapper-background": {
              width: "100% !important",
              height: "100vh !important",
              objectFit: "cover"
            }
          }, r),
          ".container-login": (l = {}, l["@media (max-width:768px)"] = {
            ".container-side-right": {
              display: "none"
            }
          }, l.display = "flex", l.overflow = "hidden", l.height = "100vh", l[".form-side-right"] = (a = {}, a["@media (max-width:480px)"] = {
            padding: "20px",
            width: "100%"
          }, a.order = 1, a.width = "75%", a.padding = "50px 100px", a.overflowY = "scroll", a.height = "100vh", a.position = "relative", a[".wrapper-logo"] = {
            width: "150px"
          }, a[".wrapper-title"] = {
            color: n.secondary70,
            fontWeight: 700,
            fontSize: "36px",
            marginTop: i.spacing8,
            marginBottom: i.spacing3
          }, a[".wrapper-desc"] = {
            color: n.grayscale50,
            lineHeight: "24px",
            fontSize: "16px",
            marginBottom: i.spacing6
          }, a[".wrapper-title-email"] = {
            color: n.grayscale80,
            fontWeight: 600,
            fontSize: "16px"
          }, a[".wrapper-title-pass"] = {
            color: n.grayscale80,
            marginTop: i.spacing6,
            fontWeight: 600,
            fontSize: "16px"
          }, a[".wrapper-remember"] = {
            display: "flex",
            justifyContent: "space-between",
            marginTop: i.spacing6,
            marginBottom: i.spacing6
          }, a[".wrapper-button"] = {
            width: "100%"
          }, a[".wrapper-or"] = {
            display: "flex",
            alignItems: "center",
            marginTop: i.spacing4,
            marginBottom: i.spacing4,
            ".wrapper-line": {
              width: "50%",
              borderBottom: "1px solid " + n.grayscale40
            },
            ".or": {
              marginLeft: "20px",
              marginRight: "20px"
            }
          }, a[".wrapper-register"] = {
            color: n.grayscale70,
            fontWeight: 600,
            fontSize: "16px",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            marginTop: i.spacing4,
            marginBottom: i.spacing10
          }, a[".wrapper-footer"] = {
            color: n.grayscale80,
            fontWeight: 600,
            fontSize: "14px",
            display: "flex",
            justifyContent: "center",
            marginBottom: "70px",
            fontFamily: "Nunito Sans, sans-serif"
          }, a), l[".form-side-left"] = (t = {}, t["@media (max-width:480px)"] = {
            padding: "20px",
            width: "100%"
          }, t.width = "75%", t.padding = "50px 100px", t.overflowY = "scroll", t.height = "100vh", t.position = "relative", t[".wrapper-logo"] = {
            width: "150px"
          }, t[".wrapper-title"] = {
            color: n.secondary70,
            fontWeight: 700,
            fontSize: "36px",
            marginTop: i.spacing8,
            marginBottom: i.spacing3
          }, t[".wrapper-desc"] = {
            color: n.grayscale50,
            lineHeight: "24px",
            fontSize: "16px",
            marginBottom: i.spacing6
          }, t[".wrapper-title-email"] = {
            color: n.grayscale80,
            fontWeight: 600,
            fontSize: "16px"
          }, t[".wrapper-title-pass"] = {
            color: n.grayscale80,
            marginTop: i.spacing6,
            fontWeight: 600,
            fontSize: "16px"
          }, t[".wrapper-remember"] = {
            display: "flex",
            justifyContent: "space-between",
            marginTop: i.spacing6,
            marginBottom: i.spacing6
          }, t[".wrapper-button"] = {
            width: "100%"
          }, t[".wrapper-or"] = {
            display: "flex",
            alignItems: "center",
            marginTop: i.spacing4,
            marginBottom: i.spacing4,
            ".wrapper-line": {
              width: "50%",
              borderBottom: "1px solid " + n.grayscale40
            },
            ".or": {
              marginLeft: "20px",
              marginRight: "20px"
            }
          }, t[".wrapper-register"] = {
            color: n.grayscale70,
            fontWeight: 600,
            fontSize: "16px",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            marginTop: i.spacing4,
            marginBottom: i.spacing10
          }, t[".wrapper-footer"] = {
            color: n.grayscale80,
            fontWeight: 600,
            fontSize: "14px",
            display: "flex",
            justifyContent: "center",
            marginBottom: "70px",
            fontFamily: "Nunito Sans, sans-serif"
          }, t), l[".container-side-right"] = {
            width: "100%",
            ".wrapper-background": {
              width: "100% !important",
              height: "100vh !important",
              objectFit: "cover"
            }
          }, l)
        }
      },
      links: L(e),
      megamenu: k(e),
      Modal: B(e),
      navbar: H(e),
      select: _(e),
      sidebar: A(e),
      sidebarWrapper: N(e),
      spacers: p({}, i),
      stepper: O(e),
      spinner: E(e),
      styles: m(e),
      tabbar: j(e),
      table: {
        borderCollapse: "collapse !important",
        width: "100% !important"
      },
      tableRow: Y(e),
      tableCell: X(e),
      text: M(e),
      tooltip: V(e)
    };
    var o, r, a, t, l;
  },
  G = r.makeTheme(p({}, q(p({}, l, a)))),
  J = r.makeTheme(p({}, q(p({}, l, {
    primary25: "#eaf3f9",
    primary50: "#d6e7f4",
    primary100: "#c1dbee",
    primary200: "#accfe9",
    primary300: "#83b8de",
    primary400: "#59a0d3",
    primary500: "#3088c8",
    primary600: "#266da0",
    primary700: "#1d5278",
    primary800: "#133650",
    primary900: "#0a1b28",
    secondary25: "#fff8ec",
    secondary50: "#ffefd5",
    secondary100: "#fee7bf",
    secondary200: "#fdd692",
    secondary300: "#fdc464",
    secondary400: "#fcb337",
    secondary500: "#fba20a",
    secondary600: "#cf8508",
    secondary700: "#a36906",
    secondary800: "#774d05",
    secondary900: "#4b3003",
    tertiary25: "#f5f5f5",
    tertiary50: "#e6e6e6",
    tertiary100: "#d8d8d8",
    tertiary200: "#bcbcbc",
    tertiary300: "#9f9f9f",
    tertiary400: "#828282",
    tertiary500: "#666666",
    tertiary600: "#525252",
    tertiary700: "#3d3d3d",
    tertiary800: "#292929",
    tertiary900: "#141414",
    error25: "#fff6f4",
    error50: "#fce0dc",
    error100: "#f9cac3",
    error200: "#f39e92",
    error300: "#ec7262",
    error400: "#e64631",
    error500: "#e01a00",
    error600: "#b31500",
    error700: "#861000",
    error800: "#5a0a00",
    error900: "#2d0500",
    warning25: "#fffcf0",
    warning50: "#f3eed8",
    warning100: "#e7e0c1",
    warning200: "#cfc492",
    warning300: "#b6a862",
    warning400: "#9e8c33",
    warning500: "#867004",
    warning600: "#6b5a03",
    warning700: "#504302",
    warning800: "#362d02",
    warning900: "#1b1601",
    success25: "#f5fffa",
    success50: "#ddf4e9",
    success100: "#c5ead8",
    success200: "#95d4b6",
    success300: "#65bf93",
    success400: "#35a971",
    success500: "#05944f",
    success600: "#04763f",
    success700: "#03592f",
    success800: "#023b20",
    success900: "#011e10",
    information25: "#f2fafd",
    information50: "#ddeef4",
    information100: "#c8e2eb",
    information200: "#9dcbd9",
    information300: "#73b4c8",
    information400: "#489cb6",
    information500: "#1e84a4",
    information600: "#186a83",
    information700: "#125062",
    information800: "#0c3542",
    information900: "#061b21",
    buttonsLgPaddingLeftRight: "16px",
    buttonsLgPaddingTopBottom: "12px",
    buttonsSmPaddingLeftRight: "12px",
    buttonsSmPaddingTopBottom: "8px",
    buttonsPrimaryDefaultBackgroundColor: "#3088c8",
    buttonsPrimaryDefaultColor: "#ffffff",
    buttonsPrimaryHoverBackgroundColor: "#266da0",
    buttonsPrimaryHoverColor: "#ffffff",
    buttonsPrimaryActiveBackgroundColor: "#1d5278",
    buttonsPrimaryActiveColor: "#ffffff",
    buttonsPrimaryFocusBackgroundColors: "#3088c8",
    buttonsPrimaryFocusColor: "#ffffff",
    buttonsPrimaryFocusBorderColors: "#83b8de",
    buttonsPrimaryDisabledBackgroundColor: "#9f9f9f",
    buttonsPrimaryDisabledColor: "#666666",
    buttonsPrimaryBorderWidth: "0px",
    buttonsSecondaryDefaultBackgroundColor: "#d6e7f4",
    buttonsSecondaryDefaultColor: "#3088c8",
    buttonsSecondaryHoverBackgroundColor: "#c1dbee",
    buttonsSecondaryHoverColor: "#266da0",
    buttonsSecondaryActiveBackgroundColor: "#accfe9",
    buttonsSecondaryActiveColor: "#266da0",
    buttonsSecondaryFocusBackgroundColor: "#d6e7f4",
    buttonsSecondaryFocusColor: "#3088c8",
    buttonsSecondaryFocusBorderColors: "#3088c8",
    buttonsSecondaryDisabledBackgroundColor: "#e6e6e6",
    buttonsSecondaryDisabledColor: "#bcbcbc",
    buttonsSecondaryBorderWidth: "0px",
    buttonsBorderRadius: "16px",
    buttonsMdPaddingLeftRight: "12px",
    buttonsMdPaddingTopBottom: "8px",
    checkboxDefaultBackgroundColor: "#ffffff",
    checkboxDefaultBorder: "#bcbcbc",
    checkboxDisabledBackgroundColor: "#d8d8d8",
    checkboxDisabledBorder: "#9f9f9f",
    checkboxActiveDisableBackgroundColor: "#83b8de",
    checkboxActiveDisableColor: "#ffffff",
    checkboxActiveDisableBorder: "#3088c8",
    checkboxActiveBackgroundColor: "#3088c8",
    checkboxActiveColor: "#ffffff",
    checkboxActiveBorder: "#266da0",
    checkboxBorderRadius: "4px",
    checkboxBorderWidth: "1px",
    checkboxTextEnable: "#292929",
    checkboxTextDisable: "#828282",
    radioBorderWidth: "1px",
    radioDefaultBackgroundColor: "#ffffff",
    radioDefaultBorder: "#bcbcbc",
    radioDisableBackgroundColor: "#d8d8d8",
    radioDisableBorder: "#9f9f9f",
    radioActiveBackgroundColor: "#ffffff",
    radioActiveBorder: "#3088c8",
    radioActiveDisableBackgroundColor: "#ffffff",
    radioActiveDisableBorder: "#83b8de",
    radioTextEnable: "#292929",
    radioTextDisable: "#828282",
    anchorDefaultColor: "#3088c8",
    anchorHoverColor: "#266da0",
    anchorActiveColor: "#1d5278",
    anchorFocusColor: "#3088c8",
    anchorDisableColor: "#9f9f9f",
    switchActiveBackgroundColor: "#3088c8",
    switchActiveDisableBackgroundColor: "#accfe9",
    switchNonactiveBackgroundColor: "#9f9f9f",
    switchNonactiveDisableBackgroundColor: "#d8d8d8",
    textFieldDefaultBackgroundColor: "#ffffff",
    textFieldDefaultOutlineColor: "#bcbcbc",
    textFieldDefaultIconColor: "#292929",
    textFieldDefaultPlaceholderColor: "#828282",
    textFieldDefaultLabelColor: "#292929",
    textFieldActiveOutlineColor: "#3088c8",
    textFieldActivePlaceholderColor: "#292929",
    textFieldActiveBorderColor: "#accfe9",
    textFieldErrorOutlineColor: "#e01a00",
    textFieldSuccessOutlineColor: "#05944f",
    textFieldDisableBackgroundColor: "#d8d8d8",
    textFieldDisableOutlineColor: "#9f9f9f",
    textFieldDisablePlaceholderColor: "#828282",
    textFieldPrefixsufixLineColor: "#9f9f9f",
    textFieldPrefixsufixTextColor: "#666666",
    textFieldBorderRadius: "4px",
    textFieldPaddingLeftRight: "12px",
    textFieldPaddingTopBottom: "12px",
    badgePrimaryBackgroundColor: "#3088c8",
    badgePrimaryColor: "#ffffff",
    badgeSecondaryBackgroundColor: "#c1dbee",
    badgeSecondaryColor: "#3088c8",
    badgeErrorBackgroundColor: "#f9cac3",
    badgeErrorColor: "#e01a00",
    badgeInfoBackgroundColor: "#c8e2eb",
    badgeInfoColor: "#1e84a4",
    badgeSuccessBackgroundColor: "#c5ead8",
    badgeSuccessColor: "#05944f",
    badgeWarningBackgroundColor: "#e7e0c1",
    badgeWarningColor: "#867004",
    badgeBorderRadius: "8px",
    baseWhite: "#ffffff",
    baseBlack: "#000000",
    sidebarNavlinkDefaultColor: "#666666",
    sidebarNavlinkDefaultBackgroundColor: "#ffffff",
    sidebarNavlinkHoverBackgroundColor: "#d6e7f4",
    sidebarNavlinkHoverColor: "#3088c8",
    sidebarNavlinkActiveBackgroundColor: "#d6e7f4",
    sidebarNavlinkActiveColor: "#3088c8",
    fontFamiliesPrimary: "Nunito",
    fontFamiliesSecondary: "Nunito",
    lineHeights0: "48px",
    lineHeights1: "42px",
    lineHeights2: "36px",
    lineHeights3: "32px",
    lineHeights4: "28px",
    lineHeights5: "26px",
    lineHeights6: "24px",
    lineHeights7: "21px",
    lineHeights8: "18px",
    lineHeights9: "16px",
    lineHeights10: "72px",
    lineHeights11: "56px",
    lineHeights12: "44px",
    lineHeights13: "40px",
    lineHeights14: "56px",
    lineHeights15: "72px",
    fontWeightsBold: "Bold",
    fontWeightsRegular: "Regular",
    fontWeightsSemiBold: "SemiBold",
    fontWeightsItalic: "Italic",
    fontSize0: "10px",
    fontSize1: "12px",
    fontSize2: "14px",
    fontSize3: "16px",
    fontSize4: "18px",
    fontSize5: "20px",
    fontSize6: "22px",
    fontSize7: "24px",
    fontSize8: "28px",
    fontSize9: "30px",
    fontSize10: "34px",
    fontSize11: "36px",
    fontSize12: "48px",
    fontSize13: "60px",
    letterSpacing0: "0px",
    letterSpacing1: "-0.08px",
    paragraphSpacing0: "0px",
    paragraphSpacing1: "18px",
    textCaseNone: "none",
    textCaseUppercase: "uppercase",
    textDecorationNone: "none",
    textDecorationUnderline: "underline",
    headingHeading1FontFamily: "Nunito",
    headingHeading1FontWeight: "Bold",
    headingHeading1LineHeight: "72px",
    headingHeading1FontSize: "60px",
    headingHeading1LetterSpacing: "0px",
    headingHeading1ParagraphSpacing: "0px",
    headingHeading1TextCase: "none",
    headingHeading1TextDecoration: "none",
    headingHeading2FontFamily: "Nunito",
    headingHeading2FontWeight: "Bold",
    headingHeading2LineHeight: "56px",
    headingHeading2FontSize: "48px",
    headingHeading2LetterSpacing: "0px",
    headingHeading2ParagraphSpacing: "0px",
    headingHeading2TextCase: "none",
    headingHeading2TextDecoration: "none",
    headingHeading3FontFamily: "Nunito",
    headingHeading3FontWeight: "Bold",
    headingHeading3LineHeight: "44px",
    headingHeading3FontSize: "36px",
    headingHeading3LetterSpacing: "0px",
    headingHeading3ParagraphSpacing: "0px",
    headingHeading3TextCase: "none",
    headingHeading3TextDecoration: "none",
    headingHeading4FontFamily: "Nunito",
    headingHeading4FontWeight: "Bold",
    headingHeading4LineHeight: "40px",
    headingHeading4FontSize: "30px",
    headingHeading4LetterSpacing: "0px",
    headingHeading4ParagraphSpacing: "0px",
    headingHeading4TextCase: "none",
    headingHeading4TextDecoration: "none",
    headingHeading5FontFamily: "Nunito",
    headingHeading5FontWeight: "Bold",
    headingHeading5LineHeight: "36px",
    headingHeading5FontSize: "24px",
    headingHeading5LetterSpacing: "0px",
    headingHeading5ParagraphSpacing: "0px",
    headingHeading5TextCase: "none",
    headingHeading5TextDecoration: "none",
    headingHeading6FontFamily: "Nunito",
    headingHeading6FontWeight: "Bold",
    headingHeading6LineHeight: "28px",
    headingHeading6FontSize: "20px",
    headingHeading6LetterSpacing: "0px",
    headingHeading6ParagraphSpacing: "0px",
    headingHeading6TextCase: "uppercase",
    headingHeading6TextDecoration: "none",
    bodyLargeRegularFontFamily: "Nunito",
    bodyLargeRegularFontWeight: "Regular",
    bodyLargeRegularLineHeight: "28px",
    bodyLargeRegularFontSize: "18px",
    bodyLargeRegularLetterSpacing: "0px",
    bodyLargeRegularParagraphSpacing: "0px",
    bodyLargeRegularTextCase: "none",
    bodyLargeRegularTextDecoration: "none",
    bodyLargeSemiboldFontFamily: "Nunito",
    bodyLargeSemiboldFontWeight: "SemiBold",
    bodyLargeSemiboldLineHeight: "28px",
    bodyLargeSemiboldFontSize: "18px",
    bodyLargeSemiboldLetterSpacing: "0px",
    bodyLargeSemiboldParagraphSpacing: "0px",
    bodyLargeSemiboldTextCase: "none",
    bodyLargeSemiboldTextDecoration: "none",
    bodyLargeBoldFontFamily: "Nunito",
    bodyLargeBoldFontWeight: "Bold",
    bodyLargeBoldLineHeight: "28px",
    bodyLargeBoldFontSize: "18px",
    bodyLargeBoldLetterSpacing: "0px",
    bodyLargeBoldParagraphSpacing: "0px",
    bodyLargeBoldTextCase: "none",
    bodyLargeBoldTextDecoration: "none",
    bodyLargeItalicFontFamily: "Nunito",
    bodyLargeItalicFontWeight: "Italic",
    bodyLargeItalicLineHeight: "28px",
    bodyLargeItalicFontSize: "18px",
    bodyLargeItalicLetterSpacing: "0px",
    bodyLargeItalicParagraphSpacing: "0px",
    bodyLargeItalicTextCase: "none",
    bodyLargeItalicTextDecoration: "none",
    bodyLargeUnderlineFontFamily: "Nunito",
    bodyLargeUnderlineFontWeight: "Regular",
    bodyLargeUnderlineLineHeight: "28px",
    bodyLargeUnderlineFontSize: "18px",
    bodyLargeUnderlineLetterSpacing: "0px",
    bodyLargeUnderlineParagraphSpacing: "0px",
    bodyLargeUnderlineTextCase: "none",
    bodyLargeUnderlineTextDecoration: "underline",
    bodyLargeUnderlineSemiboldFontFamily: "Nunito",
    bodyLargeUnderlineSemiboldFontWeight: "SemiBold",
    bodyLargeUnderlineSemiboldLineHeight: "28px",
    bodyLargeUnderlineSemiboldFontSize: "18px",
    bodyLargeUnderlineSemiboldLetterSpacing: "0px",
    bodyLargeUnderlineSemiboldParagraphSpacing: "0px",
    bodyLargeUnderlineSemiboldTextCase: "none",
    bodyLargeUnderlineSemiboldTextDecoration: "underline",
    bodyLargeUnderlineBoldFontFamily: "Nunito",
    bodyLargeUnderlineBoldFontWeight: "Bold",
    bodyLargeUnderlineBoldLineHeight: "28px",
    bodyLargeUnderlineBoldFontSize: "18px",
    bodyLargeUnderlineBoldLetterSpacing: "0px",
    bodyLargeUnderlineBoldParagraphSpacing: "0px",
    bodyLargeUnderlineBoldTextCase: "none",
    bodyLargeUnderlineBoldTextDecoration: "underline",
    bodySmallRegularFontFamily: "Nunito",
    bodySmallRegularFontWeight: "Regular",
    bodySmallRegularLineHeight: "24px",
    bodySmallRegularFontSize: "16px",
    bodySmallRegularLetterSpacing: "0px",
    bodySmallRegularParagraphSpacing: "0px",
    bodySmallRegularTextCase: "none",
    bodySmallRegularTextDecoration: "none",
    bodySmallSemiboldFontFamily: "Nunito",
    bodySmallSemiboldFontWeight: "SemiBold",
    bodySmallSemiboldLineHeight: "24px",
    bodySmallSemiboldFontSize: "16px",
    bodySmallSemiboldLetterSpacing: "0px",
    bodySmallSemiboldParagraphSpacing: "0px",
    bodySmallSemiboldTextCase: "none",
    bodySmallSemiboldTextDecoration: "none",
    bodySmallBoldFontFamily: "Nunito",
    bodySmallBoldFontWeight: "Bold",
    bodySmallBoldLineHeight: "24px",
    bodySmallBoldFontSize: "16px",
    bodySmallBoldLetterSpacing: "0px",
    bodySmallBoldParagraphSpacing: "0px",
    bodySmallBoldTextCase: "none",
    bodySmallBoldTextDecoration: "none",
    bodySmallItalicFontFamily: "Nunito",
    bodySmallItalicFontWeight: "Italic",
    bodySmallItalicLineHeight: "24px",
    bodySmallItalicFontSize: "16px",
    bodySmallItalicLetterSpacing: "0px",
    bodySmallItalicParagraphSpacing: "0px",
    bodySmallItalicTextCase: "none",
    bodySmallItalicTextDecoration: "none",
    bodySmallUnderlineFontFamily: "Nunito",
    bodySmallUnderlineFontWeight: "Regular",
    bodySmallUnderlineLineHeight: "24px",
    bodySmallUnderlineFontSize: "16px",
    bodySmallUnderlineLetterSpacing: "0px",
    bodySmallUnderlineParagraphSpacing: "18px",
    bodySmallUnderlineTextCase: "none",
    bodySmallUnderlineTextDecoration: "underline",
    bodySmallUnderlineSemiboldFontFamily: "Nunito",
    bodySmallUnderlineSemiboldFontWeight: "SemiBold",
    bodySmallUnderlineSemiboldLineHeight: "24px",
    bodySmallUnderlineSemiboldFontSize: "16px",
    bodySmallUnderlineSemiboldLetterSpacing: "0px",
    bodySmallUnderlineSemiboldParagraphSpacing: "0px",
    bodySmallUnderlineSemiboldTextCase: "none",
    bodySmallUnderlineSemiboldTextDecoration: "underline",
    bodySmallUnderlineBoldFontFamily: "Nunito",
    bodySmallUnderlineBoldFontWeight: "Bold",
    bodySmallUnderlineBoldLineHeight: "24px",
    bodySmallUnderlineBoldFontSize: "16px",
    bodySmallUnderlineBoldLetterSpacing: "-0.08px",
    bodySmallUnderlineBoldParagraphSpacing: "0px",
    bodySmallUnderlineBoldTextCase: "none",
    bodySmallUnderlineBoldTextDecoration: "underline",
    captionLargeRegularFontFamily: "Nunito",
    captionLargeRegularFontWeight: "Regular",
    captionLargeRegularLineHeight: "21px",
    captionLargeRegularFontSize: "14px",
    captionLargeRegularLetterSpacing: "0px",
    captionLargeRegularParagraphSpacing: "0px",
    captionLargeRegularTextCase: "none",
    captionLargeRegularTextDecoration: "none",
    captionLargeSemiboldFontFamily: "Nunito",
    captionLargeSemiboldFontWeight: "SemiBold",
    captionLargeSemiboldLineHeight: "21px",
    captionLargeSemiboldFontSize: "14px",
    captionLargeSemiboldLetterSpacing: "0px",
    captionLargeSemiboldParagraphSpacing: "0px",
    captionLargeSemiboldTextCase: "none",
    captionLargeSemiboldTextDecoration: "none",
    captionLargeBoldFontFamily: "Nunito",
    captionLargeBoldFontWeight: "Bold",
    captionLargeBoldLineHeight: "21px",
    captionLargeBoldFontSize: "14px",
    captionLargeBoldLetterSpacing: "0px",
    captionLargeBoldParagraphSpacing: "0px",
    captionLargeBoldTextCase: "none",
    captionLargeBoldTextDecoration: "none",
    captionLargeItalicFontFamily: "Nunito",
    captionLargeItalicFontWeight: "Italic",
    captionLargeItalicLineHeight: "21px",
    captionLargeItalicFontSize: "14px",
    captionLargeItalicLetterSpacing: "0px",
    captionLargeItalicParagraphSpacing: "0px",
    captionLargeItalicTextCase: "none",
    captionLargeItalicTextDecoration: "none",
    captionLargeUnderlineFontFamily: "Nunito",
    captionLargeUnderlineFontWeight: "Regular",
    captionLargeUnderlineLineHeight: "21px",
    captionLargeUnderlineFontSize: "14px",
    captionLargeUnderlineLetterSpacing: "0px",
    captionLargeUnderlineParagraphSpacing: "0px",
    captionLargeUnderlineTextCase: "none",
    captionLargeUnderlineTextDecoration: "underline",
    captionLargeUnderlineSemiboldFontFamily: "Nunito",
    captionLargeUnderlineSemiboldFontWeight: "SemiBold",
    captionLargeUnderlineSemiboldLineHeight: "21px",
    captionLargeUnderlineSemiboldFontSize: "14px",
    captionLargeUnderlineSemiboldLetterSpacing: "0px",
    captionLargeUnderlineSemiboldParagraphSpacing: "0px",
    captionLargeUnderlineSemiboldTextCase: "none",
    captionLargeUnderlineSemiboldTextDecoration: "underline",
    captionLargeUnderlineBoldFontFamily: "Nunito",
    captionLargeUnderlineBoldFontWeight: "Bold",
    captionLargeUnderlineBoldLineHeight: "21px",
    captionLargeUnderlineBoldFontSize: "14px",
    captionLargeUnderlineBoldLetterSpacing: "0px",
    captionLargeUnderlineBoldParagraphSpacing: "0px",
    captionLargeUnderlineBoldTextCase: "none",
    captionLargeUnderlineBoldTextDecoration: "underline",
    captionSmallRegularFontFamily: "Nunito",
    captionSmallRegularFontWeight: "Regular",
    captionSmallRegularLineHeight: "18px",
    captionSmallRegularFontSize: "12px",
    captionSmallRegularLetterSpacing: "0px",
    captionSmallRegularParagraphSpacing: "0px",
    captionSmallRegularTextCase: "none",
    captionSmallRegularTextDecoration: "none",
    captionSmallSemiboldFontFamily: "Nunito",
    captionSmallSemiboldFontWeight: "SemiBold",
    captionSmallSemiboldLineHeight: "18px",
    captionSmallSemiboldFontSize: "12px",
    captionSmallSemiboldLetterSpacing: "0px",
    captionSmallSemiboldParagraphSpacing: "0px",
    captionSmallSemiboldTextCase: "none",
    captionSmallSemiboldTextDecoration: "none",
    captionSmallBoldFontFamily: "Nunito",
    captionSmallBoldFontWeight: "Bold",
    captionSmallBoldLineHeight: "18px",
    captionSmallBoldFontSize: "12px",
    captionSmallBoldLetterSpacing: "0px",
    captionSmallBoldParagraphSpacing: "0px",
    captionSmallBoldTextCase: "none",
    captionSmallBoldTextDecoration: "none",
    captionSmallItalicFontFamily: "Nunito",
    captionSmallItalicFontWeight: "Italic",
    captionSmallItalicLineHeight: "18px",
    captionSmallItalicFontSize: "12px",
    captionSmallItalicLetterSpacing: "0px",
    captionSmallItalicParagraphSpacing: "0px",
    captionSmallItalicTextCase: "none",
    captionSmallItalicTextDecoration: "none",
    captionSmallUnderlineFontFamily: "Nunito",
    captionSmallUnderlineFontWeight: "Regular",
    captionSmallUnderlineLineHeight: "18px",
    captionSmallUnderlineFontSize: "12px",
    captionSmallUnderlineLetterSpacing: "0px",
    captionSmallUnderlineParagraphSpacing: "18px",
    captionSmallUnderlineTextCase: "none",
    captionSmallUnderlineTextDecoration: "underline",
    captionSmallUnderlineSemiboldFontFamily: "Nunito",
    captionSmallUnderlineSemiboldFontWeight: "SemiBold",
    captionSmallUnderlineSemiboldLineHeight: "18px",
    captionSmallUnderlineSemiboldFontSize: "12px",
    captionSmallUnderlineSemiboldLetterSpacing: "0px",
    captionSmallUnderlineSemiboldParagraphSpacing: "0px",
    captionSmallUnderlineSemiboldTextCase: "none",
    captionSmallUnderlineSemiboldTextDecoration: "underline",
    captionSmallUnderlineBoldFontFamily: "Nunito",
    captionSmallUnderlineBoldFontWeight: "Bold",
    captionSmallUnderlineBoldLineHeight: "18px",
    captionSmallUnderlineBoldFontSize: "12px",
    captionSmallUnderlineBoldLetterSpacing: "-0.08px",
    captionSmallUnderlineBoldParagraphSpacing: "0px",
    captionSmallUnderlineBoldTextCase: "none",
    captionSmallUnderlineBoldTextDecoration: "underline"
  })))),
  K = r.makeTheme(p({}, q(p({}, l, {
    primary25: "#f5fafd",
    primary50: "#f0fbff",
    primary100: "#dcf1fa",
    primary200: "#abd8ed",
    primary300: "#7ebee0",
    primary400: "#55aed4",
    primary500: "#3088c8",
    primary600: "#1f66a1",
    primary700: "#11487a",
    primary800: "#082d54",
    primary900: "#04172e",
    secondary25: "#fffcf9",
    secondary50: "#fffaed",
    secondary100: "#ffebc4",
    secondary200: "#ffdb9c",
    secondary300: "#ffc773",
    secondary400: "#ffb14a",
    secondary500: "#f69421",
    secondary600: "#cf7011",
    secondary700: "#a85105",
    secondary800: "#823800",
    secondary900: "#5c2500",
    tertiary25: "#fafafa",
    tertiary50: "#f5f5f5",
    tertiary100: "#f0f0f0",
    tertiary200: "#ebebeb",
    tertiary300: "#e0e0e0",
    tertiary400: "#cacaca",
    tertiary500: "#9e9e9e",
    tertiary600: "#757575",
    tertiary700: "#666666",
    tertiary800: "#404040",
    tertiary900: "#333333",
    error25: "#fffafa",
    error50: "#fce4e1",
    error100: "#f9cdc8",
    error200: "#f3a096",
    error300: "#ec7464",
    error400: "#e64732",
    error500: "#666666",
    error600: "#525252",
    error700: "#3d3d3d",
    error800: "#292929",
    error900: "#141414",
    warning25: "#fffdfb",
    warning50: "#fef2e3",
    warning100: "#fde7cb",
    warning200: "#fcd19a",
    warning300: "#fabc6a",
    warning400: "#f9a639",
    warning500: "#f79009",
    warning600: "#c77407",
    warning700: "#975805",
    warning800: "#663b04",
    warning900: "#361f02",
    success25: "#fafffd",
    success50: "#e1f4ec",
    success100: "#c9eada",
    success200: "#98d4b7",
    success300: "#67bf95",
    success400: "#36a972",
    success500: "#05944f",
    success600: "#04763f",
    success700: "#03592f",
    success800: "#023b20",
    success900: "#011e10",
    information25: "#fafcff",
    information50: "#e6f1ff",
    information100: "#d1e6fe",
    information200: "#a8d1fd",
    information300: "#80bbfc",
    information400: "#57a6fb",
    information500: "#2e90fa",
    information600: "#257cd9",
    information700: "#1c67b8",
    information800: "#145397",
    information900: "#0b3e76",
    buttonsLgPaddingLeftRight: "16px",
    buttonsLgPaddingTopBottom: "12px",
    buttonsSmPaddingLeftRight: "12px",
    buttonsSmPaddingTopBottom: "8px",
    buttonsPrimaryDefaultBackgroundColor: "#f69421",
    buttonsPrimaryDefaultColor: "#ffffff",
    buttonsPrimaryHoverBackgroundColor: "#cf7011",
    buttonsPrimaryHoverColor: "#ffffff",
    buttonsPrimaryActiveBackgroundColor: "#a85105",
    buttonsPrimaryActiveColor: "#ffffff",
    buttonsPrimaryFocusBackgroundColors: "#f69421",
    buttonsPrimaryFocusColor: "#ffffff",
    buttonsPrimaryFocusBorderColors: "#ffdb9c",
    buttonsPrimaryDisabledBackgroundColor: "#cacaca",
    buttonsPrimaryDisabledColor: "#ffffff",
    buttonsPrimaryBorderWidth: "0px",
    buttonsSecondaryDefaultBackgroundColor: "#ffffff",
    buttonsSecondaryDefaultColor: "#f69421",
    buttonsSecondaryHoverBackgroundColor: "#fffaed",
    buttonsSecondaryHoverColor: "#cf7011",
    buttonsSecondaryActiveBackgroundColor: "#ffebc4",
    buttonsSecondaryActiveColor: "#a85105",
    buttonsSecondaryFocusBackgroundColor: "#ffffff",
    buttonsSecondaryFocusColor: "#f69421",
    buttonsSecondaryFocusBorderColors: "#ffebc4",
    buttonsSecondaryDisabledBackgroundColor: "#ffffff",
    buttonsSecondaryDisabledColor: "#cacaca",
    buttonsSecondaryBorderWidth: "0px",
    buttonsBorderRadius: "16px",
    buttonsMdPaddingLeftRight: "12px",
    buttonsMdPaddingTopBottom: "8px",
    checkboxDefaultBackgroundColor: "#ffffff",
    checkboxDefaultBorder: "#666666",
    checkboxDisabledBackgroundColor: "#f5f5f5",
    checkboxDisabledBorder: "#cacaca",
    checkboxActiveDisableBackgroundColor: "#7ebee0",
    checkboxActiveDisableColor: "#ffffff",
    checkboxActiveDisableBorder: "#abd8ed",
    checkboxActiveBackgroundColor: "#3088c8",
    checkboxActiveColor: "#ffffff",
    checkboxActiveBorder: "#abd8ed",
    checkboxBorderRadius: "4px",
    checkboxBorderWidth: "1px",
    checkboxTextEnable: "#404040",
    checkboxTextDisable: "#9e9e9e",
    radioBorderWidth: "1px",
    radioDefaultBackgroundColor: "#ffffff",
    radioDefaultBorder: "#666666",
    radioDisableBackgroundColor: "#f5f5f5",
    radioDisableBorder: "#cacaca",
    radioActiveBackgroundColor: "#ffffff",
    radioActiveBorder: "#3088c8",
    radioActiveDisableBackgroundColor: "#ffffff",
    radioActiveDisableBorder: "#7ebee0",
    radioTextEnable: "#404040",
    radioTextDisable: "#9e9e9e",
    anchorDefaultColor: "#3088c8",
    anchorHoverColor: "#1f66a1",
    anchorActiveColor: "#11487a",
    anchorFocusColor: "#3088c8",
    anchorDisableColor: "#9e9e9e",
    switchActiveBackgroundColor: "#3088c8",
    switchActiveDisableBackgroundColor: "#abd8ed",
    switchNonactiveBackgroundColor: "#cacaca",
    switchNonactiveDisableBackgroundColor: "#ebebeb",
    textFieldDefaultBackgroundColor: "#ffffff",
    textFieldDefaultOutlineColor: "#cacaca",
    textFieldDefaultIconColor: "#404040",
    textFieldDefaultPlaceholderColor: "#cacaca",
    textFieldDefaultLabelColor: "#666666",
    textFieldActiveOutlineColor: "#55aed4",
    textFieldActivePlaceholderColor: "#404040",
    textFieldActiveBorderColor: "#abd8ed",
    textFieldErrorOutlineColor: "#666666",
    textFieldSuccessOutlineColor: "#05944f",
    textFieldDisableBackgroundColor: "#f5f5f5",
    textFieldDisableOutlineColor: "#cacaca",
    textFieldDisablePlaceholderColor: "#404040",
    textFieldPrefixsufixLineColor: "#cacaca",
    textFieldPrefixsufixTextColor: "#404040",
    textFieldPrefixsufixBackgroundColor: "#f0fbff",
    textFieldBorderRadius: "4px",
    textFieldPaddingLeftRight: "12px",
    textFieldPaddingTopBottom: "12px",
    badgePrimaryBackgroundColor: "#3088c8",
    badgePrimaryColor: "#ffffff",
    badgeSecondaryBackgroundColor: "#f0fbff",
    badgeSecondaryColor: "#3088c8",
    badgeErrorBackgroundColor: "#fce4e1",
    badgeErrorColor: "#666666",
    badgeInfoBackgroundColor: "#e6f1ff",
    badgeInfoColor: "#2e90fa",
    badgeSuccessBackgroundColor: "#e1f4ec",
    badgeSuccessColor: "#05944f",
    badgeWarningBackgroundColor: "#fef2e3",
    badgeWarningColor: "#f79009",
    badgeBorderRadius: "8px",
    baseWhite: "#ffffff",
    baseBlack: "#000000",
    sidebarNavlinkDefaultColor: "#9e9e9e",
    sidebarNavlinkDefaultBackgroundColor: "#ffffff",
    sidebarNavlinkHoverBackgroundColor: "#f0fbff",
    sidebarNavlinkHoverColor: "#3088c8",
    sidebarNavlinkActiveBackgroundColor: "#f0fbff",
    sidebarNavlinkActiveColor: "#3088c8",
    fontFamiliesPrimary: "Nunito",
    fontFamiliesSecondary: "Nunito",
    lineHeights0: "48px",
    lineHeights1: "42px",
    lineHeights2: "36px",
    lineHeights3: "32px",
    lineHeights4: "28px",
    lineHeights5: "26px",
    lineHeights6: "24px",
    lineHeights7: "21px",
    lineHeights8: "18px",
    lineHeights9: "16px",
    lineHeights10: "72px",
    lineHeights11: "56px",
    lineHeights12: "44px",
    lineHeights13: "40px",
    lineHeights14: "56px",
    lineHeights15: "72px",
    fontWeightsBold: "Bold",
    fontWeightsRegular: "Regular",
    fontWeightsSemiBold: "SemiBold",
    fontWeightsItalic: "Italic",
    fontSize0: "10px",
    fontSize1: "12px",
    fontSize2: "14px",
    fontSize3: "16px",
    fontSize4: "18px",
    fontSize5: "20px",
    fontSize6: "22px",
    fontSize7: "24px",
    fontSize8: "28px",
    fontSize9: "30px",
    fontSize10: "34px",
    fontSize11: "36px",
    fontSize12: "48px",
    fontSize13: "60px",
    letterSpacing0: "0px",
    letterSpacing1: "-0.08px",
    paragraphSpacing0: "0px",
    paragraphSpacing1: "18px",
    textCaseNone: "none",
    textCaseUppercase: "uppercase",
    textDecorationNone: "none",
    textDecorationUnderline: "underline",
    headingHeading1FontFamily: "Nunito",
    headingHeading1FontWeight: "Bold",
    headingHeading1LineHeight: "72px",
    headingHeading1FontSize: "60px",
    headingHeading1LetterSpacing: "0px",
    headingHeading1ParagraphSpacing: "0px",
    headingHeading1TextCase: "none",
    headingHeading1TextDecoration: "none",
    headingHeading2FontFamily: "Nunito",
    headingHeading2FontWeight: "Bold",
    headingHeading2LineHeight: "56px",
    headingHeading2FontSize: "48px",
    headingHeading2LetterSpacing: "0px",
    headingHeading2ParagraphSpacing: "0px",
    headingHeading2TextCase: "none",
    headingHeading2TextDecoration: "none",
    headingHeading3FontFamily: "Nunito",
    headingHeading3FontWeight: "Bold",
    headingHeading3LineHeight: "44px",
    headingHeading3FontSize: "36px",
    headingHeading3LetterSpacing: "0px",
    headingHeading3ParagraphSpacing: "0px",
    headingHeading3TextCase: "none",
    headingHeading3TextDecoration: "none",
    headingHeading4FontFamily: "Nunito",
    headingHeading4FontWeight: "Bold",
    headingHeading4LineHeight: "40px",
    headingHeading4FontSize: "30px",
    headingHeading4LetterSpacing: "0px",
    headingHeading4ParagraphSpacing: "0px",
    headingHeading4TextCase: "none",
    headingHeading4TextDecoration: "none",
    headingHeading5FontFamily: "Nunito",
    headingHeading5FontWeight: "Bold",
    headingHeading5LineHeight: "36px",
    headingHeading5FontSize: "24px",
    headingHeading5LetterSpacing: "0px",
    headingHeading5ParagraphSpacing: "0px",
    headingHeading5TextCase: "none",
    headingHeading5TextDecoration: "none",
    headingHeading6FontFamily: "Nunito",
    headingHeading6FontWeight: "Bold",
    headingHeading6LineHeight: "28px",
    headingHeading6FontSize: "20px",
    headingHeading6LetterSpacing: "0px",
    headingHeading6ParagraphSpacing: "0px",
    headingHeading6TextCase: "uppercase",
    headingHeading6TextDecoration: "none",
    bodyLargeRegularFontFamily: "Nunito",
    bodyLargeRegularFontWeight: "Regular",
    bodyLargeRegularLineHeight: "28px",
    bodyLargeRegularFontSize: "18px",
    bodyLargeRegularLetterSpacing: "0px",
    bodyLargeRegularParagraphSpacing: "0px",
    bodyLargeRegularTextCase: "none",
    bodyLargeRegularTextDecoration: "none",
    bodyLargeSemiboldFontFamily: "Nunito",
    bodyLargeSemiboldFontWeight: "SemiBold",
    bodyLargeSemiboldLineHeight: "28px",
    bodyLargeSemiboldFontSize: "18px",
    bodyLargeSemiboldLetterSpacing: "0px",
    bodyLargeSemiboldParagraphSpacing: "0px",
    bodyLargeSemiboldTextCase: "none",
    bodyLargeSemiboldTextDecoration: "none",
    bodyLargeBoldFontFamily: "Nunito",
    bodyLargeBoldFontWeight: "Bold",
    bodyLargeBoldLineHeight: "28px",
    bodyLargeBoldFontSize: "18px",
    bodyLargeBoldLetterSpacing: "0px",
    bodyLargeBoldParagraphSpacing: "0px",
    bodyLargeBoldTextCase: "none",
    bodyLargeBoldTextDecoration: "none",
    bodyLargeItalicFontFamily: "Nunito",
    bodyLargeItalicFontWeight: "Italic",
    bodyLargeItalicLineHeight: "28px",
    bodyLargeItalicFontSize: "18px",
    bodyLargeItalicLetterSpacing: "0px",
    bodyLargeItalicParagraphSpacing: "0px",
    bodyLargeItalicTextCase: "none",
    bodyLargeItalicTextDecoration: "none",
    bodyLargeUnderlineFontFamily: "Nunito",
    bodyLargeUnderlineFontWeight: "Regular",
    bodyLargeUnderlineLineHeight: "28px",
    bodyLargeUnderlineFontSize: "18px",
    bodyLargeUnderlineLetterSpacing: "0px",
    bodyLargeUnderlineParagraphSpacing: "0px",
    bodyLargeUnderlineTextCase: "none",
    bodyLargeUnderlineTextDecoration: "underline",
    bodyLargeUnderlineSemiboldFontFamily: "Nunito",
    bodyLargeUnderlineSemiboldFontWeight: "SemiBold",
    bodyLargeUnderlineSemiboldLineHeight: "28px",
    bodyLargeUnderlineSemiboldFontSize: "18px",
    bodyLargeUnderlineSemiboldLetterSpacing: "0px",
    bodyLargeUnderlineSemiboldParagraphSpacing: "0px",
    bodyLargeUnderlineSemiboldTextCase: "none",
    bodyLargeUnderlineSemiboldTextDecoration: "underline",
    bodyLargeUnderlineBoldFontFamily: "Nunito",
    bodyLargeUnderlineBoldFontWeight: "Bold",
    bodyLargeUnderlineBoldLineHeight: "28px",
    bodyLargeUnderlineBoldFontSize: "18px",
    bodyLargeUnderlineBoldLetterSpacing: "0px",
    bodyLargeUnderlineBoldParagraphSpacing: "0px",
    bodyLargeUnderlineBoldTextCase: "none",
    bodyLargeUnderlineBoldTextDecoration: "underline",
    bodySmallRegularFontFamily: "Nunito",
    bodySmallRegularFontWeight: "Regular",
    bodySmallRegularLineHeight: "24px",
    bodySmallRegularFontSize: "16px",
    bodySmallRegularLetterSpacing: "0px",
    bodySmallRegularParagraphSpacing: "0px",
    bodySmallRegularTextCase: "none",
    bodySmallRegularTextDecoration: "none",
    bodySmallSemiboldFontFamily: "Nunito",
    bodySmallSemiboldFontWeight: "SemiBold",
    bodySmallSemiboldLineHeight: "24px",
    bodySmallSemiboldFontSize: "16px",
    bodySmallSemiboldLetterSpacing: "0px",
    bodySmallSemiboldParagraphSpacing: "0px",
    bodySmallSemiboldTextCase: "none",
    bodySmallSemiboldTextDecoration: "none",
    bodySmallBoldFontFamily: "Nunito",
    bodySmallBoldFontWeight: "Bold",
    bodySmallBoldLineHeight: "24px",
    bodySmallBoldFontSize: "16px",
    bodySmallBoldLetterSpacing: "0px",
    bodySmallBoldParagraphSpacing: "0px",
    bodySmallBoldTextCase: "none",
    bodySmallBoldTextDecoration: "none",
    bodySmallItalicFontFamily: "Nunito",
    bodySmallItalicFontWeight: "Italic",
    bodySmallItalicLineHeight: "24px",
    bodySmallItalicFontSize: "16px",
    bodySmallItalicLetterSpacing: "0px",
    bodySmallItalicParagraphSpacing: "0px",
    bodySmallItalicTextCase: "none",
    bodySmallItalicTextDecoration: "none",
    bodySmallUnderlineFontFamily: "Nunito",
    bodySmallUnderlineFontWeight: "Regular",
    bodySmallUnderlineLineHeight: "24px",
    bodySmallUnderlineFontSize: "16px",
    bodySmallUnderlineLetterSpacing: "0px",
    bodySmallUnderlineParagraphSpacing: "18px",
    bodySmallUnderlineTextCase: "none",
    bodySmallUnderlineTextDecoration: "underline",
    bodySmallUnderlineSemiboldFontFamily: "Nunito",
    bodySmallUnderlineSemiboldFontWeight: "SemiBold",
    bodySmallUnderlineSemiboldLineHeight: "24px",
    bodySmallUnderlineSemiboldFontSize: "16px",
    bodySmallUnderlineSemiboldLetterSpacing: "0px",
    bodySmallUnderlineSemiboldParagraphSpacing: "0px",
    bodySmallUnderlineSemiboldTextCase: "none",
    bodySmallUnderlineSemiboldTextDecoration: "underline",
    bodySmallUnderlineBoldFontFamily: "Nunito",
    bodySmallUnderlineBoldFontWeight: "Bold",
    bodySmallUnderlineBoldLineHeight: "24px",
    bodySmallUnderlineBoldFontSize: "16px",
    bodySmallUnderlineBoldLetterSpacing: "-0.08px",
    bodySmallUnderlineBoldParagraphSpacing: "0px",
    bodySmallUnderlineBoldTextCase: "none",
    bodySmallUnderlineBoldTextDecoration: "underline",
    captionLargeRegularFontFamily: "Nunito",
    captionLargeRegularFontWeight: "Regular",
    captionLargeRegularLineHeight: "21px",
    captionLargeRegularFontSize: "14px",
    captionLargeRegularLetterSpacing: "0px",
    captionLargeRegularParagraphSpacing: "0px",
    captionLargeRegularTextCase: "none",
    captionLargeRegularTextDecoration: "none",
    captionLargeSemiboldFontFamily: "Nunito",
    captionLargeSemiboldFontWeight: "SemiBold",
    captionLargeSemiboldLineHeight: "21px",
    captionLargeSemiboldFontSize: "14px",
    captionLargeSemiboldLetterSpacing: "0px",
    captionLargeSemiboldParagraphSpacing: "0px",
    captionLargeSemiboldTextCase: "none",
    captionLargeSemiboldTextDecoration: "none",
    captionLargeBoldFontFamily: "Nunito",
    captionLargeBoldFontWeight: "Bold",
    captionLargeBoldLineHeight: "21px",
    captionLargeBoldFontSize: "14px",
    captionLargeBoldLetterSpacing: "0px",
    captionLargeBoldParagraphSpacing: "0px",
    captionLargeBoldTextCase: "none",
    captionLargeBoldTextDecoration: "none",
    captionLargeItalicFontFamily: "Nunito",
    captionLargeItalicFontWeight: "Italic",
    captionLargeItalicLineHeight: "21px",
    captionLargeItalicFontSize: "14px",
    captionLargeItalicLetterSpacing: "0px",
    captionLargeItalicParagraphSpacing: "0px",
    captionLargeItalicTextCase: "none",
    captionLargeItalicTextDecoration: "none",
    captionLargeUnderlineFontFamily: "Nunito",
    captionLargeUnderlineFontWeight: "Regular",
    captionLargeUnderlineLineHeight: "21px",
    captionLargeUnderlineFontSize: "14px",
    captionLargeUnderlineLetterSpacing: "0px",
    captionLargeUnderlineParagraphSpacing: "0px",
    captionLargeUnderlineTextCase: "none",
    captionLargeUnderlineTextDecoration: "underline",
    captionLargeUnderlineSemiboldFontFamily: "Nunito",
    captionLargeUnderlineSemiboldFontWeight: "SemiBold",
    captionLargeUnderlineSemiboldLineHeight: "21px",
    captionLargeUnderlineSemiboldFontSize: "14px",
    captionLargeUnderlineSemiboldLetterSpacing: "0px",
    captionLargeUnderlineSemiboldParagraphSpacing: "0px",
    captionLargeUnderlineSemiboldTextCase: "none",
    captionLargeUnderlineSemiboldTextDecoration: "underline",
    captionLargeUnderlineBoldFontFamily: "Nunito",
    captionLargeUnderlineBoldFontWeight: "Bold",
    captionLargeUnderlineBoldLineHeight: "21px",
    captionLargeUnderlineBoldFontSize: "14px",
    captionLargeUnderlineBoldLetterSpacing: "0px",
    captionLargeUnderlineBoldParagraphSpacing: "0px",
    captionLargeUnderlineBoldTextCase: "none",
    captionLargeUnderlineBoldTextDecoration: "underline",
    captionSmallRegularFontFamily: "Nunito",
    captionSmallRegularFontWeight: "Regular",
    captionSmallRegularLineHeight: "18px",
    captionSmallRegularFontSize: "12px",
    captionSmallRegularLetterSpacing: "0px",
    captionSmallRegularParagraphSpacing: "0px",
    captionSmallRegularTextCase: "none",
    captionSmallRegularTextDecoration: "none",
    captionSmallSemiboldFontFamily: "Nunito",
    captionSmallSemiboldFontWeight: "SemiBold",
    captionSmallSemiboldLineHeight: "18px",
    captionSmallSemiboldFontSize: "12px",
    captionSmallSemiboldLetterSpacing: "0px",
    captionSmallSemiboldParagraphSpacing: "0px",
    captionSmallSemiboldTextCase: "none",
    captionSmallSemiboldTextDecoration: "none",
    captionSmallBoldFontFamily: "Nunito",
    captionSmallBoldFontWeight: "Bold",
    captionSmallBoldLineHeight: "18px",
    captionSmallBoldFontSize: "12px",
    captionSmallBoldLetterSpacing: "0px",
    captionSmallBoldParagraphSpacing: "0px",
    captionSmallBoldTextCase: "none",
    captionSmallBoldTextDecoration: "none",
    captionSmallItalicFontFamily: "Nunito",
    captionSmallItalicFontWeight: "Italic",
    captionSmallItalicLineHeight: "18px",
    captionSmallItalicFontSize: "12px",
    captionSmallItalicLetterSpacing: "0px",
    captionSmallItalicParagraphSpacing: "0px",
    captionSmallItalicTextCase: "none",
    captionSmallItalicTextDecoration: "none",
    captionSmallUnderlineFontFamily: "Nunito",
    captionSmallUnderlineFontWeight: "Regular",
    captionSmallUnderlineLineHeight: "18px",
    captionSmallUnderlineFontSize: "12px",
    captionSmallUnderlineLetterSpacing: "0px",
    captionSmallUnderlineParagraphSpacing: "18px",
    captionSmallUnderlineTextCase: "none",
    captionSmallUnderlineTextDecoration: "underline",
    captionSmallUnderlineSemiboldFontFamily: "Nunito",
    captionSmallUnderlineSemiboldFontWeight: "SemiBold",
    captionSmallUnderlineSemiboldLineHeight: "18px",
    captionSmallUnderlineSemiboldFontSize: "12px",
    captionSmallUnderlineSemiboldLetterSpacing: "0px",
    captionSmallUnderlineSemiboldParagraphSpacing: "0px",
    captionSmallUnderlineSemiboldTextCase: "none",
    captionSmallUnderlineSemiboldTextDecoration: "underline",
    captionSmallUnderlineBoldFontFamily: "Nunito",
    captionSmallUnderlineBoldFontWeight: "Bold",
    captionSmallUnderlineBoldLineHeight: "18px",
    captionSmallUnderlineBoldFontSize: "12px",
    captionSmallUnderlineBoldLetterSpacing: "-0.08px",
    captionSmallUnderlineBoldParagraphSpacing: "0px",
    captionSmallUnderlineBoldTextCase: "none",
    captionSmallUnderlineBoldTextDecoration: "underline"
  }))));
exports.merge = o, exports.color = n, exports.makeThemeStyles = q, exports.pjb = J, exports.pjm = G, exports.pjs = K, exports.spacer = i, exports.text = t, exports.tokens = l;